import {
  setBelongingInformation,
  isDisplayedAction,
} from "@vrf/fr-vrf-auth-core";
import {
  useGlobalNotifier,
  useMessage,
  useSpreadsheetState,
} from "@vrf/fr-vrf-core-react";
import { Cell } from "@vrf/fr-vrf-spreadsheet-core-templating/lib/core/cell";
import { FrVrfSpreadsheet } from "@vrf/fr-vrf-spreadsheet-react";
import JSZip from "jszip";
import {
  FrVrfAccordion,
  FrVrfAlertBar,
  FrVrfButton,
  FrVrfButtonPanel,
  FrVrfCheckboxesField,
  FrVrfDropdownField,
  FrVrfFooter,
  FrVrfFormPanel,
  FrVrfIcon,
  FrVrfPanel,
  FrVrfSingleLineInputField,
  FrVrfTextDisplayField,
} from "@vrf/fr-vrf-web-components-react";
import _ from "lodash";
import React, { useEffect, useMemo, useRef } from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { useNavigate, useLocation, createPath } from "react-router-dom";
import {
  CreateFileLayoutConfirmDialogState,
  EdhNotificationType,
  GeneralCode,
  INIT_CREATE_FILE_LAYOUT_CONFIRM_DIALOG_STATE,
  INIT_FILE_LIST,
  INIT_INTERFACE_DATA,
  Information,
  Interface,
  InterfaceListPageInitialState,
  InterfaceSpreadsheetRow,
  SpreadsheetState,
  basicColumnPresets,
  crossDomainColumnPresets,
  dstOutboundColumnPresets,
  srcInboundColumnPresets,
  usePageState,
  EditedCell,
  PendingPartialRestore,
  crossDomainColumnPresetsHasDstInbound,
} from ".";
import { useAppState } from "../../app";
import { ApplicationMessageScreen } from "../../messages";
import { useCreateFileLayout } from "../../services/data-kind";
import { GetFileLayout, useGetDataKind } from "../../services/data-kinds";
import {
  useGetDipByRegionList,
  useGetDips,
  useGetEdhNotificationTypeList,
  useGetEdhProtocolList,
  useGetEdiChainTypeList,
  useGetGeneralCodes,
} from "../../services/data-list";
import {
  Dlk,
  Dst,
  GetIFDefinitionsRequest,
  GetIfDefinitionCommonValidationResultResponse,
  GetIfList,
  GodResult,
  Inbound,
  InboundConverter,
  InboundMeta,
  InboundNotification,
  InboundPartner,
  InboundSecurity,
  InboundTransceiver,
  InterfaceDefinition,
  Outbound,
  OutboundConverter,
  OutboundMeta,
  OutboundNotification,
  OutboundPartner,
  OutboundSecurity,
  OutboundTransceiver,
  Piidb,
  Project,
  ProjectTcktInfo,
  Result,
  Slk,
  Src,
  UpdateIfList,
  UpdateIfListGod,
  useGetIFDefinitionHistory,
  useGetIFDefinitions,
  useGetIfDefinitionCommonValidationResult,
  useUpdateIfDefinitions,
  useUpdateIfDefinitionsGod,
  useGetIfDefinitionReviewDiffs,
} from "../../services/if-definitions";
import { useGetProjects } from "../../services/projects";
import { useGetActionItems } from "../../services/screen-authorization/ScreenAuthorizationHook";
import {
  BulkUpdateTicketsOfIfAttributeDesignReviewRequest,
  IfAttrDsgnRvw,
  IfAttrInptInfo,
  IfBulkUpdateTicketsRequest,
  useBulkUpdateTicketsOfIfAttributeDesignReview,
  useIfBulkUpdateTickets,
} from "../../services/tickets";
import { INIT_ERROR_RESULT_DATA } from "../../util";
import { ENV } from "@vrf/fr-vrf-core";
import { EvntGrp } from "../../util/general-code/enums/evnt-grp";
import {
  DeploymentDivisionCode,
  DeploymentRequestType,
  EnvTypeCd,
  IfCallerScreenType,
  IfItmPhysclName,
  IfReqCnclType,
  InDefCommonFlagType,
  InterfaceRequirementType,
  InterruptType,
  IoType,
  LayoutDerivationReasonType,
  PjtLnchType,
  PtnrType,
  ReferenceModeType,
  ReviewActionType,
  RoleCvrgType,
  SrcDstTypeCd,
  TcktStsTypeIfDsgn,
  TcktStsTypeIfPrdDplymnt,
  TcktStsTypeIfStgDplymnt,
  TcktStsTypePrjPrgrs,
  ValidationTypeCode,
} from "../../util/general-code/enums/general-codes";
import { Option, deduplicatedOptionList } from "../../util/option";
import {
  ErrorSpreadsheetResult,
  mappingErrorResponseToSpreadsheet,
} from "../../util/spreadsheet-data-utils";
import {
  CommentDialogContent,
  useCommentDialogState,
} from "../dialog/comment-dialog";
import {
  DeploymentRequestInfomationInputDialogContent,
  DeploymentRequestInfomationInputDialogInitialState,
  DeploymentRequestInfomationInputDialogState,
  CreateIfListMap,
  CreateIfList,
  useDeploymentRequestInfomationInputDialogState,
} from "../dialog/deployment-request-infomation-input-dialog";
import { SrcDstType } from "../interface-requirement-list";
import { createModal } from "../modal/createModal";
import {
  CD_TYPES,
  DSGN_W_FLW_STS_DESIGNING,
  DSGN_W_FLW_STS_DESIGN_REVIEW,
  DSGN_W_FLW_STS_CANCELLED,
  DPlYMNT_W_FLW_STS_CANCELLED,
  DPlYMNT_W_FLW_STS_DEPLOYED,
  PAGE_MODE,
  PAGE_TYPE,
  PJT_STS,
  VRF_PRIMARY_COLOR,
  VRF_SUCCESS_COLOR,
  createMessageList as createIFAlertMessageList,
  shpCsvHeader,
  REVIEW_DIFF_TARGET,
} from "./InterfaceListPageConstant";
import { GetPartnersRequest, useGetPartners } from "../../services/partners";
import { UpdateTicketResponse } from "../../services/ticket";
import { getReviewDiffCell } from "../../util/diff-util";
import { formatInterfaceListDiffForDisplay } from "../../util/interface-list-diff-display-util";
import {
  DiffTooltip,
  type DiffTooltipDetail,
} from "../../componentns/diff/DiffTooltip";
import { useHoverDiffTooltip } from "../../services/if-definitions/get-if-definition-review-diffs/use-hover-diff-tooltip";
import { DiffDropdownField } from "../../componentns/diff/DiffDropdownField";
import {
  useReviewDiff,
  type ReviewDiffStateUpdater,
} from "../../services/if-definitions/get-if-definition-review-diffs/use-review-diff";
import { SelectedRowErrorPanel } from "../../componentns/interface-list/SelectedRowErrorPanel";
import { createErrorPanelMessages } from "../../util/interface-list-error-message-util";

export const InterfaceListPageContent = () => {
  const [getIFDefinitionsResponse, sendGetIFDefinitionsRequest] =
    useGetIFDefinitions();
  const [getIFDefinitionHistoryResponse, sendGetIFDefinitionHistoryRequest] =
    useGetIFDefinitionHistory();
  const [getUpdateIfDefinitionsResponse, sendUpdateIfDefinitionsRequest] =
    useUpdateIfDefinitions();
  const [getUpdateIfDefinitionsGodResponse, sendUpdateIfDefinitionsGodRequest] =
    useUpdateIfDefinitionsGod();
  const [
    getUpdateIfDefinitionsReviewResponse,
    sendUpdateIfDefinitionsReviewRequest,
  ] = useUpdateIfDefinitions();
  const [getIfBulkUpdateTicketsResponse, sendIfBulkUpdateTicketsRequest] =
    useIfBulkUpdateTickets();
  const [
    getIfBulkUpdateTicketsReEnterAttributesResponse,
    sendIfBulkUpdateTicketsReEnterAttributesRequest,
  ] = useIfBulkUpdateTickets();
  const [getGeneralCodesResponse, sendGeneralCodesRequest] =
    useGetGeneralCodes();
  const [
    getEdhNotificationTypeListResponse,
    sendEdhNotificationTypeListRequest,
  ] = useGetEdhNotificationTypeList();
  const [getCreateFileLayoutResponse, sendCreateFileLayoutRequest] =
    useCreateFileLayout();
  const [getDataKindResponse, sendGetDataKindRequest] = useGetDataKind();
  const [
    getBulkUpdateTicketsOfIfAttributeDesignReviewResponse,
    sendBulkUpdateTicketsOfIfAttributeDesignReviewRequest,
  ] = useBulkUpdateTicketsOfIfAttributeDesignReview();
  const [getProjectsResponse, sendGetProjectsRequest] = useGetProjects();
  const [
    getIfDefinitionCommonValidationResultResponse,
    getIfDefinitionCommonValidationResultRequest,
  ] = useGetIfDefinitionCommonValidationResult();
  const [
    getIfDefinitionGodValidationResultResponse,
    getIfDefinitionGodValidationResultRequest,
  ] = useGetIfDefinitionCommonValidationResult();
  const [
    getIfDefinitionReviewDiffsResponse,
    sendGetIfDefinitionReviewDiffsRequest,
  ] = useGetIfDefinitionReviewDiffs();

  const [getDipByRegionListResponse, sendGetDipByRegionListRequest] =
    useGetDipByRegionList();
  const [getDipListResponse, sendGetDipListRequest] = useGetDips();
  const [getEdhProtocolListResponse, sendGetEdhProtocolListRequest] =
    useGetEdhProtocolList();
  const [getGodEdhProtocolListResponse, sendGetGodEdhProtocolListRequest] =
    useGetEdhProtocolList();
  const [getEdiChainTypeListResponse, sendGetEdiChainTypeListRequest] =
    useGetEdiChainTypeList();
  const [getGodEdiChainTypeListResponse, sendGetGodEdiChainTypeListRequest] =
    useGetEdiChainTypeList();
  const [getPartnersReponse, sendGetPartners] = useGetPartners();

  const [authdActionItems, sendGetActionItems] = useGetActionItems();

  const [pageState, setPageState] = usePageState();
  const { alertMessage, searchForm, interfaceListGeneralCodeState } = pageState;
  const [appState, setAppState] = useAppState();
  const [
    deploymentRequestInfomationInputDialogState,
    setDeploymentRequestInfomationInputDialogState,
  ] = useDeploymentRequestInfomationInputDialogState();
  const [commentDialogState, setCommentDialogState] = useCommentDialogState();
  const [unSaved, setUnSaved] = useState(false);
  const [spreadsheetState, setSpreadsheetState, initSpreadsheetState] =
    useSpreadsheetState<SpreadsheetState>();
  const navigate = useNavigate();
  const location = useLocation();
  const { showToast, showAlertBar, showConfirmationDialog, resetUserError } =
    useGlobalNotifier();
  const { search } = useLocation();
  const queryParameter = new URLSearchParams(search);
  const params = {
    mode: queryParameter.get("mode") ?? PAGE_MODE.REF_MODE,
    type: queryParameter.get("type") ?? PAGE_TYPE.PRD_PJ_TYPE,
    pjtId: queryParameter.get("pjtId") ?? "",
    godFlg: queryParameter.get("godFlg") ?? InDefCommonFlagType.NO,
    dfnSetVerNum:
      queryParameter.get("dfnSetVerNum") ?? ENV("REACT_APP_DFN_SET_VER_NUM"),
  };

  const [srcPresetSelectedItems, setSrcPresetSelectedItems] = useState<
    string[]
  >(srcInboundColumnPresets.map((v) => v.value));

  const [dstPresetSelectedItems, setDstPresetSelectedItems] = useState<
    string[]
  >(dstOutboundColumnPresets.map((v) => v.value));

  const crossDomainColumnPresetsToUse =
    (params.mode === PAGE_MODE.REF_MODE &&
      params.type !== PAGE_TYPE.ACTIVE_PJ_TYPE) ||
    params.mode === PAGE_MODE.GOD_MODE
      ? crossDomainColumnPresetsHasDstInbound
      : crossDomainColumnPresets;

  const [crossPresetSelectedItems, setCrossPresetSelectedItems] = useState<
    string[]
  >(
    ![PAGE_MODE.REF_MODE].includes(params.mode)
      ? crossDomainColumnPresetsToUse.map((v) => v.value)
      : [],
  );

  const [basicPresetSelectedItems, setBasicPresetSelectedItems] = useState<
    string[]
  >(basicColumnPresets.map((v) => v.value));

  const [presetParentSelectedItems, setPresetParentSelectedItems] = useState({
    basic: true,
    src: true,
    cross: ![PAGE_MODE.REF_MODE].includes(params.mode),
    dst: true,
  });

  const [presetSubCategoriesVisible, setPresetSubCategoriesVisible] = useState({
    src: true,
    cross: true,
    dst: true,
  });

  const [isPresetEnabled, setIsPresetEnabled] = useState(false);

  const { messageForScreen } = useMessage();

  const partialRestoreRef = useRef<PendingPartialRestore | null>(null);

  const reviewDiffRequestMode =
    params.mode === PAGE_MODE.REQ_APPROVAL_MODE ? "request-approval" : "review";

  const handleReviewDiffStateChange = React.useCallback(
    (updater: ReviewDiffStateUpdater) => {
      setPageState((prev) => {
        const nextReviewDiffState = updater(prev.reviewDiffState);

        if (nextReviewDiffState === prev.reviewDiffState) {
          return prev;
        }

        return {
          ...prev,
          reviewDiffState: nextReviewDiffState,
        };
      });
    },
    [setPageState],
  );

  const { onChangeReviewDiff, refreshReviewDiff } = useReviewDiff({
    dfnSetVerNum: params.dfnSetVerNum,
    pjtId: params.pjtId,
    ifList: pageState.ifList,
    reviewDiffState: pageState.reviewDiffState,

    onReviewDiffStateChange: handleReviewDiffStateChange,

    mode: reviewDiffRequestMode,
    reviewDiffResponse: getIfDefinitionReviewDiffsResponse,
    sendGetIfDefinitionReviewDiffsRequest,
  });

  const isDiffVisible =
    params.mode === PAGE_MODE.REVIEW_MODE ||
    params.mode === PAGE_MODE.REQ_APPROVAL_MODE;

  const {
    tooltipProps,
    handleHover,
    handleHoverAreaMouseEnter,
    handleHoverAreaMouseLeave,
    closeTooltip,
  } = useHoverDiffTooltip({
    resolveDiff: (row, diffPath): DiffTooltipDetail | undefined => {
      if (!diffPath) {
        return undefined;
      }

      const isSrcAdded =
        diffPath.startsWith("src.") &&
        row?.reviewDiffInfo?.src?.changeType === "added";

      if (isSrcAdded) {
        return {
          before: "",
          after: "",
          tooltipLabel: "Added (Src)",
        };
      }

      const isDstAdded =
        diffPath.startsWith("dst.") &&
        row?.reviewDiffInfo?.dst?.changeType === "added";

      if (isDstAdded) {
        return {
          before: "",
          after: "",
          tooltipLabel: "Added (Dst)",
        };
      }

      const diff = getReviewDiffCell(row?.reviewDiffInfo, diffPath);

      return formatInterfaceListDiffForDisplay(
        diff,
        diffPath,
        pageState.interfaceListGeneralCodeState,
      );
    },
    enabled:
      isDiffVisible &&
      pageState.reviewDiffState.selectedTarget !== REVIEW_DIFF_TARGET.NONE,
    resetKey: pageState.reviewDiffState.selectedTarget,
  });

  const extractEditedCells = (obj: any, prefix = ""): EditedCell[] => {
    const results: EditedCell[] = [];

    for (const [key, value] of Object.entries(obj)) {
      const path = prefix ? `${prefix}.${key}` : key;

      if (!value || typeof value !== "object" || Array.isArray(value)) {
        continue;
      }

      if ("editedFlg" in value) {
        if (value.editedFlg) {
          results.push({ path, value: String((value as any).value ?? "") });
        }
      } else {
        const nested = extractEditedCells(value, path);
        results.push(...nested);
      }
    }

    return results;
  };

  const [
    frontendValidationMessagesByRowIndex,
    setFrontendValidationMessagesByRowIndex,
  ] = useState<Record<number, string[]>>({});

  // page title
  let projectName = "";

  const interfaceListTemplateFileUrl = useMemo(() => {
    let templateFileUrl = "spreadsheet-template/interface-list-input.xlsx";
    switch (params.mode) {
      case PAGE_MODE.REF_MODE:
        if (!pageState.isHistoryDisplay) {
          switch (params.type) {
            case PAGE_TYPE.ACTIVE_PJ_TYPE:
              templateFileUrl =
                "spreadsheet-template/interface-list-ref-active-pj.xlsx";
              break;
            case PAGE_TYPE.PRD_PJ_TYPE:
              templateFileUrl =
                "spreadsheet-template/interface-list-ref-released.xlsx";
              break;
            case PAGE_TYPE.STG_PJ_TYPE:
              templateFileUrl =
                "spreadsheet-template/interface-list-ref-released.xlsx";
              break;
            default:
              templateFileUrl =
                "spreadsheet-template/interface-list-ref-released.xlsx";
              break;
          }
        } else {
          templateFileUrl =
            "spreadsheet-template/interface-list-ref-history.xlsx";
        }
        break;
      case PAGE_MODE.GOD_MODE:
        templateFileUrl = "spreadsheet-template/interface-list-god.xlsx";
        break;
      case PAGE_MODE.INPUT_MODE:
        templateFileUrl = "spreadsheet-template/interface-list-input.xlsx";
        break;
      case PAGE_MODE.REQ_APPROVAL_MODE:
        templateFileUrl =
          "spreadsheet-template/interface-list-request-approval.xlsx";
        break;
      case PAGE_MODE.REVIEW_MODE:
        templateFileUrl = "spreadsheet-template/interface-list-review.xlsx";
        break;
      case PAGE_MODE.STG_DPLYMNT_MODE:
        templateFileUrl = !pageState.isPendingDisplay
          ? "spreadsheet-template/interface-list-stg-deployment.xlsx"
          : "spreadsheet-template/interface-list-deployment_setup-pending.xlsx";
        break;
      case PAGE_MODE.PRD_DPLYMNT_MODE:
        templateFileUrl = !pageState.isPendingDisplay
          ? "spreadsheet-template/interface-list-prd-deployment.xlsx"
          : "spreadsheet-template/interface-list-deployment_setup-pending.xlsx";
        break;
      default:
        break;
    }
    return templateFileUrl;
  }, [params.mode, pageState.isPendingDisplay, pageState.isHistoryDisplay]);

  const spreadsheetInitialData = useMemo<SpreadsheetState>(() => {
    const diffMap = pageState.reviewDiffState.response?.byIfReqId ?? {};

    const ifList: InterfaceSpreadsheetRow[] = pageState.ifList.map((e) => ({
      ...INIT_ERROR_RESULT_DATA,
      ...e,
      reviewDiffInfo: diffMap[e.project?.ifReqId ?? ""],
      shouldShowInterruptTypeFlag: shouldShowInterruptType(e),
      isInternalDIP:
        e.src.interfaceDefinition.dipByRegion ===
        e.dst.interfaceDefinition.dipByRegion,
      srcMetaOnlyFlag:
        e.src.interfaceDefinition.metaOnlyFlag === InDefCommonFlagType.YES,
      dstMetaOnlyFlag:
        e.dst.interfaceDefinition.metaOnlyFlag === InDefCommonFlagType.YES,
    }));

    const interfaceListGeneralCodeState =
      pageState.interfaceListGeneralCodeState;
    const edhNotificationType = pageState.edhNotificationType;
    return {
      ifList: ifList,
      interfaceListGeneralCodeState: interfaceListGeneralCodeState,
      edhNotificationType: edhNotificationType,
      isSaveAuth: pageState.isSaveAuth,
      mode: params.mode,
      type: params.type,

      showColumnPresets: {
        srcInbound: srcPresetSelectedItems,
        dstOutbound: dstPresetSelectedItems,
        crossDomain: crossPresetSelectedItems,
        basicInformation: basicPresetSelectedItems,
      },
      dplymntType: DeploymentDivisionCode.NORMAL,
      deploymentRequestScreenProcessingDivisionType: undefined,
      isDplymntDetailScreen: false,
    };
  }, [
    pageState.ifList,
    pageState.interfaceListGeneralCodeState,
    pageState.edhNotificationType,
    pageState.isSaveAuth,
    pageState.reviewDiffState,
    params.mode,
    params.type,
  ]);

  useEffect(() => {
    setIsPresetEnabled(false);
  }, [
    pageState.ifList,
    pageState.interfaceListGeneralCodeState,
    pageState.edhNotificationType,
    pageState.isSaveAuth,
    params.mode,
    params.type,
  ]);

  const [isInitialized, setIsInitialized] = useState(true);
  const onInitialDisplayed = () => {
    if (isInitialized) resetUserError();

    setPageState((prevState) => ({
      ...prevState,
      alertMessage: {},
    }));
    setIsInitialized(false);
    sendGeneralCodesRequest({ cdTypes: CD_TYPES });
    sendEdhNotificationTypeListRequest({});
    let iFDefinitionsRequest: GetIFDefinitionsRequest = {
      dfnSetVerNum: params.dfnSetVerNum,
    };
    switch (params.mode) {
      case PAGE_MODE.REF_MODE:
        switch (params.type) {
          case ReferenceModeType.ENVIRONMENT_PRD:
            // use by SearchForm
            sendGetDipByRegionListRequest({});
            sendGetDipListRequest({});
            break;
          case ReferenceModeType.ENVIRONMENT_STG:
            // use by SearchForm
            sendGetDipByRegionListRequest({});
            sendGetDipListRequest({});
            break;
          case ReferenceModeType.ACTIVE_PROJECTS:
            // use by SearchForm
            sendGetDipByRegionListRequest({});
            sendGetDipListRequest({});
            break;
        }
        break;
      case PAGE_MODE.GOD_MODE:
        switch (params.type) {
          case ReferenceModeType.ENVIRONMENT_PRD:
            // use by SearchForm
            sendGetDipByRegionListRequest({});
            sendGetDipListRequest({});
            break;
          case ReferenceModeType.ENVIRONMENT_STG:
            // use by SearchForm
            sendGetDipByRegionListRequest({});
            sendGetDipListRequest({});
            break;
          case ReferenceModeType.ACTIVE_PROJECTS:
            iFDefinitionsRequest.project = {
              pjtIds: [params.pjtId],
            };
            iFDefinitionsRequest.includeFileLayout =
              determineIncludeFileLayout();
            sendGetIFDefinitionsRequest(iFDefinitionsRequest);
            break;
        }
        // use by template pulldown
        sendGetDipByRegionListRequest({});
        sendGetEdhProtocolListRequest({ godOnlyFlag: InDefCommonFlagType.NO });
        sendGetGodEdhProtocolListRequest({
          godOnlyFlag: InDefCommonFlagType.YES,
        });
        sendGetEdiChainTypeListRequest({ godOnlyFlag: InDefCommonFlagType.NO });
        sendGetGodEdiChainTypeListRequest({
          godOnlyFlag: InDefCommonFlagType.YES,
        });
        setPageState((prevState) => ({
          ...prevState,
          isSaveAuth: isDisplayedAction("interface_list_god.button.god_save"),
        }));
        break;
      case PAGE_MODE.INPUT_MODE:
        iFDefinitionsRequest.project = {
          pjtIds: [params.pjtId],
          dsgnTcktStsTypeCds: [
            TcktStsTypeIfDsgn.DESIGN,
            TcktStsTypeIfDsgn.DESIGN_REVIEW,
            TcktStsTypeIfDsgn.DESIGN_APPROVED,
            TcktStsTypeIfDsgn.CANCELLED,
          ],
        };
        iFDefinitionsRequest.includeFileLayout = determineIncludeFileLayout();
        sendGetIFDefinitionsRequest(iFDefinitionsRequest);
        break;
      case PAGE_MODE.REQ_APPROVAL_MODE:
        iFDefinitionsRequest.project = {
          pjtIds: [params.pjtId],
          dsgnTcktStsTypeCds: [
            TcktStsTypeIfDsgn.DESIGN,
            TcktStsTypeIfDsgn.DESIGN_REVIEW,
          ],
        };
        iFDefinitionsRequest.includeFileLayout = determineIncludeFileLayout();
        sendGetIFDefinitionsRequest(iFDefinitionsRequest);
        break;
      case PAGE_MODE.REVIEW_MODE:
        iFDefinitionsRequest.project = {
          pjtIds: [params.pjtId],
          dsgnTcktStsTypeCds: [
            TcktStsTypeIfDsgn.DESIGN_REVIEW,
            TcktStsTypeIfDsgn.DESIGN_APPROVED,
          ],
        };
        iFDefinitionsRequest.includeFileLayout = determineIncludeFileLayout();
        sendGetIFDefinitionsRequest(iFDefinitionsRequest);
        break;
      case PAGE_MODE.STG_DPLYMNT_MODE:
        iFDefinitionsRequest.project = {
          pjtIds: [params.pjtId],
          stgDplymntTcktStsTypeCds: [
            TcktStsTypeIfStgDplymnt.REQUEST_PLANNING,
            TcktStsTypeIfStgDplymnt.DEPLOYED,
          ],
          prdDplymntTcktStsTypeCds: [
            TcktStsTypeIfPrdDplymnt.WAITING,
            TcktStsTypeIfPrdDplymnt.REQUEST_PLANNING,
            TcktStsTypeIfPrdDplymnt.CANCELLED,
          ],
        };
        iFDefinitionsRequest.includeFileLayout = determineIncludeFileLayout();
        sendGetIFDefinitionsRequest(iFDefinitionsRequest);
        break;
      case PAGE_MODE.PRD_DPLYMNT_MODE:
        iFDefinitionsRequest.project = {
          pjtIds: [params.pjtId],
          prdDplymntTcktStsTypeCds: [
            TcktStsTypeIfPrdDplymnt.REQUEST_PLANNING,
            TcktStsTypeIfPrdDplymnt.DEPLOYED,
          ],
          andCondSrcDstTcktSts: true,
        };
        iFDefinitionsRequest.includeFileLayout = determineIncludeFileLayout();
        sendGetIFDefinitionsRequest(iFDefinitionsRequest);
        break;
    }
  };

  const onChangePjtIdParam = () => {
    if (
      params.mode === PAGE_MODE.REF_MODE ||
      (params.mode === PAGE_MODE.GOD_MODE &&
        params.type !== PAGE_TYPE.ACTIVE_PJ_TYPE)
    ) {
      setPageState((prevState) => ({
        ...prevState,
        authorized: true,
      }));
      return;
    }

    if (!!params.pjtId || !!appState.pjtId) {
      setBelongingInformation({
        belongTypeCode: RoleCvrgType.PROJECT,
        belongCode: !!params.pjtId ? params.pjtId : appState.pjtId,
      });

      sendGetActionItems({
        blngTypeCd: RoleCvrgType.PROJECT,
        blngCd: !!params.pjtId ? params.pjtId : appState.pjtId,
      });
    } else {
      setPageState((prevState) => ({
        ...prevState,
        authorized: true,
      }));
    }
  };

  const onGetGeneralCodesResponse = () => {
    let commonConditionFlagType = [] as Option[];
    let securityContentsType = [] as Option[];
    let sendDatalakeType = [] as Option[];
    let fileExtensionType = [] as Option[];
    let referenceModeType = [] as Option[];
    let godReferenceModeType = [] as Option[];
    let reviewActionType = [] as Option[];
    let reviewingActionType = [] as Option[];
    let designCompletedActionType = [] as Option[];
    let interfaceRequirementType = [] as Option[];
    let interfaceUpdateRequirementType = [] as Option[];
    let edhNotificationType = [] as Option[];
    let edhPrtclType = [] as Option[];
    let ptnrType = [] as Option[];
    let chnTypeType = [] as Option[];
    let fileTypeType = [] as Option[];
    let ifCycleType = [] as Option[];
    let snapshotIncrementalDeltaType = [] as Option[];
    let dataScopeType = [] as Option[];
    let encriptionType = [] as Option[];
    let securityInformationLevelType = [] as Option[];
    let tcktStsTypePrjPrgrs = [] as Option[];
    let retentionPeriodDays = [] as Option[];
    let ediPollingAdaptorType = [] as Option[];
    let interruptType = [] as Option[];
    let interruptTypeForDstUpdate = [] as Option[];
    let interruptTypeForSrcOnlyUpdate = [] as Option[];
    let interruptTypeForSrcDstUpdate = [] as Option[];
    const GeneralCode = getGeneralCodesResponse?.gnrlCdTypeList ?? [];
    if (GeneralCode.length === 0) {
      return;
    }
    GeneralCode.map((e) => {
      switch (e.cdType) {
        case "in_def_common_flag_type":
          commonConditionFlagType = e.cdList;
          break;
        case "security_contents_type":
          securityContentsType = e.cdList;
          break;
        case "send_datalake_type":
          sendDatalakeType = e.cdList;
          break;
        case "file_extension_type":
          fileExtensionType = e.cdList;
          break;
        case "reference_mode_type":
          referenceModeType = e.cdList;
          godReferenceModeType = e.cdList.filter((e) => {
            if (
              e.value === ReferenceModeType.ENVIRONMENT_PRD ||
              e.value === ReferenceModeType.ENVIRONMENT_STG
            ) {
              return e;
            }
          });
          break;
        case "review_action_type":
          reviewActionType = e.cdList;
          reviewActionType.forEach((e) => {
            if (
              e.value === ReviewActionType.APPROVE ||
              e.value === ReviewActionType.REJECT
            )
              reviewingActionType.push(e);
            if (e.value === ReviewActionType.DISMISS_APPROVAL)
              designCompletedActionType.push(e);
          });
          break;
        case "interface_requirement_type":
          interfaceRequirementType = e.cdList;
          interfaceRequirementType.forEach((e) => {
            if (e.value !== InterfaceRequirementType.CREATE) {
              interfaceUpdateRequirementType.push(e);
            }
          });
          break;
        case "edh_notification_type":
          edhNotificationType = e.cdList;
          break;
        case "edh_prtcl_type":
          edhPrtclType = e.cdList;
          break;
        case "ptnr_type":
          ptnrType = e.cdList;
          break;
        case "chn_type_type":
          chnTypeType = e.cdList;
          break;
        case "file_type_type":
          fileTypeType = e.cdList;
          break;
        case "if_cycle_type":
          ifCycleType = e.cdList;
          break;
        case "snapshot_incremental_delta_type":
          snapshotIncrementalDeltaType = e.cdList;
          break;
        case "data_scope_type":
          dataScopeType = e.cdList;
          break;
        case "encription_type":
          encriptionType = e.cdList;
          break;
        case "security_information_level_type":
          securityInformationLevelType = e.cdList;
          break;
        case "tckt_sts_type_prj_prgrs":
          tcktStsTypePrjPrgrs = e.cdList;
          break;
        case "retention_period_days_type":
          retentionPeriodDays = e.cdList;
          break;
        case "edi_polling_adaptor_type":
          ediPollingAdaptorType = e.cdList;
          break;
        case "interrupt_type":
          interruptTypeForDstUpdate = e.cdList.filter(
            (e) => e.value != InterruptType.CANCEL,
          );
          interruptType = interruptTypeForDstUpdate.filter(
            (e) => e.value != InterruptType.NOCHANGE,
          );
          interruptTypeForSrcOnlyUpdate = interruptTypeForDstUpdate.filter(
            (e) => e.value != InterruptType.NONE,
          );
          interruptTypeForSrcDstUpdate = interruptTypeForDstUpdate.filter(
            (e) => e.value != InterruptType.PENDING,
          );
      }
    });
    const interfaceListGeneralCodeState =
      pageState.interfaceListGeneralCodeState;
    setPageState((prevState) => ({
      ...prevState,
      interfaceListGeneralCodeState: {
        ...interfaceListGeneralCodeState,
        commonConditionFlagType: commonConditionFlagType,
        securityContentsType: securityContentsType,
        sendDatalakeType: sendDatalakeType,
        fileExtensionType: fileExtensionType,
        referenceModeType: referenceModeType,
        godReferenceModeType: godReferenceModeType,
        reviewActionType: reviewActionType,
        reviewingActionType: reviewingActionType,
        designCompletedActionType: designCompletedActionType,
        interfaceRequirementType: interfaceRequirementType,
        interfaceUpdateRequirementType: interfaceUpdateRequirementType,
        edhNotificationType: edhNotificationType,
        edhPrtclType: edhPrtclType,
        ptnrType: ptnrType,
        chnTypeType: chnTypeType,
        fileTypeType: fileTypeType,
        ifCycleType: ifCycleType,
        snapshotIncrementalDeltaType: snapshotIncrementalDeltaType,
        dataScopeType: dataScopeType,
        encriptionType: encriptionType,
        securityInformationLevelType: securityInformationLevelType,
        tcktStsTypePrjPrgrs: tcktStsTypePrjPrgrs,
        retentionPeriodDays: retentionPeriodDays,
        ediPollingAdaptorType: ediPollingAdaptorType,
        interruptType: interruptType,
        interruptTypeForDstUpdate: interruptTypeForDstUpdate,
        interruptTypeForSrcOnlyUpdate: interruptTypeForSrcOnlyUpdate,
        interruptTypeForSrcDstUpdate: interruptTypeForSrcDstUpdate,
      },
    }));
  };

  const createDipByRgnOrDipList = () => {
    if (!getDipByRegionListResponse || !getDipListResponse) return;

    const dipList: Option[] = [
      ...getDipByRegionListResponse.dipByRgnList.map((e) => ({
        label: e.dipByRgn,
        value: e.dipByRgn,
      })),
      ...getDipListResponse.dipList.map((e) => ({
        label: e.dip,
        value: e.dip,
      })),
    ];
    const dipByRgnOrDipList = deduplicatedOptionList(dipList);

    setPageState((prevState) => ({
      ...prevState,
      interfaceListGeneralCodeState: {
        ...prevState.interfaceListGeneralCodeState,
        dipByRgnOrDipList: dipByRgnOrDipList,
      },
    }));
  };

  const onGetDipByRegionListResponse = () => {
    if (!getDipByRegionListResponse) return;
    setPageState((prevState) => ({
      ...prevState,
      interfaceListGeneralCodeState: {
        ...prevState.interfaceListGeneralCodeState,
        dipByRegionList: getDipByRegionListResponse.dipByRgnList.map((e) => ({
          label: e.dipByRgn,
          value: e.dipByRgn,
        })),
      },
    }));
  };

  const onGetEdhProtocolListResponse = () => {
    if (!getEdhProtocolListResponse || !getGodEdhProtocolListResponse) return;
    const protocolList = getEdhProtocolListResponse.edhProtocolList.concat(
      getGodEdhProtocolListResponse.edhProtocolList,
    );
    setPageState((prevState) => ({
      ...prevState,
      interfaceListGeneralCodeState: {
        ...prevState.interfaceListGeneralCodeState,
        inboundEdhProtocolList: protocolList
          .filter((e) =>
            [IoType.INBOUND, IoType.INBOUNDOUTBOUND].includes(
              e.inOutTypeCd as IoType,
            ),
          )
          .map((e) => ({
            label: e.label,
            value: e.value,
          })),
        outboundEdhProtocolList: protocolList
          .filter((e) =>
            [IoType.OUTBOUND, IoType.INBOUNDOUTBOUND].includes(
              e.inOutTypeCd as IoType,
            ),
          )
          .map((e) => ({
            label: e.label,
            value: e.value,
          })),
      },
    }));
  };

  const onGetEdiChainTypeListResponse = () => {
    if (!getEdiChainTypeListResponse || !getGodEdiChainTypeListResponse) return;
    const chainTypeList = getEdiChainTypeListResponse.ediChainTypeList.concat(
      getGodEdiChainTypeListResponse.ediChainTypeList,
    );
    setPageState((prevState) => ({
      ...prevState,
      interfaceListGeneralCodeState: {
        ...prevState.interfaceListGeneralCodeState,
        srcEdiChainTypeList: chainTypeList
          .filter((e) =>
            [IoType.INBOUND, IoType.INBOUNDOUTBOUND].includes(
              e.inOutTypeCd as IoType,
            ),
          )
          .map((e) => ({
            label: e.label,
            value: e.value,
          })),
        dstEdiChainTypeList: chainTypeList
          .filter((e) =>
            [IoType.OUTBOUND, IoType.INBOUNDOUTBOUND].includes(
              e.inOutTypeCd as IoType,
            ),
          )
          .map((e) => ({
            label: e.label,
            value: e.value,
          })),
      },
    }));
  };

  const onGetEdhNotificationTypeList = () => {
    if (!getEdhNotificationTypeListResponse) {
      return;
    }
    let edhNotificationType: EdhNotificationType = {};
    getEdhNotificationTypeListResponse?.edhNotificationTypeList.forEach((e) => {
      const key = e.inOutTypeCd + "/" + e.dipByRgn;
      if (!edhNotificationType.hasOwnProperty(key)) {
        edhNotificationType[key] = {
          edhNotificationTypeList: [],
        };
      }
      const edhNotificationTypeList =
        edhNotificationType[key].edhNotificationTypeList;
      edhNotificationTypeList.push({ label: e.label, value: e.value });
      edhNotificationType[key] = {
        edhNotificationTypeList: edhNotificationTypeList,
      };
    });

    setPageState((prevState) => ({
      ...prevState,
      edhNotificationType: edhNotificationType,
    }));
  };

  const onGetDataKindResponse = () => {
    const fileLayoutList = getDataKindResponse?.fileLayoutList ?? [];
    let iflist: Interface[] | InterfaceSpreadsheetRow[] = [];

    if (pageState.issuedRowIdx >= 0 && !!pageState.issuedEventName) {
      iflist = _.cloneDeep(
        spreadsheetState?.ifList,
      ) as InterfaceSpreadsheetRow[];
      let newEditedIfList = _.cloneDeep(pageState?.editedIfList || []);
      let editedIfList = {} as any;

      // Recreate FileLayout pulldown for all rows
      complementFileLayoutPulldownList(iflist, fileLayoutList);

      // Setting the initial focus state after creating a FileLayout
      if (pageState.issuedEventName === "srcIssuingInputFileID") {
        const issuedFileId = iflist[pageState.issuedRowIdx]["srcFileList"]
          .map((e: Option) => {
            return e.value;
          })
          .sort()
          .reverse()[0];
        editedIfList = editIfCell(
          iflist[pageState.issuedRowIdx],
          newEditedIfList[pageState.issuedRowIdx],
          "src.interfaceDefinition.inbound.inboundMeta.fileId",
          true,
          issuedFileId,
        );
      } else if (pageState.issuedEventName === "srcIssuingOutputFileID") {
        const issuedFileId = iflist[pageState.issuedRowIdx]["srcFileList"]
          .map((e: Option) => {
            return e.value;
          })
          .sort()
          .reverse()[0];
        editedIfList = editIfCell(
          iflist[pageState.issuedRowIdx],
          newEditedIfList[pageState.issuedRowIdx],
          "src.interfaceDefinition.outbound.outboundMeta.fileId",
          true,
          issuedFileId,
        );
      } else if (pageState.issuedEventName === "dstIssuingInputFileID") {
        const issuedFileId = iflist[pageState.issuedRowIdx]["dstFileList"]
          .map((e: Option) => {
            return e.value;
          })
          .sort()
          .reverse()[0];
        editedIfList = editIfCell(
          iflist[pageState.issuedRowIdx],
          newEditedIfList[pageState.issuedRowIdx],
          "dst.interfaceDefinition.inbound.inboundMeta.fileId",
          true,
          issuedFileId,
        );
      } else if (pageState.issuedEventName === "dstIssuingOutputFileID") {
        const issuedFileId = iflist[pageState.issuedRowIdx]["dstFileList"]
          .map((e: Option) => {
            return e.value;
          })
          .sort()
          .reverse()[0];
        editedIfList = editIfCell(
          iflist[pageState.issuedRowIdx],
          newEditedIfList[pageState.issuedRowIdx],
          "dst.interfaceDefinition.outbound.outboundMeta.fileId",
          true,
          issuedFileId,
        );
      }
      iflist[pageState.issuedRowIdx] = editedIfList.newSpreadsheetRow;
      newEditedIfList[pageState.issuedRowIdx] = editedIfList.newEditedIfRow;
      const spreadsheetData = _.cloneDeep(spreadsheetState);
      if (!spreadsheetData) return;
      setSpreadsheetState({
        ...spreadsheetData,
        ifList: iflist,
      });
      setPageState((prevState) => ({
        ...prevState,
        editedIfList: newEditedIfList,
        issuedRowIdx: -1,
        issuedEventName: "",
      }));
    } else {
      // Setting the initial FileLayout pulldown
      iflist = _.cloneDeep(pageState?.ifList) as Interface[];
      complementFileLayoutPulldownList(iflist, fileLayoutList);
      setPageState((prevState) => ({
        ...prevState,
        ifList: iflist,
        editedIfList: iflist,
        issuedRowIdx: -1,
        issuedEventName: "",
      }));
    }
  };

  const restoreAfterPartial = (
    dbIfList: Interface[],
    dbEditedIfList: Interface[],
    pending: PendingPartialRestore,
  ) => {
    const patchedEditedIfList = _.cloneDeep(dbEditedIfList);

    pending.failedRows.forEach(({ index, edits }) => {
      let sheetRow = dbIfList[index];
      let editedRow = patchedEditedIfList[index];
      edits.forEach(({ path, value }) => {
        const res = editIfCell(sheetRow, editedRow, path, true, value);
        editedRow = res.newEditedIfRow;
      });

      patchedEditedIfList[index] = editedRow;
    });

    const errorsForMapping = pending.failedRows.map(
      ({ index, ifReqId, error }) => ({
        ...error,
        ifReqId,
        index,
      }),
    );

    const withErrors = mappingErrorResponseToSpreadsheet(
      errorsForMapping,
      dbIfList,
      InterfaceListPageInitialState.displayColumn,
    );

    pending.failedRows.forEach((failed) => {
      const row = withErrors[failed.index];
      if (!row) return;

      row.partialRestoreRowEdited = true;

      const editedCellMap: Record<string, true> = Object.create(null);
      failed.edits.forEach(({ path }) => {
        editedCellMap[path] = true;
      });

      row.partialRestoreCellEdited = editedCellMap;
    });

    return { withErrors, patchedEditedIfList };
  };

  const onGetIFDefinitionsResponse = () => {
    if (!getIFDefinitionsResponse) return;
    // Filtering ifList by screenmode
    const iflist = filterIfListByScreenMode(
      params.mode,
      getIFDefinitionsResponse.ifList,
    );

    let interfaceList: Interface[] = iflist.map((e, idx) => {
      projectName = e.project?.pjtName;
      const information: Information = {
        duplicatedIdList: e.information?.duplicatedIdList
          ? e.information.duplicatedIdList.map((dup) => {
              if (dup.duplicatedProjectList.length > 0) {
                dup.message.push(
                  messageForScreen(
                    ApplicationMessageScreen.APP_SCN_00154,
                    dup.duplicatedProjectList
                      .map((pjt) => pjt.pjtName)
                      .toString(),
                  ),
                );
                return dup;
              } else {
                return dup;
              }
            })
          : [],
        layoutFileExistanceList: e.information?.layoutFileExistanceList,
        val: "",
        col: [],
      };
      const isGodMode =
        params.mode === PAGE_MODE.GOD_MODE &&
        (params.type === ReferenceModeType.ENVIRONMENT_PRD ||
          params.type === ReferenceModeType.ENVIRONMENT_STG);

      const src: Src = isGodMode
        ? {
            interfaceDefinition: {
              ...e.src.interfaceDefinition,
              interfaceRequirementType: "",
            },
          }
        : e.src;

      const dst: Dst = isGodMode
        ? {
            interfaceDefinition: {
              ...e.dst.interfaceDefinition,
              interfaceRequirementType: "",
            },
          }
        : e.dst;

      const res: Interface = {
        ...INIT_INTERFACE_DATA,
        idx,
        existSrcDsgnCmnt: !!e.projectTcktInfo?.srcDsgnCmnt,
        existDstDsgnCmnt: !!e.projectTcktInfo?.dstDsgnCmnt,
        // Gray out cancelled IF requirement
        cancelledRequirement:
          (e.projectTcktInfo?.srcDsgnWFlwStsDsplyName ==
            DSGN_W_FLW_STS_CANCELLED &&
            e.projectTcktInfo?.dstDsgnWFlwStsDsplyName ==
              DSGN_W_FLW_STS_CANCELLED) ||
          ([DPlYMNT_W_FLW_STS_CANCELLED, DPlYMNT_W_FLW_STS_DEPLOYED].includes(
            e.projectTcktInfo?.srcStgDplymntWFlwStsDsplyName,
          ) &&
            [DPlYMNT_W_FLW_STS_CANCELLED, DPlYMNT_W_FLW_STS_DEPLOYED].includes(
              e.projectTcktInfo?.dstStgDplymntWFlwStsDsplyName,
            ) &&
            e.projectTcktInfo?.srcPrdDplymntWFlwStsDsplyName ==
              DPlYMNT_W_FLW_STS_CANCELLED)
            ? true
            : false,
        updateDateTime: e.updateDateTime,
        project: e.project,
        projectTcktInfo: e.projectTcktInfo,
        srcInterruptType: "None",
        dstInterruptType: "Pending",
        src,
        dst,
        information,
      };

      if (params.mode === PAGE_MODE.REVIEW_MODE) {
        const retentionItem = pageState.retentionEditedIfList.get(
          e.project.ifReqId,
        );
        if (!!retentionItem && Object.keys(retentionItem).length) {
          res.srcAction =
            retentionItem.srcAction &&
            retentionItem.srcAction.hasOwnProperty("editedFlg")
              ? retentionItem.srcAction.value
              : retentionItem.srcAction;
          res.dstAction =
            retentionItem.dstAction &&
            retentionItem.dstAction.hasOwnProperty("editedFlg")
              ? retentionItem.dstAction.value
              : retentionItem.dstAction;
          res.projectTcktInfo.srcDsgnCmnt =
            retentionItem.srcComment &&
            retentionItem.srcComment.hasOwnProperty("editedFlg")
              ? retentionItem.srcComment.value
              : retentionItem.srcComment;
          res.projectTcktInfo.dstDsgnCmnt =
            retentionItem.dstComment &&
            retentionItem.dstComment.hasOwnProperty("editedFlg")
              ? retentionItem.dstComment.value
              : retentionItem.dstComment;
        }
      }
      return res;
    });
    let editedIfList = _.cloneDeep(interfaceList);
    if (
      params.mode === PAGE_MODE.REVIEW_MODE &&
      pageState.retentionEditedIfList.size > 0
    ) {
      editedIfList.map((e: Interface) => {
        const retentionItem = pageState.retentionEditedIfList.get(
          e.project.ifReqId,
        );
        if (Object.keys(retentionItem).length) {
          e.srcAction =
            retentionItem.srcAction &&
            retentionItem.srcAction.hasOwnProperty("editedFlg") &&
            retentionItem.srcAction.editedFlg
              ? ({
                  initValue: retentionItem.srcAction.initValue,
                  editedFlg: true,
                  value: retentionItem.srcAction.value,
                } as any)
              : e.srcAction;
          e.dstAction =
            retentionItem.dstAction &&
            retentionItem.dstAction.hasOwnProperty("editedFlg") &&
            retentionItem.dstAction.editedFlg
              ? ({
                  initValue: retentionItem.dstAction.initValue,
                  editedFlg: true,
                  value: retentionItem.dstAction.value,
                } as any)
              : e.dstAction;
          e.projectTcktInfo.srcDsgnCmnt =
            retentionItem.srcComment &&
            retentionItem.srcComment.hasOwnProperty("editedFlg") &&
            retentionItem.srcComment.editedFlg
              ? ({
                  initValue: retentionItem.srcComment.initValue,
                  editedFlg: true,
                  value: retentionItem.srcComment.value,
                } as any)
              : e.projectTcktInfo.srcDsgnCmnt;
          e.projectTcktInfo.dstDsgnCmnt =
            retentionItem.dstComment &&
            retentionItem.dstComment.hasOwnProperty("editedFlg") &&
            retentionItem.dstComment.editedFlg
              ? ({
                  initValue: retentionItem.srcComment.initValue,
                  editedFlg: true,
                  value: retentionItem.srcComment.value,
                } as any)
              : e.projectTcktInfo.dstDsgnCmnt;
        }
        return e;
      });
    }

    const fileLayout = getIFDefinitionsResponse.fileLayoutList;
    complementFileLayoutPulldownList(interfaceList, fileLayout);

    const pending = partialRestoreRef.current;
    if (pending) {
      const { withErrors, patchedEditedIfList } = restoreAfterPartial(
        interfaceList,
        editedIfList,
        pending,
      );

      interfaceList = withErrors;
      editedIfList = patchedEditedIfList;
      partialRestoreRef.current = null;

      if (spreadsheetState) {
        setSpreadsheetState({
          ...spreadsheetState,
          ifList: withErrors,
        });
      }
    }

    const errorMessageList =
      interfaceList.length === 0
        ? [
            {
              message: messageForScreen(
                ApplicationMessageScreen.APP_SCN_00125,
                "Interface",
              ),
            },
          ]
        : createIFAlertMessageList(params.mode, pageState.isPendingDisplay);

    const { hitCount, total } = getIFDefinitionsResponse;
    const warningMessageList = hitCount > total && [
      {
        message: messageForScreen(
          ApplicationMessageScreen.APP_SCN_00176,
          total,
          hitCount,
        ),
      },
    ];

    setUnSaved(false);
    setPageState((prevState) => ({
      ...prevState,
      alertMessage: {
        ...(!!prevState.prevActionSuccessMessage && {
          successMessage: [{ message: prevState.prevActionSuccessMessage }],
        }),
        ...(!!errorMessageList && { errorMessage: errorMessageList }),
        ...(!!warningMessageList && {
          warningMessage: warningMessageList,
        }),
      },
      prevActionSuccessMessage: "",
      ifList: interfaceList,
      editedIfList: editedIfList,
      projectName: projectName,
      retentionEditedIfList: new Map<string, any>(),
    }));
  };

  const reflectIfUpdateError = (res: any) => {
    const spreadsheetData = _.cloneDeep(spreadsheetState);
    if (!spreadsheetData) return;
    const errorIfList = spreadsheetData.ifList;

    const initInformation: Information = {
      duplicatedIdList: [],
      layoutFileExistanceList: [],
      val: "",
      col: [],
    };

    res.forEach((e: any) => {
      e.message?.forEach((m: any) => {
        if (!errorIfList[e.idx].hasOwnProperty("information")) {
          errorIfList[e.idx].information = initInformation;
        }
        errorIfList[e.idx].information.val += m.val;
        errorIfList[e.idx].information.col = errorIfList[
          e.idx
        ].information.col.concat(m.col ?? []);
      });
    });
    spreadsheetData.ifList = errorIfList;
    setSpreadsheetState(spreadsheetData);
  };

  const onUpdateIfDefinitionsResponse = () => {
    if (!getUpdateIfDefinitionsResponse) return;

    // 400 response
    if (
      Array.isArray(getUpdateIfDefinitionsResponse) &&
      getUpdateIfDefinitionsResponse.length > 0
    ) {
      const currentRecords: Interface[] = spreadsheetState
        ? [...spreadsheetState.ifList]
        : [];

      const newSpreadsheetRecordData: Interface[] =
        mappingErrorResponseToSpreadsheet(
          getUpdateIfDefinitionsResponse,
          currentRecords,
          InterfaceListPageInitialState.displayColumn,
        );

      if (!spreadsheetState) return;
      setSpreadsheetState({
        ...spreadsheetState,
        ifList: newSpreadsheetRecordData,
      });
      return;
    }

    // 200 partial success response
    if (
      Array.isArray(getUpdateIfDefinitionsResponse.result) &&
      getUpdateIfDefinitionsResponse.result.length > 0
    ) {
      showAlertBar([
        {
          id: ApplicationMessageScreen.APP_SCN_00165,
          message: messageForScreen(ApplicationMessageScreen.APP_SCN_00165),
        },
      ]);

      const errorResults = getUpdateIfDefinitionsResponse.result;

      const currentRecords: Interface[] = spreadsheetState
        ? [...spreadsheetState.ifList]
        : [];

      const failedRows = errorResults
        .map((er) => {
          const ifReqId = er.ifReqId;
          const index = currentRecords.findIndex(
            (r) => r.project.ifReqId === ifReqId,
          );
          const editedRow = pageState.editedIfList.find(
            (r) => r.project.ifReqId === ifReqId,
          );
          return {
            index,
            ifReqId,
            edits: editedRow ? extractEditedCells(editedRow) : [],
            error: er,
          };
        })
        .filter((row) => row.index !== -1);

      partialRestoreRef.current = { failedRows };

      const newSpreadsheetRecordData: Interface[] =
        mappingErrorResponseToSpreadsheet(
          getUpdateIfDefinitionsResponse.result,
          currentRecords,
          InterfaceListPageInitialState.displayColumn,
        );

      if (!spreadsheetState) return;
      setSpreadsheetState({
        ...spreadsheetState,
        ifList: newSpreadsheetRecordData,
      });

      let iFDefinitionsRequest: GetIFDefinitionsRequest = {
        dfnSetVerNum: params.dfnSetVerNum,
        project: {
          pjtIds: [params.pjtId],
        },
        includeFileLayout: determineIncludeFileLayout(),
      };

      sendGetIFDefinitionsRequest(iFDefinitionsRequest);

      return;
    }

    const res: Result[] = getUpdateIfDefinitionsResponse.result ?? [];
    if (res.length === 0) {
      showToast({
        design: "completion",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
      });
      onInitialDisplayed();
      return;
    }
    reflectIfUpdateError(res);
  };

  const onUpdateIfDefinitionsGodResponse = () => {
    if (!getUpdateIfDefinitionsGodResponse) {
      return;
    }

    // 400 response
    if (
      Array.isArray(getUpdateIfDefinitionsGodResponse) &&
      getUpdateIfDefinitionsGodResponse.length > 0
    ) {
      const currentRecords: Interface[] = spreadsheetState
        ? [...spreadsheetState.ifList]
        : [];

      const newSpreadsheetRecordData: Interface[] =
        mappingErrorResponseToSpreadsheet(
          getUpdateIfDefinitionsGodResponse,
          currentRecords,
          InterfaceListPageInitialState.displayColumn,
        );

      if (!spreadsheetState) return;
      setSpreadsheetState({
        ...spreadsheetState,
        ifList: newSpreadsheetRecordData,
      });
      return;
    }

    // 200 partial success response
    if (
      Array.isArray(getUpdateIfDefinitionsGodResponse.result) &&
      getUpdateIfDefinitionsGodResponse.result.length > 0
    ) {
      showToast({
        design: "completion",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
      });

      const currentRecords: Interface[] = spreadsheetState
        ? [...spreadsheetState.ifList]
        : [];

      const newSpreadsheetRecordData: Interface[] =
        mappingErrorResponseToSpreadsheet(
          getUpdateIfDefinitionsGodResponse.result,
          currentRecords,
          InterfaceListPageInitialState.displayColumn,
        );

      if (!spreadsheetState) return;
      setSpreadsheetState({
        ...spreadsheetState,
        ifList: newSpreadsheetRecordData,
      });
      return;
    }

    const res: GodResult[] = getUpdateIfDefinitionsGodResponse.result ?? [];
    if (res.length === 0) {
      showToast({
        design: "completion",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
      });
      const pjtId = getUpdateIfDefinitionsGodResponse.pjtId;
      const href = createPath({
        pathname: `/interface-list?pjtId=${pjtId}&mode=${PAGE_MODE.GOD_MODE}&type=${PAGE_TYPE.ACTIVE_PJ_TYPE}`,
      });
      navigate(href);
      return;
    }
    reflectIfUpdateError(res);
  };

  const onUpdateIfDefinitionsReviewResponse = () => {
    if (!getUpdateIfDefinitionsReviewResponse) return;

    // 400 response
    if (
      Array.isArray(getUpdateIfDefinitionsReviewResponse) &&
      getUpdateIfDefinitionsReviewResponse.length > 0
    ) {
      const currentRecords: Interface[] = spreadsheetState
        ? [...spreadsheetState.ifList]
        : [];

      const newSpreadsheetRecordData: Interface[] =
        mappingErrorResponseToSpreadsheet(
          getUpdateIfDefinitionsReviewResponse,
          currentRecords,
          InterfaceListPageInitialState.displayColumn,
        );

      if (!spreadsheetState) return;
      setSpreadsheetState({
        ...spreadsheetState,
        ifList: newSpreadsheetRecordData,
      });
      return;
    }

    // 200 partial success response
    if (
      Array.isArray(getUpdateIfDefinitionsReviewResponse.result) &&
      getUpdateIfDefinitionsReviewResponse.result.length > 0
    ) {
      showAlertBar([
        {
          id: ApplicationMessageScreen.APP_SCN_00165,
          message: messageForScreen(ApplicationMessageScreen.APP_SCN_00165),
        },
      ]);

      const currentRecords: Interface[] = spreadsheetState
        ? [...spreadsheetState.ifList]
        : [];

      const newSpreadsheetRecordData: Interface[] =
        mappingErrorResponseToSpreadsheet(
          getUpdateIfDefinitionsReviewResponse.result,
          currentRecords,
          InterfaceListPageInitialState.displayColumn,
        );

      if (!spreadsheetState) return;
      setSpreadsheetState({
        ...spreadsheetState,
        ifList: newSpreadsheetRecordData,
      });
      return;
    }

    const res = getUpdateIfDefinitionsReviewResponse?.result ?? [];
    if (res.length === 0) {
      showToast({
        design: "completion",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
      });
      sendGetIFDefinitionsRequest({
        dfnSetVerNum: params.dfnSetVerNum,
        project: {
          pjtIds: [params.pjtId],
          dsgnTcktStsTypeCds: [
            TcktStsTypeIfDsgn.DESIGN_REVIEW,
            TcktStsTypeIfDsgn.DESIGN_APPROVED,
          ],
        },
        includeFileLayout: determineIncludeFileLayout(),
      });

      refreshReviewDiff();

      return;
    }
    const spreadsheetData = _.cloneDeep(spreadsheetState);
    if (!spreadsheetData) return;
    const errorIfList = spreadsheetData.ifList;
    res.forEach((e) => {
      e.messageList?.forEach((m) => {
        if (!errorIfList[e.index].hasOwnProperty("information")) {
          errorIfList[e.index].information = {} as Information;
        }
        errorIfList[e.index].information.val += m.val;
        errorIfList[e.index].information.col = errorIfList[
          e.index
        ].information.col.concat(m.col ?? []);
      });
    });
    spreadsheetData.ifList = errorIfList;
    setSpreadsheetState(spreadsheetData);
  };

  const onGetProjectsResponse = () => {
    if (!pageState.interfaceListGeneralCodeState.tcktStsTypePrjPrgrs) return;
    const activePjtStsName =
      pageState.interfaceListGeneralCodeState?.tcktStsTypePrjPrgrs
        .filter(
          (gcd) =>
            gcd.value === TcktStsTypePrjPrgrs.PROJECT_IN_PROGRESS ||
            gcd.value === TcktStsTypePrjPrgrs.CHANGING_IF_REQUIREMENTS ||
            gcd.value === TcktStsTypePrjPrgrs.ASSIGNING_STAKEHOLDERS,
        )
        .map((gcd) => gcd.label);

    const res = getProjectsResponse?.pjtList ?? [];
    if (res.length === 0) {
      return;
    }
    const pjtIds: string[] = [];
    res.forEach((e) => {
      if (!activePjtStsName.includes(e.wkFlwStsName)) return;
      pjtIds.push(e.pjtId);
    });
    sendGetIFDefinitionsRequest({
      dfnSetVerNum: params.dfnSetVerNum,
      project: {
        pjtIds: pjtIds,
        ...(!!searchForm.srcDipByRgnOrDip && {
          srcDipByRgnOrDip: searchForm.srcDipByRgnOrDip,
        }),
        ...(!!searchForm.srcIfId && { srcIfId: searchForm.srcIfId }),
        ...(!!searchForm.srcInbdId && { srcInbdId: searchForm.srcInbdId }),
        ...(!!searchForm.srcInbdCpntId && {
          srcInbdCpntId: searchForm.srcInbdCpntId,
        }),
        ...(!!searchForm.dstDipByRgnOrDip && {
          dstDipByRgnOrDip: searchForm.dstDipByRgnOrDip,
        }),
        ...(!!searchForm.dstIfId && { dstIfId: searchForm.dstIfId }),
        ...(!!searchForm.dstOtbdId && { dstOtbdId: searchForm.dstOtbdId }),
        ...(!!searchForm.dstOtbdCpntId && {
          dstOtbdCpntId: searchForm.dstOtbdCpntId,
        }),
        ...(!!searchForm.interfaceNameEnglish && {
          interfaceNameEnglish: searchForm.interfaceNameEnglish,
        }),
        ...(!!searchForm.interfaceNameJapanese && {
          interfaceNameJapanese: searchForm.interfaceNameJapanese,
        }),
        andCondDip: true,
        andCondIfId: true,
        andCondInOtbdId: true,
        andCondInOtbdCpntId: true,
      },
      includeFileLayout: determineIncludeFileLayout(),
    });
  };

  // To authorize Issuing File ID button
  const onGetAuthdActionItemsResponse = () => {
    if (!authdActionItems) return;
    let isSaveAuth = false;
    switch (params.mode) {
      case PAGE_MODE.INPUT_MODE:
        isSaveAuth = isDisplayedAction(
          "interface_list_input.button.input_save",
        );
        break;
      case PAGE_MODE.REVIEW_MODE:
        isSaveAuth = isDisplayedAction(
          "interface_list_review.button.review_save",
        );
        break;
      case PAGE_MODE.GOD_MODE:
        isSaveAuth = isDisplayedAction("interface_list_god.button.god_save");
        break;
    }
    setPageState((prevState) => ({
      ...prevState,
      authorized: true,
      isSaveAuth: isSaveAuth,
    }));
  };

  // Method of merge between Objects.
  const mergeDeeply = (target: any, source: any) => {
    const isObject = (obj: any) => {
      return obj && typeof obj === "object" && !Array.isArray(obj);
    };
    let result = Object.assign({}, target);
    if (isObject(target) && isObject(source)) {
      for (const [sourceKey, sourceValue] of Object.entries(source)) {
        const targetValue = target[sourceKey];
        if (Array.isArray(sourceValue) && Array.isArray(targetValue)) {
          result[sourceKey] = targetValue.concat(...sourceValue);
        } else if (isObject(sourceValue) && target.hasOwnProperty(sourceKey)) {
          result[sourceKey] = mergeDeeply(targetValue, sourceValue);
        } else {
          Object.assign(result, { [sourceKey]: sourceValue });
        }
      }
    }
    return result;
  };

  // Convert If Definitions History.
  const convIfHistory = (
    ifItem: any,
    tempIf: any,
    diffFlg: boolean,
    ifProp: any,
  ) => {
    if (!ifItem[1]) {
      // Skip, if ifItem is null.
      return tempIf;
    }
    if (!_.isObject(ifItem[1]) || ifItem[1].hasOwnProperty("diffFlg")) {
      let ifProperty = "";
      let closeBracket = "";
      ifProp.forEach((e: string) => {
        ifProperty = ifProperty + "{" + '"' + e + '"' + ":";
        closeBracket = closeBracket + "}";
      });
      const value = ifItem[1].hasOwnProperty("diffFlg")
        ? ifItem[1].value
        : ifItem[1];
      const diffObject = JSON.stringify({ diffFlg: diffFlg, value: value });
      ifProperty =
        ifProperty + '{"' + ifItem[0] + '":' + diffObject + closeBracket + "}";
      tempIf = mergeDeeply(JSON.parse(ifProperty), tempIf);
    } else {
      ifProp.push(ifItem[0]);
      Object.entries(ifItem[1]).forEach((e) => {
        tempIf = convIfHistory(e, tempIf, diffFlg, ifProp);
      });
      ifProp.pop();
    }
    return tempIf;
  };

  const onGetIFDefinitionHistoryResponse = () => {
    if (!getIFDefinitionHistoryResponse) return;
    const ifHistoryResponse = getIFDefinitionHistoryResponse?.ifList ?? [];

    const ifHistoryList = [] as any;
    for (let i = 0; ifHistoryResponse.length > i; i++) {
      let ifHistory = {} as any;
      let prevSeq = {} as any;
      let thisSeq = {} as any;
      if (i === 0) {
        // First Sequence IF Definitions.
        Object.entries(ifHistoryResponse[i]).forEach((ifItem) => {
          ifHistory = convIfHistory(ifItem, ifHistory, false, []);
        });
      } else {
        // Get previous Sequence IF Definitions.
        Object.entries(ifHistoryList[i - 1]).forEach((ifItem) => {
          prevSeq = convIfHistory(ifItem, prevSeq, false, []);
        });
        // Get this Sequence IF Definitions.
        Object.entries(ifHistoryResponse[i]).forEach((ifItem) => {
          thisSeq = convIfHistory(ifItem, thisSeq, true, []);
        });
        // Create IF Definitions with diffFlg:true in data with difference
        ifHistory = mergeDeeply(prevSeq, thisSeq);
      }
      ifHistory.delFlg = false;
      ifHistoryList.push(ifHistory);
    }
    const errorMessageList =
      ifHistoryList.length === 0
        ? [
            {
              message: messageForScreen(
                ApplicationMessageScreen.APP_SCN_00125,
                "Interface",
              ),
            },
          ]
        : createIFAlertMessageList(params.mode, pageState.isPendingDisplay);
    setPageState((prevState) => ({
      ...prevState,
      ifList: ifHistoryList,
      alertMessage: {
        ...prevState.alertMessage,
        errorMessage: errorMessageList,
      },
    }));
  };

  const onGetIfBulkUpdateTicketsResponse = () => {
    if (!getIfBulkUpdateTicketsResponse) return;
    // 400 response
    if (
      Array.isArray(getIfBulkUpdateTicketsResponse) &&
      getIfBulkUpdateTicketsResponse.length > 0
    ) {
      const currentRecords: Interface[] = spreadsheetState
        ? [...spreadsheetState.ifList]
        : [];

      const newSpreadsheetRecordData: Interface[] =
        mappingErrorResponseToSpreadsheet(
          getIfBulkUpdateTicketsResponse,
          currentRecords,
          InterfaceListPageInitialState.displayColumn,
        );

      if (!spreadsheetState) return;
      setSpreadsheetState({
        ...spreadsheetState,
        ifList: newSpreadsheetRecordData,
      });
      return;
    }

    // 200 partial success response
    if (
      Array.isArray(getIfBulkUpdateTicketsResponse.result) &&
      getIfBulkUpdateTicketsResponse.result.length > 0
    ) {
      showAlertBar([
        {
          id: ApplicationMessageScreen.APP_SCN_00165,
          message: messageForScreen(ApplicationMessageScreen.APP_SCN_00165),
        },
      ]);
      const currentRecords: Interface[] = spreadsheetState
        ? [...spreadsheetState.ifList]
        : [];

      const newSpreadsheetRecordData: Interface[] =
        mappingErrorResponseToSpreadsheet(
          getIfBulkUpdateTicketsResponse.result,
          currentRecords,
          InterfaceListPageInitialState.displayColumn,
        );

      if (!spreadsheetState) return;
      setSpreadsheetState({
        ...spreadsheetState,
        ifList: newSpreadsheetRecordData,
      });
      return;
    }

    const res: Result[] = getIfBulkUpdateTicketsResponse.result ?? [];
    if (res.length === 0) {
      showToast({
        design: "completion",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
      });
      onInitialDisplayed();
    }
  };

  const onGetIfBulkUpdateTicketsReEnterAttributesResponse = () => {
    if (Array.isArray(getIfBulkUpdateTicketsReEnterAttributesResponse)) {
      const currentRecords: Interface[] = spreadsheetState
        ? [...spreadsheetState.ifList]
        : [];

      const newSpreadsheetRecordData: Interface[] =
        mappingErrorResponseToSpreadsheet(
          getIfBulkUpdateTicketsReEnterAttributesResponse,
          currentRecords,
          InterfaceListPageInitialState.displayColumn,
        );

      if (!spreadsheetState) return;
      setSpreadsheetState({
        ...spreadsheetState,
        ifList: newSpreadsheetRecordData,
      });
      return;
    }
    if (!!getIfBulkUpdateTicketsReEnterAttributesResponse) {
      showToast({
        design: "completion",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
      });
      changeMode(PAGE_MODE.INPUT_MODE);
    }
  };

  const onGetBulkUpdateTicketsOfIfAttributeDesignReview = () => {
    if (!getBulkUpdateTicketsOfIfAttributeDesignReviewResponse) return;
    // 400 response
    if (
      Array.isArray(getBulkUpdateTicketsOfIfAttributeDesignReviewResponse) &&
      getBulkUpdateTicketsOfIfAttributeDesignReviewResponse.length > 0
    ) {
      const currentRecords: Interface[] = spreadsheetState
        ? [...spreadsheetState.ifList]
        : [];

      const newSpreadsheetRecordData: Interface[] =
        mappingErrorResponseToSpreadsheet(
          getBulkUpdateTicketsOfIfAttributeDesignReviewResponse,
          currentRecords,
          InterfaceListPageInitialState.displayColumn,
        );

      if (!spreadsheetState) return;
      setSpreadsheetState({
        ...spreadsheetState,
        ifList: newSpreadsheetRecordData,
      });
      return;
    }

    // 200 partial success response
    if (
      Array.isArray(
        getBulkUpdateTicketsOfIfAttributeDesignReviewResponse.result,
      ) &&
      getBulkUpdateTicketsOfIfAttributeDesignReviewResponse.result.length > 0
    ) {
      showAlertBar([
        {
          id: ApplicationMessageScreen.APP_SCN_00165,
          message: messageForScreen(ApplicationMessageScreen.APP_SCN_00165),
        },
      ]);
      const currentRecords: Interface[] = spreadsheetState
        ? [...spreadsheetState.ifList]
        : [];

      const newSpreadsheetRecordData: Interface[] =
        mappingErrorResponseToSpreadsheet(
          getBulkUpdateTicketsOfIfAttributeDesignReviewResponse.result,
          currentRecords,
          InterfaceListPageInitialState.displayColumn,
        );

      if (!spreadsheetState) return;
      setSpreadsheetState({
        ...spreadsheetState,
        ifList: newSpreadsheetRecordData,
      });
      return;
    }

    const res: ErrorSpreadsheetResult[] =
      getBulkUpdateTicketsOfIfAttributeDesignReviewResponse.result ?? [];
    if (res.length === 0) {
      showToast({
        design: "completion",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
      });
      onInitialDisplayed();
    }
  };

  const onGetIfDefinitionCommonValidationResultResponse = () => {
    if (getIfDefinitionCommonValidationResultResponse === undefined) return;

    // 400 response
    if (
      Array.isArray(getIfDefinitionCommonValidationResultResponse) &&
      getIfDefinitionCommonValidationResultResponse.length > 0
    ) {
      validateErrorHandling(getIfDefinitionCommonValidationResultResponse);
      return;
    }
    // 200 partial success response
    if (
      Array.isArray(getIfDefinitionCommonValidationResultResponse.result) &&
      getIfDefinitionCommonValidationResultResponse.result.length > 0
    ) {
      validatePartialErrorHandling(
        getIfDefinitionCommonValidationResultResponse,
      );
      return;
    }
    const res: ErrorSpreadsheetResult[] =
      getIfDefinitionCommonValidationResultResponse.result ?? [];
    if (res.length === 0) {
      showToast({
        design: "completion",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00182),
      });
      return;
    }
  };

  const onGetIfDefinitionGodValidationResultResponse = () => {
    if (getIfDefinitionGodValidationResultResponse === undefined) return;
    // clear errorMessage
    const currentSpreadsheetRow: InterfaceSpreadsheetRow[] = spreadsheetState
      ? [...spreadsheetState.ifList]
      : [];
    currentSpreadsheetRow.forEach((ifList) => {
      ifList.errorMessage = "";
    });
    // 400 response
    if (
      Array.isArray(getIfDefinitionGodValidationResultResponse) &&
      getIfDefinitionGodValidationResultResponse.length > 0
    ) {
      validateErrorHandling(getIfDefinitionGodValidationResultResponse);
      showToast({
        design: "alert",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00182),
      });
      return;
    }
    // 200 partial success response
    if (
      Array.isArray(getIfDefinitionGodValidationResultResponse.result) &&
      getIfDefinitionGodValidationResultResponse.result.length > 0
    ) {
      validatePartialErrorHandling(getIfDefinitionGodValidationResultResponse);
      showToast({
        design: "alert",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00182),
      });
      return;
    }
    const res: ErrorSpreadsheetResult[] =
      getIfDefinitionGodValidationResultResponse.result ?? [];
    if (res.length === 0) {
      changeMode(PAGE_MODE.STG_DPLYMNT_MODE);
      return;
    }
  };

  /**
   * Map the error of validate to spreadSheet when response code is 400.
   */
  const validateErrorHandling = (
    validateResponse: GetIfDefinitionCommonValidationResultResponse,
  ) => {
    const currentSpreadsheetRow: InterfaceSpreadsheetRow[] = spreadsheetState
      ? [...spreadsheetState.ifList]
      : [];

    const newSpreadsheetRow = mappingErrorResponseToSpreadsheet(
      validateResponse,
      currentSpreadsheetRow,
      InterfaceListPageInitialState.displayColumn,
    );

    if (!spreadsheetState) return;
    setSpreadsheetState({
      ...spreadsheetState,
      ifList: [...newSpreadsheetRow],
    });
  };

  /**
   * Map the error of validate to spreadSheet when response code is 200.
   */
  const validatePartialErrorHandling = (
    validateResponse: GetIfDefinitionCommonValidationResultResponse,
  ) => {
    const currentSpreadsheetRow: InterfaceSpreadsheetRow[] = spreadsheetState
      ? [...spreadsheetState.ifList]
      : [];

    const indexMappedResponseResult = validateResponse.result.map((e: any) => ({
      ...e,
      index: currentSpreadsheetRow.find((s) => s.project.ifReqId === e.ifReqId)
        ?.idx,
    }));
    const newSpreadsheetRow = mappingErrorResponseToSpreadsheet(
      indexMappedResponseResult,
      currentSpreadsheetRow,
      InterfaceListPageInitialState.displayColumn,
    );

    if (!spreadsheetState) return;
    setSpreadsheetState({
      ...spreadsheetState,
      ifList: [...newSpreadsheetRow],
    });
  };

  const onCreateFileLayoutResponse = () => {
    if (!getCreateFileLayoutResponse) return;
    showToast({
      design: "completion",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
    });
    sendGetDataKindRequest({});
    setUnSaved(true);
  };

  useEffect(onInitialDisplayed, []);
  useEffect(onChangePjtIdParam, [params.pjtId]);
  useEffect(onGetIFDefinitionsResponse, [getIFDefinitionsResponse]);
  useEffect(onGetGeneralCodesResponse, [getGeneralCodesResponse]);
  useEffect(createDipByRgnOrDipList, [
    getDipByRegionListResponse,
    getDipListResponse,
  ]);
  useEffect(onGetDipByRegionListResponse, [getDipByRegionListResponse]);
  useEffect(onGetEdhNotificationTypeList, [getEdhNotificationTypeListResponse]);
  useEffect(onGetEdhProtocolListResponse, [
    getEdhProtocolListResponse,
    getGodEdhProtocolListResponse,
  ]);
  useEffect(onGetEdiChainTypeListResponse, [
    getEdiChainTypeListResponse,
    getGodEdiChainTypeListResponse,
  ]);
  useEffect(onCreateFileLayoutResponse, [getCreateFileLayoutResponse]);
  useEffect(onGetDataKindResponse, [getDataKindResponse]);
  useEffect(onGetIFDefinitionHistoryResponse, [getIFDefinitionHistoryResponse]);
  useEffect(onUpdateIfDefinitionsResponse, [getUpdateIfDefinitionsResponse]);
  useEffect(onUpdateIfDefinitionsGodResponse, [
    getUpdateIfDefinitionsGodResponse,
  ]);
  useEffect(onUpdateIfDefinitionsReviewResponse, [
    getUpdateIfDefinitionsReviewResponse,
  ]);
  useEffect(onGetProjectsResponse, [
    getProjectsResponse,
    pageState.interfaceListGeneralCodeState,
  ]);
  useEffect(onGetAuthdActionItemsResponse, [authdActionItems]);
  useEffect(onGetIfBulkUpdateTicketsResponse, [getIfBulkUpdateTicketsResponse]);
  useEffect(onGetIfBulkUpdateTicketsReEnterAttributesResponse, [
    getIfBulkUpdateTicketsReEnterAttributesResponse,
  ]);
  useEffect(onGetBulkUpdateTicketsOfIfAttributeDesignReview, [
    getBulkUpdateTicketsOfIfAttributeDesignReviewResponse,
  ]);

  useEffect(onGetIfDefinitionCommonValidationResultResponse, [
    getIfDefinitionCommonValidationResultResponse,
  ]);
  useEffect(onGetIfDefinitionGodValidationResultResponse, [
    getIfDefinitionGodValidationResultResponse,
  ]);

  useEffect(() => {
    if (params.mode === PAGE_MODE.REF_MODE) {
      if (pageState.isHistoryDisplay) return;

      switch (params.type) {
        case PAGE_TYPE.ACTIVE_PJ_TYPE:
          changeHeaderTitle("Interface List ( Active Projects )");
          break;
        case PAGE_TYPE.PRD_PJ_TYPE:
          changeHeaderTitle("Interface List ( Environment: PRD )");
          break;
        case PAGE_TYPE.STG_PJ_TYPE:
          changeHeaderTitle("Interface List ( Environment: STG )");
          break;
        default:
          changeHeaderTitle("Interface List ( Environment: PRD )");
          break;
      }
    } else {
      setAppState((prevState) => ({
        ...prevState,
        title: `Interface List${
          pageState.projectName
            ? " ( Project Name: " + pageState.projectName + " )"
            : ""
        }`,
        isGodMode: params.mode === PAGE_MODE.GOD_MODE,
        ...(!!params.pjtId && { pjtId: params.pjtId }),
      }));
    }
  }, [
    params.mode,
    params.type,
    pageState.projectName,
    pageState.isHistoryDisplay,
  ]);

  const changeHeaderTitle = (title: string) => {
    setAppState((prevState) => ({
      ...prevState,
      title: title,
    }));
  };

  const filterIfListByScreenMode = (mode: String, ifList: GetIfList[]) => {
    switch (mode) {
      // Design Review mode.
      case PAGE_MODE.REVIEW_MODE:
        return ifList.filter((e) => {
          // JDI-2423  Both SRC and DST will not be displayed if the design review is complete or the STG transfer status is other than Waiting Request Plan.
          const tckt = e.projectTcktInfo;
          if (
            // SRC
            tckt.srcDsgnTcktStsTypeCd === TcktStsTypeIfDsgn.DESIGN_APPROVED &&
            tckt.srcStgDplymntTcktStsTypeCd !==
              TcktStsTypeIfPrdDplymnt.REQUEST_PLANNING &&
            tckt.dstDsgnTcktStsTypeCd === TcktStsTypeIfDsgn.DESIGN_APPROVED &&
            tckt.dstStgDplymntTcktStsTypeCd !==
              TcktStsTypeIfPrdDplymnt.REQUEST_PLANNING
          ) {
            console.log(
              `${e.project.ifReqId} is not display. srcStgDplyStatus[${tckt.srcStgDplymntWFlwStsDsplyName}] dstStgDplyStatus[${tckt.dstStgDplymntWFlwStsDsplyName}]`,
            );
            return false;
          } else {
            return true;
          }
        });
      // STG Deployment Request mode.
      case PAGE_MODE.STG_DPLYMNT_MODE:
        return ifList.filter((e) => {
          // JDI-2423 Both SRC and DST, the status after Cancel transfer is completed is not displayed.
          const tckt = e.projectTcktInfo;
          if (
            // SRC
            tckt.srcStgDplymntTcktStsTypeCd ===
              TcktStsTypeIfStgDplymnt.DEPLOYED &&
            tckt.srcPrdDplymntTcktStsTypeCd ===
              TcktStsTypeIfPrdDplymnt.CANCELLED &&
            tckt.dstStgDplymntTcktStsTypeCd ===
              TcktStsTypeIfStgDplymnt.DEPLOYED &&
            tckt.dstPrdDplymntTcktStsTypeCd ===
              TcktStsTypeIfPrdDplymnt.CANCELLED
          ) {
            console.log(
              `${e.project.ifReqId} is not display . srcPrdDplymntTcktStsTypeCd[${tckt.srcPrdDplymntTcktStsTypeCd}] dstPrdDplymntTcktStsTypeCd[${tckt.dstPrdDplymntTcktStsTypeCd}]`,
            );
            return false;
          } else {
            return true;
          }
        });

      default:
        return ifList;
    }
  };

  const openDeploymentDialog = () => {
    if (!spreadsheetState) return;

    const ifList: CreateIfList[] = spreadsheetState.ifList.flatMap((e) => {
      const ifInfoData = {
        interfaceRequirementId: e.project.ifReqId,
        updateDTimeTIfReq: e.updateDateTime,
      };
      const isInternalDIP =
        e.src.interfaceDefinition.dipByRegion ===
        e.dst.interfaceDefinition.dipByRegion;

      let resultIfList: CreateIfList[] = [];

      if (isInternalDIP) {
        resultIfList.push({
          ...ifInfoData,
          srcDstType: SrcDstTypeCd.DIP_INTERNAL_DESTINATION,
          tcktId:
            params.mode === PAGE_MODE.STG_DPLYMNT_MODE
              ? e.projectTcktInfo.dstStgDplymntTcktId
              : e.projectTcktInfo.dstPrdDplymntTcktId,
          interruptType: shouldSetInterruptType(
            e,
            SrcDstTypeCd.DIP_INTERNAL_DESTINATION,
            false,
          )
            ? e.dstInterruptType
            : InterruptType.NOCHANGE,
        });
        return resultIfList;
      }

      if (params.mode === PAGE_MODE.STG_DPLYMNT_MODE) {
        if (!!e.srcDipSelect && !!e.dstDipSelect) {
          resultIfList.push({
            ...ifInfoData,
            srcDstType: SrcDstTypeCd.INTERDOMAIN_SOURCE,
            tcktId: e.projectTcktInfo.srcStgDplymntTcktId,
            interruptType: shouldSetInterruptType(
              e,
              SrcDstTypeCd.INTERDOMAIN_SOURCE,
              !!e.srcDipSelect && !!!e.dstDipSelect,
            )
              ? e.srcInterruptType
              : InterruptType.NOCHANGE,
          });
        }
        if (!!e.srcDipSelect && !e.dstDipSelect) {
          resultIfList.push({
            ...ifInfoData,
            srcDstType: SrcDstTypeCd.INTERDOMAIN_SOURCE,
            tcktId: e.projectTcktInfo.srcStgDplymntTcktId,
            interruptType: shouldSetInterruptType(
              e,
              SrcDstTypeCd.INTERDOMAIN_SOURCE,
              !!e.srcDipSelect && !!!e.dstDipSelect,
            )
              ? e.srcInterruptType
              : InterruptType.NOCHANGE,
          });
        }
        if (!!e.dstDipSelect) {
          resultIfList.push({
            ...ifInfoData,
            srcDstType: SrcDstTypeCd.INTERDOMAIN_DESTINATION,
            tcktId: e.projectTcktInfo.dstStgDplymntTcktId,
            interruptType: shouldSetInterruptType(
              e,
              SrcDstTypeCd.INTERDOMAIN_DESTINATION,
              !!e.srcDipSelect && !!!e.dstDipSelect,
            )
              ? e.dstInterruptType
              : InterruptType.NOCHANGE,
          });
        }
      } else if (params.mode === PAGE_MODE.PRD_DPLYMNT_MODE) {
        if (!!e.srcDipSelect) {
          resultIfList.push(
            {
              ...ifInfoData,
              srcDstType: SrcDstTypeCd.INTERDOMAIN_SOURCE,
              tcktId: e.projectTcktInfo.srcPrdDplymntTcktId,
              interruptType: shouldSetInterruptType(
                e,
                SrcDstTypeCd.INTERDOMAIN_SOURCE,
                false,
              )
                ? e.srcInterruptType
                : InterruptType.NOCHANGE,
            },
            {
              ...ifInfoData,
              srcDstType: SrcDstTypeCd.INTERDOMAIN_DESTINATION,
              tcktId: e.projectTcktInfo.dstPrdDplymntTcktId,
              interruptType: shouldSetInterruptType(
                e,
                SrcDstTypeCd.INTERDOMAIN_DESTINATION,
                false,
              )
                ? e.dstInterruptType
                : InterruptType.NOCHANGE,
            },
          );
        }
      }

      return resultIfList;
    });
    const createifListMap: CreateIfListMap[] = [
      {
        pjtId: spreadsheetState.ifList[0].project.pjtId,
        ifList,
      },
    ];

    const dialogState: DeploymentRequestInfomationInputDialogState = {
      ...DeploymentRequestInfomationInputDialogInitialState,
      dplymntReqType: DeploymentRequestType.INTERFACE,
      processTyp:
        params.mode === PAGE_MODE.PRD_DPLYMNT_MODE
          ? EnvTypeCd.PRD
          : EnvTypeCd.STG,
      deploymentRequestList: [],
      createifListMap,
      componentMap: [],
      isShow: true,
    };

    setDeploymentRequestInfomationInputDialogState(dialogState);
  };

  const transitionHandle =
    (mode: string, type?: string) => (_event: CustomEvent) => {
      const pathParam = !type ? `mode=${mode}` : `mode=${mode}&type=${type}`;
      const href = createPath({
        pathname: `/interface-list?pjtId=${params.pjtId}&${pathParam}`,
      });
      navigate(href);
    };

  const changeMode = (mode: string, type?: string) => {
    const pathParam = !type ? `mode=${mode}` : `mode=${mode}&type=${type}`;
    const href = createPath({
      pathname: `/interface-list?pjtId=${params.pjtId}&${pathParam}`,
    });
    navigate(href);
  };

  const reloadWindow = () => {
    window.location.reload();
  };

  const editIfCell = (
    newSpreadsheetRow: any,
    newEditedIfRow: any,
    ifProperty: string,
    isChanged: boolean,
    inputValue: string,
  ) => {
    // Convert label to code for retentionPeriodDays.
    inputValue = convertRetentionPeriodDaysCode(ifProperty, inputValue);

    let initValue = "";
    const editedTarget = _.get(newEditedIfRow, ifProperty);
    if (editedTarget && editedTarget.hasOwnProperty("initValue")) {
      initValue = editedTarget.initValue;
    } else {
      initValue = editedTarget || "";
    }
    const editedValue = isChanged
      ? {
          initValue: initValue,
          editedFlg: isChanged,
          value: inputValue,
          cmplCntnt: ifProperty,
        }
      : initValue;
    _.set(newSpreadsheetRow, ifProperty, inputValue);
    _.set(newEditedIfRow, ifProperty, editedValue);

    // when changing InterDomainID
    if (ifProperty === "src.interfaceDefinition.outbound.outboundId") {
      const dstIfProperty = "dst.interfaceDefinition.inbound.inboundId";
      const editedTarget = _.get(newEditedIfRow, dstIfProperty);

      if (editedTarget && editedTarget.hasOwnProperty("initValue")) {
        initValue = editedTarget.initValue;
      } else {
        initValue = editedTarget || "";
      }
      const editedValue = isChanged
        ? {
            initValue: initValue,
            editedFlg: isChanged,
            value: inputValue,
            cmplCntnt: dstIfProperty,
          }
        : initValue;
      _.set(newSpreadsheetRow, dstIfProperty, inputValue);
      _.set(newEditedIfRow, dstIfProperty, editedValue);
    }
    // when changing InterDomainID Optional Part
    if (
      ifProperty === "src.interfaceDefinition.outbound.outboundIdOptionalPart"
    ) {
      const dstIfProperty =
        "dst.interfaceDefinition.inbound.inboundIdOptionalPart";
      const editedTarget = _.get(newEditedIfRow, dstIfProperty);

      if (editedTarget && editedTarget.hasOwnProperty("initValue")) {
        initValue = editedTarget.initValue;
      } else {
        initValue = editedTarget || "";
      }
      const editedValue = isChanged
        ? {
            initValue: initValue,
            editedFlg: isChanged,
            value: inputValue,
            cmplCntnt: dstIfProperty,
          }
        : initValue;
      _.set(newSpreadsheetRow, dstIfProperty, inputValue);
      _.set(newEditedIfRow, dstIfProperty, editedValue);
    }

    return {
      newSpreadsheetRow: newSpreadsheetRow,
      newEditedIfRow: newEditedIfRow,
    };
  };

  const convertRetentionPeriodDaysCode = (
    ifProperty: string,
    inputValue: string,
  ) => {
    if (!ifProperty.endsWith("retentionPeriodValue")) {
      return inputValue;
    }
    // Label > Code
    const codeVal =
      pageState.interfaceListGeneralCodeState.retentionPeriodDays.find(
        (e) => e.label === inputValue,
      )?.value;
    if (codeVal) {
      return codeVal;
    } else {
      return inputValue;
    }
  };

  const onCellEdited = (event: CustomEvent) => {
    if (!spreadsheetState) return;

    const rowIndex = event.detail.value.idx as number;
    const inputValue: string = event.detail.cell.value;
    const isChanged: boolean = event.detail.cell.isChanged;
    const eventName: string = event.detail.name;

    setFrontendValidationMessagesByRowIndex((prev) => {
      const messages = event.detail?.cell?.data?.row?.validationErrors;
      return {
        ...prev,
        [rowIndex]: Array.isArray(messages) ? messages : [],
      };
    });

    const newSpreadsheetIfList = _.cloneDeep(spreadsheetState.ifList) as any;
    const newEditedIfList = _.cloneDeep(pageState?.editedIfList || []);

    if (
      [
        PAGE_MODE.REQ_APPROVAL_MODE,
        PAGE_MODE.STG_DPLYMNT_MODE,
        PAGE_MODE.PRD_DPLYMNT_MODE,
      ].includes(params.mode)
    ) {
      if (["srcDipSelect", "dstDipSelect"].includes(eventName)) {
        const isChecked = JSON.parse(inputValue.toLowerCase());
        const idx = event.detail.cell?.data.index as number;
        newSpreadsheetIfList[idx][eventName] = isChecked;
        setSpreadsheetState({
          ...spreadsheetState,
          ifList: newSpreadsheetIfList,
        });
      }
      if (["srcInterruptType", "dstInterruptType"].includes(eventName)) {
        const editedIfList = editIfCell(
          (newSpreadsheetIfList as InterfaceSpreadsheetRow[]).find(
            (e) => rowIndex === e.idx,
          ),
          newEditedIfList.find((e) => rowIndex === e.idx),
          eventName,
          isChanged,
          inputValue,
        );

        const interruptTypeUpdatedSpreadSheetIfList = (
          newSpreadsheetIfList as InterfaceSpreadsheetRow[]
        ).map((e) => (rowIndex === e.idx ? editedIfList.newSpreadsheetRow : e));

        const interruptTypeUpdatedEditedIfList = newEditedIfList.map((e) =>
          rowIndex === e.idx ? editedIfList.newEditedIfRow : e,
        );

        setSpreadsheetState({
          ...spreadsheetState,
          ifList: interruptTypeUpdatedSpreadSheetIfList,
        });

        setPageState((prevState) => ({
          ...prevState,
          editedIfList: interruptTypeUpdatedEditedIfList,
          spreadsheetSelectedRowIndex: rowIndex,
        }));
      }
    } else if (
      [
        PAGE_MODE.INPUT_MODE,
        PAGE_MODE.REVIEW_MODE,
        PAGE_MODE.GOD_MODE,
      ].includes(params.mode)
    ) {
      const editedIfList = editIfCell(
        newSpreadsheetIfList[rowIndex],
        newEditedIfList[rowIndex],
        eventName,
        isChanged,
        inputValue,
      );

      newSpreadsheetIfList[rowIndex] = editedIfList.newSpreadsheetRow;
      newEditedIfList[rowIndex] = editedIfList.newEditedIfRow;
      setSpreadsheetState({
        ...spreadsheetState,
        ifList: newSpreadsheetIfList,
      });
      setPageState((prevState) => ({
        ...prevState,
        editedIfList: newEditedIfList,
        spreadsheetSelectedRowIndex: rowIndex,
      }));
      if (
        ![
          "srcAction",
          "dstAction",
          "projectTcktInfo.srcDsgnCmnt",
          "projectTcktInfo.dstDsgnCmnt",
        ].includes(eventName)
      ) {
        setUnSaved(true);
      }
    }
  };

  const onCellBulkEdited = (event: CustomEvent) => {
    if (!spreadsheetState) return;
    const eventName: string = event.detail.name;
    const newSpreadsheetIfList = _.cloneDeep(
      spreadsheetState?.ifList,
    ) as InterfaceSpreadsheetRow[];
    const newEditedIfList = _.cloneDeep(pageState?.editedIfList || []);
    if (
      ["srcDipSelectAll", "dstDipSelectAll", "interruptTypeAll"].includes(
        eventName,
      )
    ) {
      event.detail.affectedCells.cells.forEach((cell: Cell) => {
        const data = newSpreadsheetIfList.find((v) => v.idx == cell.data.index);
        if (!data) return;
        const value: string = event.detail.cell.value;
        const isChecked = JSON.parse(value.toLowerCase());
        // When IF is DIP INTERNAL and either src or dst requirementType is NoChange,
        // src or dst IF Design ticket does not exist.
        // However, in DIP INTERNAL the deployment ticket (only one for src and dst together)
        // always exists except when src and dst are both NoChange.

        // In INTER DIP (CROSS DIP) the deployment ticket always exists
        // even if the requiement type is NoChange.
        // Because JDI batch expects that deployment ticket exists to
        // deploy src.OutboundId or dst.InboundId even if the requiement type is NoChage.
        if (eventName === "srcDipSelectAll") {
          switch (params.mode) {
            case PAGE_MODE.REQ_APPROVAL_MODE:
              if (!!data.projectTcktInfo.srcDsgnTcktId) {
                data.srcDipSelect = isChecked;
              }
              break;
            case PAGE_MODE.STG_DPLYMNT_MODE:
              data.srcDipSelect = isChecked;
              break;
            case PAGE_MODE.PRD_DPLYMNT_MODE:
              data.srcDipSelect = isChecked;
              break;
          }
        } else if (eventName === "dstDipSelectAll") {
          switch (params.mode) {
            case PAGE_MODE.REQ_APPROVAL_MODE:
              if (!!data.projectTcktInfo.dstDsgnTcktId) {
                data.dstDipSelect = isChecked;
              }
              break;
            case PAGE_MODE.STG_DPLYMNT_MODE:
              if (
                data.src.interfaceDefinition.dipByRegion !==
                data.dst.interfaceDefinition.dipByRegion
              ) {
                data.dstDipSelect = isChecked;
              }
              break;
            case PAGE_MODE.PRD_DPLYMNT_MODE:
              break;
          }
        }
      });
      setSpreadsheetState({
        ...spreadsheetState,
        ifList: newSpreadsheetIfList,
      });
    } else {
      event.detail.affectedCells.cells.forEach((item: Cell) => {
        const value: string = item.value;
        const editedIfList = editIfCell(
          newSpreadsheetIfList[item.data.index],
          newEditedIfList[item.data.index],
          event.detail.name,
          item.isChanged,
          value,
        );
        newSpreadsheetIfList[item.data.index] =
          editedIfList.newSpreadsheetRow as InterfaceSpreadsheetRow;
        newEditedIfList[item.data.index] = editedIfList.newEditedIfRow;
      });
    }
    setSpreadsheetState({
      ...spreadsheetState,
      ifList: newSpreadsheetIfList,
    });
    setPageState({
      ...pageState,
      editedIfList: newEditedIfList,
    });
    if (
      ![
        "srcAction",
        "dstAction",
        "projectTcktInfo.srcDsgnCmnt",
        "projectTcktInfo.dstDsgnCmnt",
      ].includes(eventName)
    ) {
      setUnSaved(true);
    }
  };

  const handleSpreadsheetAreaClickCapture = (
    event: React.MouseEvent<HTMLDivElement>,
  ) => {
    const isTooltipClick =
      event.nativeEvent
        .composedPath?.()
        .some(
          (target) =>
            target instanceof Element &&
            target.matches('[data-diff-tooltip="true"]'),
        ) ?? false;

    if (isTooltipClick) {
      return;
    }
    queueMicrotask(closeTooltip);
  };

  const getClickedRowIndex = (
    clickedRow: InterfaceSpreadsheetRow | undefined,
    detail: any,
  ): number | undefined => {
    const candidates = [
      detail?.cell?.data?.index,
      clickedRow?.idx,
      detail?.value?.idx,
    ];

    const found = candidates.find((value) => {
      const num = Number(value);
      return Number.isInteger(num) && num >= 0;
    });

    if (found !== undefined) {
      return Number(found);
    }

    if (!clickedRow || !spreadsheetState?.ifList) {
      return undefined;
    }

    const indexByIfReqId = spreadsheetState.ifList.findIndex(
      (row) => row.project?.ifReqId === clickedRow.project?.ifReqId,
    );

    return indexByIfReqId >= 0 ? indexByIfReqId : undefined;
  };

  const onCellClicked = (event: CustomEvent) => {
    const detail = event.detail as any;
    const eventName: string | undefined = detail?.name ?? detail?.eventName;

    if (!spreadsheetState) return;

    if (eventName === "selectedRow") {
      const clickedRow = detail?.value as InterfaceSpreadsheetRow | undefined;
      const clickedRowIndex = getClickedRowIndex(clickedRow, detail);

      if (clickedRowIndex === undefined) {
        console.log("selectedRow rowIndex could not be resolved", detail);
        return;
      }

      setPageState((prevState) => ({
        ...prevState,
        spreadsheetSelectedRowIndex: clickedRowIndex,
      }));

      return;
    }

    const rowIndex = Number(detail?.cell?.data?.index);

    if (!Number.isInteger(rowIndex) || rowIndex < 0) {
      return;
    }

    if (eventName === "srcComment" || eventName === "dstComment") {
      const selectedIf = event.detail.value as Interface;
      const comment =
        eventName === "srcComment"
          ? selectedIf.projectTcktInfo.srcDsgnCmnt
          : selectedIf.projectTcktInfo.dstDsgnCmnt;
      if (comment === "") {
        return;
      }
      setCommentDialogState((prevState) => ({
        ...prevState,
        commentDescription: comment,
        selectedEvent: eventName,
        ifList: selectedIf,
        isShow: true,
        onChangeSpreadsheetState: (
          newComment: string,
          updateTicketResponse: UpdateTicketResponse,
        ) => {
          if (spreadsheetState === undefined) return;
          let copyedSpreadsheetState: {
            ifList: InterfaceSpreadsheetRow[];
            interfaceListGeneralCodeState: GeneralCode;
          } = _.cloneDeep(spreadsheetState);
          const index: number = +selectedIf.idx;
          if (eventName === "srcComment") {
            copyedSpreadsheetState.ifList[index].projectTcktInfo.srcDsgnCmnt =
              newComment;
            copyedSpreadsheetState.ifList[
              index
            ].projectTcktInfo.srcDsgnTcktUpdateDateTime =
              updateTicketResponse.updateDateTime;
          } else {
            copyedSpreadsheetState.ifList[index].projectTcktInfo.dstDsgnCmnt =
              newComment;
            copyedSpreadsheetState.ifList[
              index
            ].projectTcktInfo.dstDsgnTcktUpdateDateTime =
              updateTicketResponse.updateDateTime;
          }
          setSpreadsheetState({
            ...spreadsheetState,
            ifList: copyedSpreadsheetState.ifList,
          });
        },
      }));
    } else if (
      eventName === "srcIssuingInputFileID" ||
      eventName === "srcIssuingOutputFileID" ||
      eventName === "dstIssuingInputFileID" ||
      eventName === "dstIssuingOutputFileID"
    ) {
      const dtKindId = event.detail.value.dtKindId;
      const cmpId = event.detail.value.cmpId;
      if (!dtKindId || !cmpId) {
        showToast({
          design: "alert",
          message: messageForScreen(ApplicationMessageScreen.APP_SCN_00142),
        });
        return;
      }
      const createConfirmDialogState: CreateFileLayoutConfirmDialogState = {
        isShow: true,
        createFileLayoutRequest: {
          dtKindId: dtKindId,
          cmpId: cmpId,
          converterType: LayoutDerivationReasonType.EDH_CONVERTER,
        },
        issuedRowIdx: rowIndex,
        issuedEventName: eventName,
      };

      setPageState((prevState) => ({
        ...prevState,
        createFileLayoutConfirmDialogState: createConfirmDialogState,
      }));
    } else if (eventName === "history") {
      resetUserError();
      const selectedIf = event.detail.value as Interface;
      sendGetIFDefinitionHistoryRequest({
        dfnSetVerNum: params.dfnSetVerNum,
        srcInbdId: selectedIf.src.interfaceDefinition?.inbound?.inboundId ?? "",
        dstOtbdId:
          selectedIf.dst.interfaceDefinition?.outbound?.outboundId ?? "",
        isPrd: params.type === ReferenceModeType.ENVIRONMENT_PRD ? true : false,
      });
      const srcInboundId =
        selectedIf.src.interfaceDefinition?.inbound?.inboundId ?? "";
      const dstOutboundId =
        selectedIf.dst.interfaceDefinition?.outbound?.outboundId ?? "";
      const historyEnvType =
        params.type === ReferenceModeType.ENVIRONMENT_PRD ? "PRD" : "STG";

      const title = `Interface List ( Src Inbound ID: ${srcInboundId} | Dst Outbound ID: ${dstOutboundId} | Environment: ${historyEnvType} )`;
      changeHeaderTitle(title);
      setPageState((prevState) => ({
        ...prevState,
        isHistoryDisplay: true,
        ifList: [],
        alertMessage: {},
      }));
    } else if (eventName === "project") {
      resetUserError();
      const selectedIf = event.detail.value;
      const pjtId = selectedIf.project.pjtId.value || selectedIf.project.pjtId;

      const searchParam = { pjtId: pjtId, mode: PAGE_MODE.INPUT_MODE };
      const newState = { prevPath: "/interface-list" };

      navigate(
        `/interface-list?${new URLSearchParams(searchParam).toString()}`,
        {
          state: newState,
        },
      );
    } else if (eventName === "deleteIconClicked") {
      if (!event.detail.cell.data.each.isAddRow) return;
      const newSpreadsheetState: InterfaceSpreadsheetRow[] =
        spreadsheetState?.ifList ? [...spreadsheetState.ifList] : [];
      newSpreadsheetState.splice(rowIndex, 1);
      newSpreadsheetState.map((e, idx) => {
        e.idx = idx;
      });
      setSpreadsheetState({
        ...spreadsheetState,
        ifList: [...newSpreadsheetState],
      });
      const editedIfList: Interface[] = _.cloneDeep(pageState.editedIfList);
      // Set Edited Iflist
      editedIfList.splice(rowIndex, 1);
      editedIfList.map((e, idx) => {
        e.idx = idx;
      });
      setPageState((prevState) => ({
        ...prevState,
        editedIfList: editedIfList,
      }));
    }
  };

  const onClickPresetCheckboxHandle =
    (name: string) => (event: CustomEvent) => {
      if (!spreadsheetState?.showColumnPresets || !isPresetEnabled) return;
      const values = event.detail.value;
      let currentPresets = { ...spreadsheetState.showColumnPresets };
      if (name === "src") {
        setSrcPresetSelectedItems(values);
        currentPresets.srcInbound = values;
        setPresetParentSelectedItems((prev) => ({
          ...prev,
          src: values.length > 0,
        }));
      } else if (name === "dst") {
        setDstPresetSelectedItems(values);
        currentPresets.dstOutbound = values;
        setPresetParentSelectedItems((prev) => ({
          ...prev,
          dst: values.length > 0,
        }));
      } else if (name === "cross") {
        setCrossPresetSelectedItems(values);
        currentPresets.crossDomain = values;
        setPresetParentSelectedItems((prev) => ({
          ...prev,
          cross: values.length > 0,
        }));
      }

      setSpreadsheetState({
        ...spreadsheetState,
        showColumnPresets: currentPresets,
      });
    };

  const onClickPresetButtonHandle = (name: string) => () => {
    if (!spreadsheetState?.showColumnPresets || !isPresetEnabled) return;
    let currentPresets = { ...spreadsheetState.showColumnPresets };
    const currentValue =
      presetParentSelectedItems[name as keyof typeof presetParentSelectedItems];
    const newValue = !currentValue;

    if (name === "basic") {
      setPresetParentSelectedItems({
        ...presetParentSelectedItems,
        basic: newValue,
      });
      const selectedItems = newValue
        ? basicColumnPresets.map((v) => v.value)
        : [];
      setBasicPresetSelectedItems(selectedItems);
      currentPresets.basicInformation = selectedItems;
    } else if (name === "src") {
      setPresetParentSelectedItems({
        ...presetParentSelectedItems,
        src: newValue,
      });
      const selectedItems = newValue
        ? srcInboundColumnPresets.map((v) => v.value)
        : [];
      setSrcPresetSelectedItems(selectedItems);
      currentPresets.srcInbound = selectedItems;
    } else if (name === "cross") {
      setPresetParentSelectedItems({
        ...presetParentSelectedItems,
        cross: newValue,
      });
      const selectedItems = newValue
        ? crossDomainColumnPresetsToUse.map((v) => v.value)
        : [];
      setCrossPresetSelectedItems(selectedItems);
      currentPresets.crossDomain = selectedItems;
    } else if (name === "dst") {
      setPresetParentSelectedItems({
        ...presetParentSelectedItems,
        dst: newValue,
      });
      const selectedItems = newValue
        ? dstOutboundColumnPresets.map((v) => v.value)
        : [];
      setDstPresetSelectedItems(selectedItems);
      currentPresets.dstOutbound = selectedItems;
    }

    setSpreadsheetState({
      ...spreadsheetState,
      showColumnPresets: currentPresets,
    });
  };

  const clickedCreateManifestZip = async () => {
    // Compare semantic versions (e.g., 1.9 < 1.10)
    const compareVersions = (v1: string, v2: string): number => {
      const v1Parts = v1.split(".").map(Number);
      const v2Parts = v2.split(".").map(Number);

      for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
        const part1 = v1Parts[i] || 0;
        const part2 = v2Parts[i] || 0;

        if (part1 < part2) return -1;
        if (part1 > part2) return 1;
      }

      return 0;
    };

    // Helper function to get the correct Talend object based on IO type and Talend type
    const getTalendObject = (
      io: any,
      ioType: "inbound" | "outbound",
      talendType: "Transceiver" | "Converter",
    ) => {
      if (ioType === "inbound") {
        return talendType === "Transceiver"
          ? io.inboundTransceiver
          : io.inboundConverter;
      } else {
        return talendType === "Transceiver"
          ? io.outboundTransceiver
          : io.outboundConverter;
      }
    };

    // Create job list by DIP and ComponentId with deduplication
    const createJobListByDip = (
      jobListByDip: Map<string, Map<string, Map<string, any>>>,
      interfaceObj: any,
      ioType: "inbound" | "outbound",
    ) => {
      if (!interfaceObj || !interfaceObj.interfaceDefinition) return;

      const def = interfaceObj.interfaceDefinition;
      if (
        def.interfaceRequirementType !== InterfaceRequirementType.CREATE &&
        def.interfaceRequirementType !== InterfaceRequirementType.UPDATE
      ) {
        return;
      }

      const io = def[ioType];
      if (!io) return;

      (["Transceiver", "Converter"] as const).forEach((talendType) => {
        let talendObject = getTalendObject(io, ioType, talendType);

        if (
          talendObject &&
          !!talendObject.jobName &&
          !!talendObject.talendJobVersion &&
          !!def.dipByRegion &&
          !!io.componentId
        ) {
          const job = {
            dip: def.dipByRegion,
            componentId: io.componentId,
            jobName: talendObject.jobName,
            projectName: io.talendProject,
            verificationType:
              talendObject.talendJobVersion === "1.0" ? "1" : "2",
            jobVersion: talendObject.talendJobVersion,
          };

          const dip = job.dip;
          const componentId = job.componentId;
          const jobName = job.jobName;

          if (!jobListByDip.has(dip)) {
            jobListByDip.set(dip, new Map<string, Map<string, any>>());
          }

          const componentMap = jobListByDip.get(dip)!;
          if (!componentMap.has(componentId)) {
            componentMap.set(componentId, new Map<string, any>());
          }

          const jobNameMap = componentMap.get(componentId)!;
          if (!jobNameMap.has(jobName)) {
            jobNameMap.set(jobName, job);
          } else {
            const existing = jobNameMap.get(jobName)!;
            const projectName = !!existing.projectName
              ? existing.projectName
              : job.projectName;
            if (
              job.jobVersion &&
              existing.jobVersion &&
              compareVersions(job.jobVersion, existing.jobVersion) > 0
            ) {
              jobNameMap.set(jobName, { ...job, projectName });
            } else {
              jobNameMap.set(jobName, { ...existing, projectName });
            }
          }
        }
      });
    };

    const date = new Date();
    const farmatedToday =
      date.getFullYear() +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      ("0" + date.getDate()).slice(-2) +
      "_" +
      ("0" + date.getHours()).slice(-2) +
      ("0" + date.getMinutes()).slice(-2) +
      ("0" + date.getSeconds()).slice(-2);
    // Map structure: DIP -> ComponentId -> JobName -> Job
    const jobListByDip = new Map<string, Map<string, Map<string, any>>>();

    pageState.ifList.forEach((e) => {
      createJobListByDip(jobListByDip, e.src, "inbound");
      createJobListByDip(jobListByDip, e.dst, "outbound");
    });

    const zip = new JSZip();

    // Process each DIP and ComponentId, create JSON files
    jobListByDip.forEach((componentMap, dip) => {
      componentMap.forEach((jobNameMap, componentId) => {
        // Convert Map to array and sort
        const sortedJobs = Array.from(jobNameMap.values()).sort(
          (a: any, b: any) => {
            if (a.jobName !== b.jobName) return a.jobName < b.jobName ? -1 : 1;
            if (a.projectName !== b.projectName)
              return a.projectName < b.projectName ? -1 : 1;
            return 0;
          },
        );

        // Build JSON
        if (sortedJobs.length > 0) {
          const projectName =
            sortedJobs.find((j: any) => j.projectName)?.projectName || null;
          const manifest = {
            componentId,
            projectName,
            jobs: sortedJobs.map((jobData: any) => ({
              verificationType: jobData.verificationType,
              jobName: jobData.jobName,
              jobVersion: jobData.jobVersion,
            })),
          };
          const data = JSON.stringify(manifest, null, 2);
          const blob = new Blob([data], { type: "application/json" });
          const fileName = `${dip}_${componentId}_manifest_${farmatedToday}.json`;
          zip.file(fileName, blob);
        }
      });
    });

    const fileCount = Object.keys(zip.files).length;
    if (fileCount > 0) {
      const zipBlob = await zip.generateAsync({ type: "blob" });
      const url = URL.createObjectURL(zipBlob);
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.download = "Manifest.zip";
      a.href = url;
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } else {
      showConfirmationDialog({
        type: "info",
        title: "",
        showCancelButton: false,
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00210),
      });
    }
  };

  const onClickCreateSHPCsv = () => {
    const req: GetPartnersRequest = {
      dipByRgn: "AIF",
    };
    sendGetPartners(req);
  };

  const resolvePartnerCountryCd = (
    ptnrCd?: string,
    ptnrType?: string,
    ptnrBu?: string,
    dipByRgn?: string,
  ) => {
    const targetPartner = getPartnersReponse?.ptnrList.find((e) => {
      if (ptnrType === PtnrType.LOGISTICS) {
        return (
          e.dipByRgn === dipByRgn &&
          e.ptnrCd === ptnrCd &&
          e.ptnrTypeCd === ptnrType &&
          e.buCd === ptnrBu
        );
      } else {
        return (
          e.dipByRgn === dipByRgn &&
          e.ptnrCd === ptnrCd &&
          e.ptnrTypeCd === ptnrType
        );
      }
    });

    return targetPartner?.cnCd;
  };

  const resolveGnrlCdName = (
    dataList: Option[],
    gnrlCd: string | undefined,
  ) => {
    return dataList.find((e) => e.value === gnrlCd)?.label;
  };

  const formattedDateTime = (date: Date) => {
    return (
      date.getFullYear() +
      (date.getMonth() + 1).toString().padStart(2, "0") +
      date.getDate().toString().padStart(2, "0") +
      "_" +
      date.getHours().toString().padStart(2, "0") +
      date.getMinutes().toString().padStart(2, "0") +
      date.getSeconds().toString().padStart(2, "0")
    );
  };

  /**
   * Create CSV for SHP
   */
  const createSHPCsv = () => {
    if (!getPartnersReponse) return;

    const targetIfList: Interface[] = pageState.ifList
      .filter((e) => e.project.ifReqCnclTypeCd === IfReqCnclType.NORMAL)
      .filter(
        (e) =>
          e.src.interfaceDefinition.inbound?.componentId === "SHP" ||
          e.dst.interfaceDefinition.outbound?.componentId === "SHP",
      );

    const csvData: string = targetIfList
      .map((e): (string | undefined)[] => {
        // DIP Internal
        if (
          e.src.interfaceDefinition.dipByRegion ===
          e.dst.interfaceDefinition.dipByRegion
        ) {
          return [
            e.src.interfaceDefinition.interfaceId,
            e.src.interfaceDefinition.interfaceNameEnglish,
            e.src.interfaceDefinition.interfaceNameJapanese,
            e.src.interfaceDefinition.inbound?.componentId,
            e.dst.interfaceDefinition.outbound?.componentId,
            e.src.interfaceDefinition.inbound?.inboundId,
            e.dst.interfaceDefinition.outbound?.outboundId,
            // Inbound
            e.src.interfaceDefinition.inbound?.inboundPartner?.fileTypeCode,
            resolveGnrlCdName(
              pageState.interfaceListGeneralCodeState.fileTypeType,
              e.src.interfaceDefinition.inbound?.inboundPartner?.fileTypeCode,
            ),
            e.src.interfaceDefinition.inbound?.inboundPartner?.partnerInitFlg,
            e.src.interfaceDefinition.inbound?.inboundPartner?.partnerCode,
            e.src.interfaceDefinition.inbound?.inboundPartner?.partnerType,
            resolveGnrlCdName(
              pageState.interfaceListGeneralCodeState.ptnrType,
              e.src.interfaceDefinition.inbound?.inboundPartner?.partnerType,
            ),
            e.src.interfaceDefinition.inbound?.inboundPartner?.partnerName,
            e.src.interfaceDefinition.inbound?.inboundPartner?.partnerBusiness,
            resolvePartnerCountryCd(
              e.src.interfaceDefinition.inbound?.inboundPartner?.partnerCode,
              e.src.interfaceDefinition.inbound?.inboundPartner?.partnerType,
              e.src.interfaceDefinition.inbound?.inboundPartner
                ?.partnerBusiness,
              e.src.interfaceDefinition.dipByRegion,
            ),
            // Outbound
            e.dst.interfaceDefinition.outbound?.outboundPartner?.fileTypeCode,
            resolveGnrlCdName(
              pageState.interfaceListGeneralCodeState.fileTypeType,
              e.dst.interfaceDefinition.outbound?.outboundPartner?.fileTypeCode,
            ),
            e.dst.interfaceDefinition.outbound?.outboundPartner?.partnerCode,
            e.dst.interfaceDefinition.outbound?.outboundPartner?.partnerType,
            resolveGnrlCdName(
              pageState.interfaceListGeneralCodeState.ptnrType,
              e.dst.interfaceDefinition.outbound?.outboundPartner?.partnerType,
            ),
            e.dst.interfaceDefinition.outbound?.outboundPartner?.partnerName,
            e.dst.interfaceDefinition.outbound?.outboundPartner
              ?.partnerBusiness,
            resolvePartnerCountryCd(
              e.dst.interfaceDefinition.outbound?.outboundPartner?.partnerCode,
              e.dst.interfaceDefinition.outbound?.outboundPartner?.partnerType,
              e.dst.interfaceDefinition.outbound?.outboundPartner
                ?.partnerBusiness,
              e.dst.interfaceDefinition.dipByRegion,
            ),
          ];

          // Cross DIP. src=AIF
        } else if (
          e.src.interfaceDefinition.dipByRegion !==
            e.dst.interfaceDefinition.dipByRegion &&
          e.src.interfaceDefinition.dipByRegion === "AIF"
        ) {
          return [
            e.src.interfaceDefinition.interfaceId,
            e.src.interfaceDefinition.interfaceNameEnglish,
            e.src.interfaceDefinition.interfaceNameJapanese,
            e.src.interfaceDefinition.inbound?.componentId,
            e.src.interfaceDefinition.outbound?.componentId,
            e.src.interfaceDefinition.inbound?.inboundId,
            e.src.interfaceDefinition.outbound?.outboundId,
            // Inbound
            e.src.interfaceDefinition.inbound?.inboundPartner?.fileTypeCode,
            resolveGnrlCdName(
              pageState.interfaceListGeneralCodeState.fileTypeType,
              e.src.interfaceDefinition.inbound?.inboundPartner?.fileTypeCode,
            ),
            e.src.interfaceDefinition.inbound?.inboundPartner?.partnerInitFlg,
            e.src.interfaceDefinition.inbound?.inboundPartner?.partnerCode,
            e.src.interfaceDefinition.inbound?.inboundPartner?.partnerType,
            resolveGnrlCdName(
              pageState.interfaceListGeneralCodeState.ptnrType,
              e.src.interfaceDefinition.inbound?.inboundPartner?.partnerType,
            ),
            e.src.interfaceDefinition.inbound?.inboundPartner?.partnerName,
            e.src.interfaceDefinition.inbound?.inboundPartner?.partnerBusiness,
            resolvePartnerCountryCd(
              e.src.interfaceDefinition.inbound?.inboundPartner?.partnerCode,
              e.src.interfaceDefinition.inbound?.inboundPartner?.partnerType,
              e.src.interfaceDefinition.inbound?.inboundPartner
                ?.partnerBusiness,
              e.src.interfaceDefinition.dipByRegion,
            ),
            // Outbound
            e.src.interfaceDefinition.outbound?.outboundPartner?.fileTypeCode,
            resolveGnrlCdName(
              pageState.interfaceListGeneralCodeState.fileTypeType,
              e.src.interfaceDefinition.outbound?.outboundPartner?.fileTypeCode,
            ),
            e.src.interfaceDefinition.outbound?.outboundPartner?.partnerCode,
            e.src.interfaceDefinition.outbound?.outboundPartner?.partnerType,
            resolveGnrlCdName(
              pageState.interfaceListGeneralCodeState.ptnrType,
              e.src.interfaceDefinition.outbound?.outboundPartner?.partnerType,
            ),
            e.src.interfaceDefinition.outbound?.outboundPartner?.partnerName,
            e.src.interfaceDefinition.outbound?.outboundPartner
              ?.partnerBusiness,
            resolvePartnerCountryCd(
              e.src.interfaceDefinition.outbound?.outboundPartner?.partnerCode,
              e.src.interfaceDefinition.outbound?.outboundPartner?.partnerType,
              e.src.interfaceDefinition.outbound?.outboundPartner
                ?.partnerBusiness,
              e.src.interfaceDefinition.dipByRegion,
            ),
          ];

          // Cross DIP. dst=AIF
        } else if (
          e.src.interfaceDefinition.dipByRegion !==
            e.dst.interfaceDefinition.dipByRegion &&
          e.dst.interfaceDefinition.dipByRegion === "AIF"
        ) {
          return [
            e.dst.interfaceDefinition.interfaceId,
            e.dst.interfaceDefinition.interfaceNameEnglish,
            e.dst.interfaceDefinition.interfaceNameJapanese,
            e.dst.interfaceDefinition.inbound?.componentId,
            e.dst.interfaceDefinition.outbound?.componentId,
            e.dst.interfaceDefinition.inbound?.inboundId,
            e.dst.interfaceDefinition.outbound?.outboundId,
            // Inbound
            e.dst.interfaceDefinition.inbound?.inboundPartner?.fileTypeCode,
            resolveGnrlCdName(
              pageState.interfaceListGeneralCodeState.fileTypeType,
              e.dst.interfaceDefinition.inbound?.inboundPartner?.fileTypeCode,
            ),
            e.dst.interfaceDefinition.inbound?.inboundPartner?.fileTypeCode,
            e.dst.interfaceDefinition.inbound?.inboundPartner?.partnerInitFlg,
            e.dst.interfaceDefinition.inbound?.inboundPartner?.partnerCode,
            e.dst.interfaceDefinition.inbound?.inboundPartner?.partnerType,
            resolveGnrlCdName(
              pageState.interfaceListGeneralCodeState.ptnrType,
              e.dst.interfaceDefinition.inbound?.inboundPartner?.partnerType,
            ),
            e.dst.interfaceDefinition.inbound?.inboundPartner?.partnerName,
            e.dst.interfaceDefinition.inbound?.inboundPartner?.partnerBusiness,
            resolvePartnerCountryCd(
              e.dst.interfaceDefinition.inbound?.inboundPartner?.partnerCode,
              e.dst.interfaceDefinition.inbound?.inboundPartner?.partnerType,
              e.dst.interfaceDefinition.inbound?.inboundPartner
                ?.partnerBusiness,
              e.dst.interfaceDefinition.dipByRegion,
            ),
            // Outbound
            e.dst.interfaceDefinition.outbound?.outboundPartner?.fileTypeCode,
            resolveGnrlCdName(
              pageState.interfaceListGeneralCodeState.fileTypeType,
              e.dst.interfaceDefinition.outbound?.outboundPartner?.fileTypeCode,
            ),
            e.dst.interfaceDefinition.outbound?.outboundPartner?.partnerCode,
            e.dst.interfaceDefinition.outbound?.outboundPartner?.partnerType,
            resolveGnrlCdName(
              pageState.interfaceListGeneralCodeState.ptnrType,
              e.dst.interfaceDefinition.outbound?.outboundPartner?.partnerType,
            ),
            e.dst.interfaceDefinition.outbound?.outboundPartner?.partnerName,
            e.dst.interfaceDefinition.outbound?.outboundPartner
              ?.partnerBusiness,
            resolvePartnerCountryCd(
              e.dst.interfaceDefinition.outbound?.outboundPartner?.partnerCode,
              e.dst.interfaceDefinition.outbound?.outboundPartner?.partnerType,
              e.dst.interfaceDefinition.outbound?.outboundPartner
                ?.partnerBusiness,
              e.dst.interfaceDefinition.dipByRegion,
            ),
          ];
        }
        return [];
      })
      .filter((e) => e.length > 0)
      .map((row) => row.map((e) => (!!e ? `"${e}"` : '""')).join(","))
      // dedup for multicast or ID/File integration
      .filter((e, idx, arr) => arr.indexOf(e) === idx)
      .join("\n");

    const csv = shpCsvHeader.map((e) => `"${e}"`).join(",") + "\n" + csvData;

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.download = `jedi_shp_interface_definition_${formattedDateTime(
      new Date(),
    )}.csv`;
    a.href = url;
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };
  useEffect(createSHPCsv, [getPartnersReponse]);

  const includeSHP = () => {
    return pageState.ifList.some(
      (e) =>
        e.src.interfaceDefinition.inbound?.componentId === "SHP" ||
        e.dst.interfaceDefinition.outbound?.componentId === "SHP",
    );
  };

  // Get edited item in the form of UpdateIfList.
  const getEditedItems = (ifItem: any, tempIf: any, ifProp: any) => {
    if (_.isObject(ifItem[1])) {
      if (ifItem[1].hasOwnProperty("editedFlg")) {
        // If there is an update flag.
        const item = JSON.parse(JSON.stringify(ifItem[1]));
        if (item.editedFlg === true) {
          let ifProperty = "";
          let closeBracket = "";
          ifProp.forEach((e: string) => {
            ifProperty = ifProperty + "{" + '"' + e + '"' + ":";
            closeBracket = closeBracket + "}";
          });
          const newObj = JSON.parse(`{"${ifItem[0]}":""}`);
          newObj[ifItem[0]] = item.value;
          ifProperty = ifProperty + JSON.stringify(newObj) + closeBracket;
          tempIf = mergeDeeply(JSON.parse(ifProperty), tempIf);
          if (params.mode === PAGE_MODE.REVIEW_MODE) {
            if (!tempIf.notice) {
              tempIf.notice = {};
            }
            if (item.cmplCntnt.startsWith("src.")) {
              tempIf.notice.srcCmplCntnt =
                (!!tempIf.notice.srcCmplCntnt
                  ? tempIf.notice.srcCmplCntnt + "\n"
                  : "") +
                item.cmplCntnt +
                ", before:" +
                item.initValue +
                ", after:" +
                item.value;
            } else if (item.cmplCntnt.startsWith("dst.")) {
              tempIf.notice.dstCmplCntnt =
                (!!tempIf.notice.dstCmplCntnt
                  ? tempIf.notice.dstCmplCntnt + "\n"
                  : "") +
                item.cmplCntnt +
                ", before:" +
                item.initValue +
                ", after:" +
                item.value;
            }
          }
        }
      } else {
        // Perform recursive processing.
        ifProp.push(ifItem[0]);
        Object.entries(ifItem[1]).forEach((e) => {
          tempIf = getEditedItems(e, tempIf, ifProp);
        });
        ifProp.pop();
      }
    }
    return tempIf;
  };

  // Get edited item in the form of UpdateIfList For IE Maintenance.
  const getEditedItemsForGod = (
    ifItem: any,
    tempIf: any,
    ifProp: any,
    isEdited: boolean,
  ) => {
    if (ifItem[0].endsWith("interruptType")) {
      return { editedIfItem: tempIf, isEdited: isEdited };
    } else if (_.isObject(ifItem[1])) {
      if (ifItem[1].hasOwnProperty("editedFlg")) {
        const item = JSON.parse(JSON.stringify(ifItem[1]));
        if (!item.value && item.editedFlg === false) {
          return { editedIfItem: tempIf, isEdited: isEdited };
        }
        let ifProperty = "";
        let closeBracket = "";
        ifProp.forEach((e: string) => {
          ifProperty = ifProperty + "{" + '"' + e + '"' + ":";
          closeBracket = closeBracket + "}";
        });
        const newObj = JSON.parse(`{"${ifItem[0]}":""}`);
        newObj[ifItem[0]] = item.value;
        ifProperty = ifProperty + JSON.stringify(newObj) + closeBracket;
        tempIf = mergeDeeply(JSON.parse(ifProperty), tempIf);
        if (item.editedFlg === true) {
          isEdited = true;
        }
      } else {
        // Perform recursive processing.
        ifProp.push(ifItem[0]);
        Object.entries(ifItem[1]).forEach((e) => {
          const editedInfo = getEditedItemsForGod(e, tempIf, ifProp, isEdited);
          tempIf = editedInfo.editedIfItem;
          isEdited = editedInfo.isEdited;
        });
        ifProp.pop();
      }
    } else if (_.isString(ifItem[1])) {
      // Unedited items
      const item = JSON.parse(JSON.stringify(ifItem[1]));
      if (!item) {
        return { editedIfItem: tempIf, isEdited: isEdited };
      }
      let ifProperty = "";
      let closeBracket = "";
      ifProp.forEach((e: string) => {
        ifProperty = ifProperty + "{" + '"' + e + '"' + ":";
        closeBracket = closeBracket + "}";
      });
      const newObj = JSON.parse(`{"${ifItem[0]}":""}`);
      newObj[ifItem[0]] = convertRetentionPeriodDaysCode(ifItem[0], item);
      ifProperty = ifProperty + JSON.stringify(newObj) + closeBracket;
      tempIf = mergeDeeply(JSON.parse(ifProperty), tempIf);
    }
    return { editedIfItem: tempIf, isEdited: isEdited };
  };

  const setMandatoryIfItms = (
    ifItmsToUpdate: UpdateIfList,
    editedIf: Interface,
  ): UpdateIfList => {
    const mergedIfList = mergeDeeply(editedIf, ifItmsToUpdate);
    return {
      ...ifItmsToUpdate,
      project: !!mergedIfList.project ? mergedIfList.project : {},
      src: {
        ...ifItmsToUpdate.src,
        interfaceDefinition: {
          ...ifItmsToUpdate.src?.interfaceDefinition,
          interfaceRequirementType:
            mergedIfList.src.interfaceDefinition.interfaceRequirementType,
          interfaceId: mergedIfList.src.interfaceDefinition.interfaceId,
          dipByRegion: mergedIfList.src.interfaceDefinition.dipByRegion,
          dataKindId: mergedIfList.src.interfaceDefinition.dataKindId,
          inbound: {
            ...ifItmsToUpdate.src?.interfaceDefinition.inbound,
            inboundId: mergedIfList.src.interfaceDefinition.inbound?.inboundId,
            componentId:
              mergedIfList.src.interfaceDefinition.inbound?.componentId,
          },
          outbound: {
            ...ifItmsToUpdate.src?.interfaceDefinition.outbound,
            ...(!!mergedIfList.src.interfaceDefinition.outbound?.outboundId
              ? {
                  outboundId:
                    mergedIfList.src.interfaceDefinition.outbound?.outboundId,
                }
              : {}),
            ...(!!mergedIfList.src?.interfaceDefinition.outbound?.componentId
              ? {
                  componentId:
                    mergedIfList.src.interfaceDefinition.outbound?.componentId,
                }
              : {}),
          },
        },
      },
      dst: {
        ...ifItmsToUpdate.dst,
        interfaceDefinition: {
          ...ifItmsToUpdate.dst?.interfaceDefinition,
          interfaceRequirementType:
            mergedIfList.dst.interfaceDefinition.interfaceRequirementType,
          interfaceId: mergedIfList.dst.interfaceDefinition.interfaceId,
          dipByRegion: mergedIfList.dst.interfaceDefinition.dipByRegion,
          dataKindId: mergedIfList.dst.interfaceDefinition.dataKindId,
          inbound: {
            ...ifItmsToUpdate.dst?.interfaceDefinition.inbound,
            ...(!!mergedIfList.dst.interfaceDefinition.inbound?.inboundId
              ? {
                  inboundId:
                    mergedIfList.dst.interfaceDefinition.inbound?.inboundId,
                }
              : {}),
            ...(!!mergedIfList.dst.interfaceDefinition.inbound?.componentId
              ? {
                  componentId:
                    mergedIfList.dst.interfaceDefinition.inbound?.componentId,
                }
              : {}),
          },
          outbound: {
            ...ifItmsToUpdate.dst?.interfaceDefinition.outbound,
            outboundId:
              mergedIfList.dst.interfaceDefinition.outbound?.outboundId,
            componentId:
              mergedIfList.dst.interfaceDefinition.outbound?.componentId,
          },
        },
      },
    };
  };

  const cmplDstIfItemsForGod = (ifItems: UpdateIfList): UpdateIfList => {
    return {
      ...ifItems,
      dst: {
        ...ifItems.dst,
        interfaceDefinition: {
          ...ifItems.dst?.interfaceDefinition,
          dataKindId: ifItems.src?.interfaceDefinition.dataKindId,
          interfaceNameEnglish:
            ifItems.src?.interfaceDefinition.interfaceNameEnglish,
          interfaceNameJapanese:
            ifItems.src?.interfaceDefinition.interfaceNameJapanese,
        },
      },
    };
  };

  /**
   * JDI-2378 Completion of RetentionPeriodDay on save.
   *
   * If the ifreq cancellation type is normal and the Create/Update requirement is met,
   * and there is no change in RetentionPeriodDay,
   * but the current value does not match the general code value,
   * then add it to the update target.
   *
   * @param ifDefinition Current If Def.
   * @param editedIfItem Edited If Def.
   */
  const setRetentionPeriodDaysToEditItem = (
    ifDefinition: Interface,
    editedIfItem: UpdateIfList,
  ) => {
    const ifReqCnclTypeCd = editedIfItem.project?.ifReqCnclTypeCd;
    const interfaceRequirementType =
      editedIfItem.src?.interfaceDefinition.interfaceRequirementType;
    const srcDsgnTcktStsTypeCd =
      ifDefinition?.projectTcktInfo?.srcDsgnTcktStsTypeCd;
    if (
      ifReqCnclTypeCd === IfReqCnclType.NORMAL &&
      (interfaceRequirementType === InterfaceRequirementType.CREATE ||
        interfaceRequirementType === InterfaceRequirementType.UPDATE) &&
      (srcDsgnTcktStsTypeCd === TcktStsTypeIfDsgn.DESIGN ||
        params.mode === PAGE_MODE.GOD_MODE)
    ) {
      const retentionPeriodValue = _.get(
        editedIfItem,
        "src.interfaceDefinition.inbound.inboundSecurity.retentionPeriodValue",
      );
      const currentVal = _.get(
        ifDefinition,
        "src.interfaceDefinition.inbound.inboundSecurity.retentionPeriodValue",
      );

      // JDI-2465 If currentVal is an object rather than a string, it will not be converted to Code.
      if (currentVal !== null && typeof currentVal === "object") {
        return;
      }

      if (!retentionPeriodValue && currentVal) {
        var retentionPeriodDaysType =
          pageState.interfaceListGeneralCodeState.retentionPeriodDays;
        // Not match General code.
        if (!retentionPeriodDaysType.find((e) => e.value === currentVal)) {
          // Label > Code othewise current value.
          const newVal =
            retentionPeriodDaysType.find((e) => e.label === currentVal)
              ?.value || currentVal;
          _.set(
            editedIfItem,
            "src.interfaceDefinition.inbound.inboundSecurity.retentionPeriodValue",
            newVal,
          );
        }
      }
    }
  };

  const onInitializedSheet = (e: CustomEvent) => {
    setIsPresetEnabled(true);
    initSpreadsheetState(e);
  };

  const clickedSave = () => {
    resetUserError();
    const updateIfDefinitions = () => {
      const editedIfList = [] as UpdateIfList[];
      let pjtId = "";
      pageState.editedIfList.forEach((ifDefinition) => {
        let editedIfItem = {} as UpdateIfList;
        pjtId = ifDefinition.project.pjtId ?? params.pjtId;
        Object.entries(ifDefinition).forEach((ifItem) => {
          editedIfItem = getEditedItems(ifItem, editedIfItem, []);
        });
        if (Object.keys(editedIfItem).length) {
          editedIfItem.idx = ifDefinition.idx;
          editedIfItem.updateDateTime = ifDefinition.updateDateTime;
          editedIfItem = setMandatoryIfItms(editedIfItem, ifDefinition);

          if (params.mode === PAGE_MODE.GOD_MODE) {
            editedIfItem = cmplDstIfItemsForGod(editedIfItem);
            if (
              editedIfItem.src?.interfaceDefinition.dipByRegion ===
              editedIfItem.dst?.interfaceDefinition.dipByRegion
            ) {
              // In case dip internal, interdomain definitions do not allow value to be set.
              delete editedIfItem.src?.interfaceDefinition?.outbound;
              delete editedIfItem.dst?.interfaceDefinition?.inbound;
            }
          }

          // JDI-2378 Completion of RetentionPeriodDay on save
          setRetentionPeriodDaysToEditItem(ifDefinition, editedIfItem);

          editedIfList.push(editedIfItem);
        }
      });
      if (editedIfList.length === 0) {
        showToast({
          design: "alert",
          message: messageForScreen(ApplicationMessageScreen.APP_SCN_00146),
        });
        return;
      }
      const isGod = params.mode === PAGE_MODE.GOD_MODE;
      const godFlg = isGod ? InDefCommonFlagType.YES : InDefCommonFlagType.NO;
      const ifCallerScreenType = isGod
        ? IfCallerScreenType.IF_LIST_GOD
        : IfCallerScreenType.IF_LIST_INPUT;
      sendUpdateIfDefinitionsRequest({
        dfnSetVerNum: params.dfnSetVerNum,
        ifCallerScreenType: ifCallerScreenType,
        pjtId: pjtId,
        godFlg: godFlg,
        ifList: editedIfList,
      });
    };

    const updateIfDefinitionsGod = () => {
      const editedIfList = [] as UpdateIfListGod[];
      pageState.editedIfList.forEach((ifDefinition) => {
        let editedIfItem = {} as UpdateIfListGod;
        let editedInfo = {} as {
          editedIfItem: UpdateIfListGod;
          isEdited: boolean;
        };
        const isEdited = false;
        Object.entries(ifDefinition).forEach((ifItem) => {
          if (ifItem[0] === "src" || ifItem[0] === "dst") {
            editedInfo = getEditedItemsForGod(
              ifItem,
              editedIfItem,
              [],
              isEdited,
            );
            editedIfItem = editedInfo.editedIfItem;
          }
        });
        if (!editedInfo.isEdited) {
          editedIfItem = {} as UpdateIfListGod;
        }
        if (Object.keys(editedIfItem).length) {
          editedIfItem.idx = ifDefinition.idx;
          editedIfItem = setMandatoryIfItms(editedIfItem, ifDefinition);
          editedIfItem.project!.ifReqCnclTypeCd = IfReqCnclType.NORMAL;
          editedIfItem = cmplDstIfItemsForGod(editedIfItem);
          // JDI-2378 Completion of RetentionPeriodDay on save
          setRetentionPeriodDaysToEditItem(ifDefinition, editedIfItem);
          if (
            editedIfItem.src?.interfaceDefinition.dipByRegion ===
            editedIfItem.dst?.interfaceDefinition.dipByRegion
          ) {
            // In case dip internal, interdomain definitions do not allow value to be set.
            delete editedIfItem.src?.interfaceDefinition?.outbound;
            delete editedIfItem.dst?.interfaceDefinition?.inbound;
          }
          editedIfList.push(editedIfItem);
        }
      });
      if (editedIfList.length === 0) {
        showToast({
          design: "alert",
          message: messageForScreen(ApplicationMessageScreen.APP_SCN_00146),
        });
        return;
      }
      sendUpdateIfDefinitionsGodRequest({
        dfnSetVerNum: params.dfnSetVerNum,
        ifList: editedIfList,
      });
    };

    const updateIfDefinitionsReview = () => {
      const editedIfList = [] as UpdateIfList[];
      let pjtId = "";
      pageState.editedIfList.forEach((ifDefinition) => {
        let editedIfItem = {} as UpdateIfList;
        pjtId = ifDefinition.project.pjtId;
        Object.entries(ifDefinition).forEach((ifItem) => {
          editedIfItem = getEditedItems(ifItem, editedIfItem, []);
        });
        if (Object.keys(editedIfItem).length) {
          editedIfItem.idx = ifDefinition.idx;
          editedIfItem.updateDateTime = ifDefinition.updateDateTime;
          editedIfItem = setMandatoryIfItms(editedIfItem, ifDefinition);
          if (!editedIfItem.notice) {
            editedIfItem.notice = {};
          }
          editedIfItem.notice.evntGrpTypeCd = EvntGrp.EVNT_GRP_IF_010_002;
          editedIfItem.notice.srcTcktId =
            ifDefinition.projectTcktInfo.srcDsgnTcktId;
          editedIfItem.notice.srcDipByRgn =
            ifDefinition.src.interfaceDefinition?.dipByRegion;
          editedIfItem.notice.dstTcktId =
            ifDefinition.projectTcktInfo.dstDsgnTcktId;
          editedIfItem.notice.dstDipByRgn =
            ifDefinition.dst.interfaceDefinition?.dipByRegion;
          editedIfList.push(editedIfItem);
        }
      });
      if (editedIfList.length === 0) {
        showToast({
          design: "alert",
          message: messageForScreen(ApplicationMessageScreen.APP_SCN_00146),
        });
        return;
      }
      const godFlg =
        params.mode === PAGE_MODE.GOD_MODE
          ? InDefCommonFlagType.YES
          : InDefCommonFlagType.NO;
      sendUpdateIfDefinitionsReviewRequest({
        dfnSetVerNum: params.dfnSetVerNum,
        ifCallerScreenType: IfCallerScreenType.IF_LIST_REVIEW,
        pjtId: pjtId,
        godFlg: godFlg,
        ifList: editedIfList,
      });
    };

    if (params.mode === PAGE_MODE.INPUT_MODE) {
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00045),
        onOkButtonClicked: () => {
          updateIfDefinitions();
        },
      });
    } else if (
      params.mode === PAGE_MODE.GOD_MODE &&
      (params.type === PAGE_TYPE.PRD_PJ_TYPE ||
        params.type === PAGE_TYPE.STG_PJ_TYPE)
    ) {
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00045),
        onOkButtonClicked: () => {
          updateIfDefinitionsGod();
        },
      });
    } else if (
      params.mode === PAGE_MODE.GOD_MODE &&
      params.type === PAGE_TYPE.ACTIVE_PJ_TYPE
    ) {
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00045),
        onOkButtonClicked: () => {
          updateIfDefinitions();
        },
      });
    } else if (params.mode === PAGE_MODE.REVIEW_MODE) {
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00045),
        onOkButtonClicked: () => {
          // Retention action and comment.
          const retentionEditedIfList = new Map();
          pageState.editedIfList?.map((e) => {
            retentionEditedIfList.set(e.project.ifReqId, {
              srcAction: e.srcAction,
              dstAction: e.dstAction,
              srcComment: e.projectTcktInfo.srcDsgnCmnt,
              dstComment: e.projectTcktInfo.dstDsgnCmnt,
            });
          });
          setPageState((prevState) => ({
            ...prevState,
            retentionEditedIfList: retentionEditedIfList,
          }));
          updateIfDefinitionsReview();
        },
      });
    }
  };

  const onClickValidate = () => {
    resetUserError();

    const request = {
      dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM"),
      validationTypeCode:
        ValidationTypeCode.IF_ATTR_REVIEW_REQUEST_IFLIST_SCREEN,
      pjtId: params.pjtId,
    };
    getIfDefinitionCommonValidationResultRequest(request);
  };

  const clickedCompleteReview = () => {
    let isDiscardComment = false;
    const ifAttrDsgnRvwList = [] as IfAttrDsgnRvw[];
    pageState.editedIfList?.forEach((e) => {
      const srcAction = e.srcAction
        ? JSON.parse(JSON.stringify(e.srcAction))
        : "";
      const srcComment = e.projectTcktInfo.srcDsgnCmnt
        ? JSON.parse(JSON.stringify(e.projectTcktInfo.srcDsgnCmnt))
        : "";
      const dstAction = e.dstAction
        ? JSON.parse(JSON.stringify(e.dstAction))
        : "";
      const dstComment = e.projectTcktInfo.dstDsgnCmnt
        ? JSON.parse(JSON.stringify(e.projectTcktInfo.dstDsgnCmnt))
        : "";
      if (
        srcComment.hasOwnProperty("editedFlg") &&
        srcComment.editedFlg &&
        (!srcAction ||
          (srcAction.hasOwnProperty("editedFlg") && !srcAction.value))
      ) {
        isDiscardComment = true;
      }
      if (
        dstComment.hasOwnProperty("editedFlg") &&
        dstComment.editedFlg &&
        (!dstAction ||
          (dstAction.hasOwnProperty("editedFlg") && !dstAction.value))
      ) {
        isDiscardComment = true;
      }
      if (
        !!srcAction &&
        srcAction.hasOwnProperty("editedFlg") &&
        srcAction.editedFlg
      ) {
        let tcktStsId = "";
        if (srcAction.value === ReviewActionType.APPROVE) {
          tcktStsId = TcktStsTypeIfDsgn.DESIGN_APPROVED;
        } else if (srcAction.value === ReviewActionType.REJECT) {
          tcktStsId = TcktStsTypeIfDsgn.DESIGN;
        } else if (srcAction.value === ReviewActionType.DISMISS_APPROVAL) {
          tcktStsId = TcktStsTypeIfDsgn.DESIGN_REVIEW;
        }
        const ifAttrDsgnRvw = {} as IfAttrDsgnRvw;
        ifAttrDsgnRvw.index = e.idx;
        ifAttrDsgnRvw.tcktId = e.projectTcktInfo.srcDsgnTcktId;
        ifAttrDsgnRvw.tcktStsTypeCd = tcktStsId;
        ifAttrDsgnRvw.ifReqId = e.project.ifReqId;
        ifAttrDsgnRvw.dipByRgn = e.src.interfaceDefinition.dipByRegion ?? "";
        ifAttrDsgnRvw.cpntId =
          e.src.interfaceDefinition.inbound?.componentId ?? "";
        ifAttrDsgnRvw.cmnt = e.projectTcktInfo.srcDsgnCmnt;
        ifAttrDsgnRvw.updateDateTime =
          e.projectTcktInfo.srcDsgnTcktUpdateDateTime;
        if (
          !!srcComment &&
          srcComment.hasOwnProperty("editedFlg") &&
          srcComment.editedFlg
        ) {
          ifAttrDsgnRvw.cmnt = srcComment.value;
        }
        ifAttrDsgnRvwList.push(ifAttrDsgnRvw);
      }
      if (
        !!dstAction &&
        dstAction.hasOwnProperty("editedFlg") &&
        dstAction.editedFlg
      ) {
        let tcktStsId = "";
        if (dstAction.value === ReviewActionType.APPROVE) {
          tcktStsId = TcktStsTypeIfDsgn.DESIGN_APPROVED;
        } else if (dstAction.value === ReviewActionType.REJECT) {
          tcktStsId = TcktStsTypeIfDsgn.DESIGN;
        } else if (dstAction.value === ReviewActionType.DISMISS_APPROVAL) {
          tcktStsId = TcktStsTypeIfDsgn.DESIGN_REVIEW;
        }
        const ifAttrDsgnRvw = {} as IfAttrDsgnRvw;
        ifAttrDsgnRvw.index = e.idx;
        ifAttrDsgnRvw.tcktId = e.projectTcktInfo.dstDsgnTcktId;
        ifAttrDsgnRvw.tcktStsTypeCd = tcktStsId;
        ifAttrDsgnRvw.ifReqId = e.project.ifReqId;
        ifAttrDsgnRvw.dipByRgn = e.dst.interfaceDefinition.dipByRegion ?? "";
        ifAttrDsgnRvw.cpntId =
          e.dst.interfaceDefinition.outbound?.componentId ?? "";
        ifAttrDsgnRvw.cmnt = e.projectTcktInfo.dstDsgnCmnt;
        ifAttrDsgnRvw.updateDateTime =
          e.projectTcktInfo.dstDsgnTcktUpdateDateTime;
        if (
          !!dstComment &&
          dstComment.hasOwnProperty("editedFlg") &&
          dstComment.editedFlg
        ) {
          ifAttrDsgnRvw.cmnt = dstComment.value;
        }
        ifAttrDsgnRvwList.push(ifAttrDsgnRvw);
      }
    });

    const resultIfAttrDsgnRvwList = ifAttrDsgnRvwList.filter(
      (e) => e.tcktStsTypeCd !== TcktStsTypeIfDsgn.DESIGN_REVIEW,
    );

    if (resultIfAttrDsgnRvwList.length === 0) {
      showToast({
        design: "alert",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00146),
      });
      return;
    }

    const sendIfBulkUpdateTicketsParam: BulkUpdateTicketsOfIfAttributeDesignReviewRequest =
      {
        ifAttrDsgnRvwList: resultIfAttrDsgnRvwList,
        evntGrpTypeCd: EvntGrp.EVNT_GRP_IF_010_002,
        dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM"),
      };

    if (isDiscardComment) {
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00034),
        onOkButtonClicked: () => {
          resetUserError();
          sendBulkUpdateTicketsOfIfAttributeDesignReviewRequest(
            sendIfBulkUpdateTicketsParam,
          );
          setPageState((prevState) => ({
            ...prevState,
            prevActionSuccessMessage: messageForScreen(
              ApplicationMessageScreen.APP_SCN_00178,
            ),
          }));
        },
      });
    } else {
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(
          ApplicationMessageScreen.APP_SCN_00169,
          "complete",
          "design review",
        ),
        onOkButtonClicked: () => {
          resetUserError();
          sendBulkUpdateTicketsOfIfAttributeDesignReviewRequest(
            sendIfBulkUpdateTicketsParam,
          );
          setPageState((prevState) => ({
            ...prevState,
            prevActionSuccessMessage: messageForScreen(
              ApplicationMessageScreen.APP_SCN_00178,
            ),
          }));
        },
      });
    }
  };

  const clickedDismiss = () => {
    let isDiscardComment = false;
    const ifAttrDsgnRvwList = [] as IfAttrDsgnRvw[];
    pageState.editedIfList?.forEach((e) => {
      const srcAction = e.srcAction
        ? JSON.parse(JSON.stringify(e.srcAction))
        : "";
      const srcComment = e.projectTcktInfo.srcDsgnCmnt
        ? JSON.parse(JSON.stringify(e.projectTcktInfo.srcDsgnCmnt))
        : "";
      const dstAction = e.dstAction
        ? JSON.parse(JSON.stringify(e.dstAction))
        : "";
      const dstComment = e.projectTcktInfo.dstDsgnCmnt
        ? JSON.parse(JSON.stringify(e.projectTcktInfo.dstDsgnCmnt))
        : "";
      if (
        srcComment.hasOwnProperty("editedFlg") &&
        srcComment.editedFlg &&
        (!srcAction ||
          (srcAction.hasOwnProperty("editedFlg") && !srcAction.value))
      ) {
        isDiscardComment = true;
      }
      if (
        dstComment.hasOwnProperty("editedFlg") &&
        dstComment.editedFlg &&
        (!dstAction ||
          (dstAction.hasOwnProperty("editedFlg") && !dstAction.value))
      ) {
        isDiscardComment = true;
      }
      if (
        !!srcAction &&
        srcAction.hasOwnProperty("editedFlg") &&
        srcAction.editedFlg
      ) {
        let tcktStsId = "";
        if (srcAction.value === ReviewActionType.APPROVE) {
          tcktStsId = TcktStsTypeIfDsgn.DESIGN_APPROVED;
        } else if (srcAction.value === ReviewActionType.REJECT) {
          tcktStsId = TcktStsTypeIfDsgn.DESIGN;
        } else if (srcAction.value === ReviewActionType.DISMISS_APPROVAL) {
          tcktStsId = TcktStsTypeIfDsgn.DESIGN_REVIEW;
        }
        const ifAttrDsgnRvw = {} as IfAttrDsgnRvw;
        ifAttrDsgnRvw.index = e.idx;
        ifAttrDsgnRvw.tcktId = e.projectTcktInfo.srcDsgnTcktId;
        ifAttrDsgnRvw.tcktStsTypeCd = tcktStsId;
        ifAttrDsgnRvw.ifReqId = e.project.ifReqId;
        ifAttrDsgnRvw.dipByRgn = e.src.interfaceDefinition.dipByRegion ?? "";
        ifAttrDsgnRvw.cpntId =
          e.src.interfaceDefinition.inbound?.componentId ?? "";
        ifAttrDsgnRvw.cmnt = e.projectTcktInfo.srcDsgnCmnt;
        ifAttrDsgnRvw.updateDateTime =
          e.projectTcktInfo.srcDsgnTcktUpdateDateTime;
        if (
          !!srcComment &&
          srcComment.hasOwnProperty("editedFlg") &&
          srcComment.editedFlg
        ) {
          ifAttrDsgnRvw.cmnt = srcComment.value;
        }
        ifAttrDsgnRvwList.push(ifAttrDsgnRvw);
      }
      if (
        !!dstAction &&
        dstAction.hasOwnProperty("editedFlg") &&
        dstAction.editedFlg
      ) {
        let tcktStsId = "";
        if (dstAction.value === ReviewActionType.APPROVE) {
          tcktStsId = TcktStsTypeIfDsgn.DESIGN_APPROVED;
        } else if (dstAction.value === ReviewActionType.REJECT) {
          tcktStsId = TcktStsTypeIfDsgn.DESIGN;
        } else if (dstAction.value === ReviewActionType.DISMISS_APPROVAL) {
          tcktStsId = TcktStsTypeIfDsgn.DESIGN_REVIEW;
        }
        const ifAttrDsgnRvw = {} as IfAttrDsgnRvw;
        ifAttrDsgnRvw.index = e.idx;
        ifAttrDsgnRvw.tcktId = e.projectTcktInfo.dstDsgnTcktId;
        ifAttrDsgnRvw.tcktStsTypeCd = tcktStsId;
        ifAttrDsgnRvw.ifReqId = e.project.ifReqId;
        ifAttrDsgnRvw.dipByRgn = e.dst.interfaceDefinition.dipByRegion ?? "";
        ifAttrDsgnRvw.cpntId =
          e.dst.interfaceDefinition.outbound?.componentId ?? "";
        ifAttrDsgnRvw.cmnt = e.projectTcktInfo.dstDsgnCmnt;
        ifAttrDsgnRvw.updateDateTime =
          e.projectTcktInfo.dstDsgnTcktUpdateDateTime;
        if (
          !!dstComment &&
          dstComment.hasOwnProperty("editedFlg") &&
          dstComment.editedFlg
        ) {
          ifAttrDsgnRvw.cmnt = dstComment.value;
        }
        ifAttrDsgnRvwList.push(ifAttrDsgnRvw);
      }
    });

    const resultIfAttrDsgnRvwList = ifAttrDsgnRvwList.filter(
      (e) => e.tcktStsTypeCd === TcktStsTypeIfDsgn.DESIGN_REVIEW,
    );

    if (resultIfAttrDsgnRvwList.length === 0) {
      showToast({
        design: "alert",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00146),
      });
      return;
    }

    const sendIfBulkUpdateTicketsParam: IfBulkUpdateTicketsRequest = {
      ifAttrInptInfoList: resultIfAttrDsgnRvwList,
      evntGrpTypeCd: EvntGrp.EVNT_GRP_IF_010_004,
      dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM"),
    };

    if (isDiscardComment) {
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00034),
        onOkButtonClicked: () => {
          resetUserError();
          sendIfBulkUpdateTicketsRequest(sendIfBulkUpdateTicketsParam);
        },
      });
    } else {
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(
          ApplicationMessageScreen.APP_SCN_00169,
          "dismiss",
          "design request approval",
        ),
        onOkButtonClicked: () => {
          resetUserError();
          sendIfBulkUpdateTicketsRequest(sendIfBulkUpdateTicketsParam);
        },
      });
    }
  };

  const clickedReload = () => {
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
      onOkButtonClicked: () => {
        window.location.reload();
      },
    });
  };

  const clickedBackProject = () => {
    const transitionToProject = () => {
      const state = location.state as { prevPath: string } | undefined;

      if (!!state?.prevPath && state.prevPath !== "/project-detail") {
        const href = createPath({
          pathname: `/project-detail?pjtId=${params.pjtId}`,
        });
        navigate(href);
      } else {
        navigate(-1);
      }
    };
    if (unSaved) {
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
        onOkButtonClicked: () => {
          transitionToProject();
        },
      });
      return;
    }
    transitionToProject();
  };

  const clickedBackReference = () => {
    if (unSaved) {
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
        onOkButtonClicked: () => {
          navigate(-1);
        },
      });
      return;
    }
    navigate(-1);
  };

  const getSelectedTarget = () => {
    const spreadsheetData = _.cloneDeep(spreadsheetState);
    if (!spreadsheetData) return;
    const ifList = spreadsheetData.ifList.filter((e: Interface) => {
      return e.srcDipSelect === true || e.dstDipSelect === true;
    });
    if (ifList.length === 0) {
      showToast({
        design: "alert",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00035),
      });
      return;
    }
    return ifList;
  };

  const clickedWithdrawReviewRequest = () => {
    resetUserError();
    const ifList = getSelectedTarget();
    if (!ifList) {
      return;
    } else {
      const checkstatus = ifList.filter((e) => {
        return (
          (e.srcDipSelect === true &&
            e.projectTcktInfo.srcDsgnWFlwStsDsplyName !==
              DSGN_W_FLW_STS_DESIGN_REVIEW) ||
          (e.dstDipSelect === true &&
            e.projectTcktInfo.dstDsgnWFlwStsDsplyName !==
              DSGN_W_FLW_STS_DESIGN_REVIEW)
        );
      });
      if (checkstatus.length > 0) {
        showToast({
          design: "alert",
          message: messageForScreen(
            ApplicationMessageScreen.APP_SCN_00041,
            "withdraw review request",
            "Reviewing",
          ),
        });
        return;
      }
    }
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(
        ApplicationMessageScreen.APP_SCN_00169,
        "withdraw",
        "design review request",
      ),
      onOkButtonClicked: () => {
        let ifAttrInptInfoList = [] as IfAttrInptInfo[];
        ifList.forEach((e) => {
          if (e.srcDipSelect === true) {
            let ifAttrInptInfo = {} as IfAttrInptInfo;
            ifAttrInptInfo.index = e.idx;
            ifAttrInptInfo.tcktId = e.projectTcktInfo.srcDsgnTcktId;
            ifAttrInptInfo.ifReqId = e.project.ifReqId;
            ifAttrInptInfo.dipByRgn =
              e.src.interfaceDefinition.dipByRegion ?? "";
            ifAttrInptInfo.cpntId =
              e.src.interfaceDefinition.inbound?.componentId ?? "";
            ifAttrInptInfoList.push(ifAttrInptInfo);
          }
          if (e.dstDipSelect === true) {
            let ifAttrInptInfo = {} as IfAttrInptInfo;
            ifAttrInptInfo.index = e.idx;
            ifAttrInptInfo.tcktId = e.projectTcktInfo.dstDsgnTcktId;
            ifAttrInptInfo.ifReqId = e.project.ifReqId;
            ifAttrInptInfo.dipByRgn =
              e.dst.interfaceDefinition.dipByRegion ?? "";
            ifAttrInptInfo.cpntId =
              e.dst.interfaceDefinition.outbound?.componentId ?? "";
            ifAttrInptInfoList.push(ifAttrInptInfo);
          }
        });
        sendIfBulkUpdateTicketsRequest({
          ifAttrInptInfoList: ifAttrInptInfoList,
          evntGrpTypeCd: EvntGrp.EVNT_GRP_IF_010_003,
          dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM"),
        });
      },
    });
  };

  const clickedRequestReview = () => {
    resetUserError();
    const ifList = getSelectedTarget();
    if (!ifList) {
      return;
    } else {
      const checkstatus = ifList.filter((e) => {
        return (
          (e.srcDipSelect === true &&
            e.projectTcktInfo.srcDsgnWFlwStsDsplyName !==
              DSGN_W_FLW_STS_DESIGNING) ||
          (e.dstDipSelect === true &&
            e.projectTcktInfo.dstDsgnWFlwStsDsplyName !==
              DSGN_W_FLW_STS_DESIGNING)
        );
      });
      if (checkstatus.length > 0) {
        showToast({
          design: "alert",
          message: messageForScreen(
            ApplicationMessageScreen.APP_SCN_00041,
            "request review",
            "Designing",
          ),
        });
        return;
      }
    }
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(
        ApplicationMessageScreen.APP_SCN_00169,
        "request",
        "design review request",
      ),
      onOkButtonClicked: () => {
        let ifAttrInptInfoList = [] as IfAttrInptInfo[];
        ifList.forEach((e) => {
          if (!!e.srcDipSelect) {
            let ifAttrInptInfo = {} as IfAttrInptInfo;
            ifAttrInptInfo.index = e.idx;
            ifAttrInptInfo.tcktId = e.projectTcktInfo.srcDsgnTcktId;
            ifAttrInptInfo.ifReqId = e.project.ifReqId;
            ifAttrInptInfo.dipByRgn =
              e.src.interfaceDefinition.dipByRegion ?? "";
            ifAttrInptInfo.cpntId =
              e.src.interfaceDefinition.inbound?.componentId ?? "";
            ifAttrInptInfoList.push(ifAttrInptInfo);
          }
          if (!!e.dstDipSelect) {
            let ifAttrInptInfo = {} as IfAttrInptInfo;
            ifAttrInptInfo.index = e.idx;
            ifAttrInptInfo.tcktId = e.projectTcktInfo.dstDsgnTcktId;
            ifAttrInptInfo.ifReqId = e.project.ifReqId;
            ifAttrInptInfo.dipByRgn =
              e.dst.interfaceDefinition.dipByRegion ?? "";
            ifAttrInptInfo.cpntId =
              e.dst.interfaceDefinition.outbound?.componentId ?? "";
            ifAttrInptInfoList.push(ifAttrInptInfo);
          }
        });
        sendIfBulkUpdateTicketsRequest({
          ifAttrInptInfoList: ifAttrInptInfoList,
          evntGrpTypeCd: EvntGrp.EVNT_GRP_IF_010_001,
          dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM"),
        });

        setPageState((prevState) => ({
          ...prevState,
          prevActionSuccessMessage: messageForScreen(
            ApplicationMessageScreen.APP_SCN_00177,
          ),
        }));
      },
    });
  };

  const clickedReEnterAttribute = () => {
    resetUserError();
    const spreadsheetData = _.cloneDeep(spreadsheetState);
    if (!spreadsheetData) return;
    const ifList = spreadsheetData.ifList.filter((e: Interface) => {
      return e.srcDipSelect === true || e.dstDipSelect === true;
    });
    if (ifList.length === 0) {
      showToast({
        design: "alert",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00035),
      });
      return;
    }
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(
        ApplicationMessageScreen.APP_SCN_00169,
        "withdraw",
        "status to designing",
      ),
      onOkButtonClicked: () => {
        const ifAttrInptInfoList = [] as IfAttrInptInfo[];
        ifList.forEach((e: Interface) => {
          const isTargetBoth =
            e.srcDipSelect &&
            (e.src.interfaceDefinition.dipByRegion ===
              e.dst.interfaceDefinition.dipByRegion ||
              params.mode === PAGE_MODE.PRD_DPLYMNT_MODE);
          if (!!e.srcDipSelect && !!e.projectTcktInfo.srcDsgnTcktId) {
            const ifAttrInptInfo = {} as IfAttrInptInfo;
            ifAttrInptInfo.index = e.idx;
            ifAttrInptInfo.tcktId = e.projectTcktInfo.srcDsgnTcktId;
            ifAttrInptInfo.ifReqId = e.project.ifReqId;
            ifAttrInptInfo.dipByRgn =
              e.src.interfaceDefinition.dipByRegion ?? "";
            ifAttrInptInfo.cpntId =
              e.src.interfaceDefinition.inbound?.componentId ?? "";
            ifAttrInptInfoList.push(ifAttrInptInfo);
          }
          if (
            (isTargetBoth || !!e.dstDipSelect) &&
            !!e.projectTcktInfo.dstDsgnTcktId
          ) {
            const ifAttrInptInfo = {} as IfAttrInptInfo;
            ifAttrInptInfo.index = e.idx;
            ifAttrInptInfo.tcktId = e.projectTcktInfo.dstDsgnTcktId;
            ifAttrInptInfo.ifReqId = e.project.ifReqId;
            ifAttrInptInfo.dipByRgn =
              e.dst.interfaceDefinition.dipByRegion ?? "";
            ifAttrInptInfo.cpntId =
              e.dst.interfaceDefinition.outbound?.componentId ?? "";
            ifAttrInptInfoList.push(ifAttrInptInfo);
          }
        });
        sendIfBulkUpdateTicketsReEnterAttributesRequest({
          ifAttrInptInfoList: ifAttrInptInfoList,
          evntGrpTypeCd: EvntGrp.EVNT_GRP_IF_010_006,
          dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM"),
        });
      },
    });
  };

  const clickedConfirmDeploymentTarget = () => {
    const spreadsheetData = _.cloneDeep(spreadsheetState);
    if (!spreadsheetData) return;
    const ifList = spreadsheetData.ifList
      .map((e) => {
        const isInternalDIP =
          e.src.interfaceDefinition.dipByRegion ===
          e.dst.interfaceDefinition.dipByRegion;
        if (isInternalDIP) {
          e.srcInterruptType = undefined;
          e.dstInterruptType = shouldSetInterruptType(
            e,
            SrcDstTypeCd.DIP_INTERNAL_DESTINATION,
            false,
          )
            ? e.dstInterruptType
            : InterruptType.NOCHANGE;
        } else if (params.mode === PAGE_MODE.STG_DPLYMNT_MODE) {
          if (e.srcDipSelect && !e.dstDipSelect) {
            e.srcInterruptType = shouldSetInterruptType(
              e,
              SrcDstTypeCd.INTERDOMAIN_SOURCE,
              true,
            )
              ? InterruptType.PENDING
              : InterruptType.NOCHANGE;
            e.dstInterruptType = undefined;
          } else if (e.srcDipSelect && e.dstDipSelect) {
            e.srcInterruptType = shouldSetInterruptType(
              e,
              SrcDstTypeCd.INTERDOMAIN_SOURCE,
              false,
            )
              ? InterruptType.NONE
              : InterruptType.NOCHANGE;
            e.dstInterruptType = shouldSetInterruptType(
              e,
              SrcDstTypeCd.INTERDOMAIN_DESTINATION,
              false,
            )
              ? InterruptType.PENDING
              : InterruptType.NOCHANGE;
          } else if (!e.srcDipSelect && e.dstDipSelect) {
            e.srcInterruptType = undefined;
            e.dstInterruptType = shouldSetInterruptType(
              e,
              SrcDstTypeCd.INTERDOMAIN_DESTINATION,
              false,
            )
              ? InterruptType.PENDING
              : InterruptType.NOCHANGE;
          }
        } else if (
          params.mode === PAGE_MODE.PRD_DPLYMNT_MODE &&
          !!e.srcDipSelect
        ) {
          e.srcInterruptType = shouldSetInterruptType(
            e,
            SrcDstTypeCd.INTERDOMAIN_SOURCE,
            false,
          )
            ? InterruptType.NONE
            : InterruptType.NOCHANGE;
          e.dstInterruptType = shouldSetInterruptType(
            e,
            SrcDstTypeCd.INTERDOMAIN_DESTINATION,
            false,
          )
            ? InterruptType.PENDING
            : InterruptType.NOCHANGE;
        }
        return e;
      })
      .filter((e) => e.srcDipSelect === true || e.dstDipSelect === true);

    if (ifList.length === 0) {
      showToast({
        design: "alert",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00035),
      });
      return;
    }

    setPageState((prevState) => ({
      ...prevState,
      isPendingDisplay: true,
      ifList: ifList,
    }));
  };

  const onChangeReferenceType = (event: CustomEvent) => {
    resetUserError();
    const value = event.detail.value;
    changeMode(params.mode, value);
  };

  const transitionGodMode = () => {
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00046),
      onOkButtonClicked: () => {
        changeMode(PAGE_MODE.GOD_MODE, PAGE_TYPE.PRD_PJ_TYPE);
      },
    });
  };

  const clickedAddRow = () => {
    const insertRowIndex: number =
      (pageState.spreadsheetSelectedRowIndex ?? 0) + 1;
    const newSpreadsheetState: InterfaceSpreadsheetRow[] =
      spreadsheetState?.ifList ? [...spreadsheetState.ifList] : [];
    if (!spreadsheetState) return;
    const addSpreadsheetRow: InterfaceSpreadsheetRow = {
      ...INIT_ERROR_RESULT_DATA,
      idx: 0,
      isAddRow: true,
      existSrcDsgnCmnt: false,
      existDstDsgnCmnt: false,
      srcAction: "",
      dstAction: "",
      srcDipSelect: false,
      dstDipSelect: false,
      srcInterruptType: undefined,
      dstInterruptType: undefined,
      srcFileList: [...INIT_FILE_LIST],
      dstFileList: [...INIT_FILE_LIST],
      srcInboundOutputFileList: [...INIT_FILE_LIST],
      dstInboundOutputFileList: [...INIT_FILE_LIST],
      updateDateTime: "",
      srcDplymntReqSeqNum: "",
      srcDplymntDtime: "",
      dstDplymntReqSeqNum: "",
      dstDplymntDtime: "",
      project: {} as Project,
      projectTcktInfo: {} as ProjectTcktInfo,
      src: {} as Src,
      dst: {} as Dst,
      information: {} as Information,
    };
    addSpreadsheetRow.src.interfaceDefinition = {} as InterfaceDefinition;
    addSpreadsheetRow.src.interfaceDefinition.inbound = {} as Inbound;
    addSpreadsheetRow.src.interfaceDefinition.inbound.inboundNotification =
      {} as InboundNotification;
    addSpreadsheetRow.src.interfaceDefinition.inbound.inboundTransceiver =
      {} as InboundTransceiver;
    addSpreadsheetRow.src.interfaceDefinition.inbound.inboundConverter =
      {} as InboundConverter;
    addSpreadsheetRow.src.interfaceDefinition.inbound.inboundPartner =
      {} as InboundPartner;
    addSpreadsheetRow.src.interfaceDefinition.inbound.inboundMeta =
      {} as InboundMeta;
    addSpreadsheetRow.src.interfaceDefinition.inbound.inboundSecurity =
      {} as InboundSecurity;
    addSpreadsheetRow.src.interfaceDefinition.inbound.inboundSecurity.piidb =
      {} as Piidb;
    addSpreadsheetRow.src.interfaceDefinition.inbound.inboundSecurity.slk =
      {} as Slk;
    addSpreadsheetRow.src.interfaceDefinition.inbound.inboundSecurity.dlk =
      {} as Dlk;
    addSpreadsheetRow.src.interfaceDefinition.outbound = {} as Outbound;
    addSpreadsheetRow.src.interfaceDefinition.outbound.outboundNotification =
      {} as OutboundNotification;
    addSpreadsheetRow.src.interfaceDefinition.outbound.outboundTransceiver =
      {} as OutboundTransceiver;
    addSpreadsheetRow.src.interfaceDefinition.outbound.outboundConverter =
      {} as OutboundConverter;
    addSpreadsheetRow.src.interfaceDefinition.outbound.outboundPartner =
      {} as OutboundPartner;
    addSpreadsheetRow.src.interfaceDefinition.outbound.outboundMeta =
      {} as OutboundMeta;
    addSpreadsheetRow.src.interfaceDefinition.outbound.outboundSecurity =
      {} as OutboundSecurity;
    addSpreadsheetRow.dst.interfaceDefinition = {} as InterfaceDefinition;
    addSpreadsheetRow.dst.interfaceDefinition.inbound = {} as Inbound;
    addSpreadsheetRow.dst.interfaceDefinition.inbound.inboundNotification =
      {} as InboundNotification;
    addSpreadsheetRow.dst.interfaceDefinition.inbound.inboundTransceiver =
      {} as InboundTransceiver;
    addSpreadsheetRow.dst.interfaceDefinition.inbound.inboundConverter =
      {} as InboundConverter;
    addSpreadsheetRow.dst.interfaceDefinition.inbound.inboundPartner =
      {} as InboundPartner;
    addSpreadsheetRow.dst.interfaceDefinition.inbound.inboundMeta =
      {} as InboundMeta;
    addSpreadsheetRow.dst.interfaceDefinition.inbound.inboundSecurity =
      {} as InboundSecurity;
    addSpreadsheetRow.dst.interfaceDefinition.inbound.inboundSecurity.piidb =
      {} as Piidb;
    addSpreadsheetRow.dst.interfaceDefinition.inbound.inboundSecurity.slk =
      {} as Slk;
    addSpreadsheetRow.dst.interfaceDefinition.inbound.inboundSecurity.dlk =
      {} as Dlk;
    addSpreadsheetRow.dst.interfaceDefinition.outbound = {} as Outbound;
    addSpreadsheetRow.dst.interfaceDefinition.outbound.outboundNotification =
      {} as OutboundNotification;
    addSpreadsheetRow.dst.interfaceDefinition.outbound.outboundTransceiver =
      {} as OutboundTransceiver;
    addSpreadsheetRow.dst.interfaceDefinition.outbound.outboundConverter =
      {} as OutboundConverter;
    addSpreadsheetRow.dst.interfaceDefinition.outbound.outboundPartner =
      {} as OutboundPartner;
    addSpreadsheetRow.dst.interfaceDefinition.outbound.outboundMeta =
      {} as OutboundMeta;
    addSpreadsheetRow.dst.interfaceDefinition.outbound.outboundSecurity =
      {} as OutboundSecurity;

    addSpreadsheetRow.project.ifReqCnclTypeCd = IfReqCnclType.NORMAL;
    addSpreadsheetRow.src.interfaceDefinition.interfaceRequirementType = "";
    addSpreadsheetRow.dst.interfaceDefinition.interfaceRequirementType = "";

    newSpreadsheetState.splice(insertRowIndex, 0, addSpreadsheetRow);
    newSpreadsheetState.map((e, idx) => {
      e.idx = idx;
    });
    setSpreadsheetState({
      ...spreadsheetState,
      ifList: [...newSpreadsheetState],
    });
    const editedIfList: Interface[] = _.cloneDeep(pageState.editedIfList);
    // Set Edited Iflist
    const addSpreadsheetEditedRow = JSON.parse(
      JSON.stringify(addSpreadsheetRow),
    );
    addSpreadsheetEditedRow.project.ifReqCnclTypeCd = {
      initValue: "",
      editedFlg: true,
      value: IfReqCnclType.NORMAL,
      cmplCntnt: "ifReqCnclTypeCd",
    } as any;
    editedIfList.splice(insertRowIndex, 0, addSpreadsheetEditedRow);
    editedIfList.map((e, idx) => {
      e.idx = idx;
    });
    setPageState((prevState) => ({
      ...prevState,
      editedIfList: editedIfList,
    }));
  };

  /**
   * In Case IE Maintenance mode, validate IfList when request stg deployment.
   */
  const onClickRequestStgDeployment = (event: CustomEvent) => {
    resetUserError();
    const request = {
      dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM"),
      validationTypeCode: ValidationTypeCode.GOD_SAVE,
      pjtId: params.pjtId,
    };
    getIfDefinitionGodValidationResultRequest(request);
  };

  const onCellSelected = (event: CustomEvent) => {
    const rowIndex: number = event.detail.cell?.data.index;
    setPageState((prevState) => ({
      ...prevState,
      spreadsheetSelectedRowIndex: rowIndex,
    }));
  };

  /**
   * Determine whether to include file layout in response.
   * @returns Flag
   */
  const determineIncludeFileLayout = () => {
    switch (params.mode) {
      case PAGE_MODE.REF_MODE: // STG/PRD/Actvie/History
      case PAGE_MODE.STG_DPLYMNT_MODE:
      case PAGE_MODE.PRD_DPLYMNT_MODE:
      case PAGE_MODE.REQ_APPROVAL_MODE:
        return InDefCommonFlagType.NO;
      case PAGE_MODE.INPUT_MODE:
      case PAGE_MODE.REVIEW_MODE:
      case PAGE_MODE.GOD_MODE:
        return InDefCommonFlagType.YES;
      default:
        return InDefCommonFlagType.NO;
    }
  };

  /**
   * Create a file ID pull-down list linked to data type
   * @param iflist target
   * @param fileLayoutList source
   */
  const complementFileLayoutPulldownList = (
    iflist: any,
    fileLayoutList: any,
  ) => {
    if (!iflist || !fileLayoutList) {
      return;
    }

    iflist.map((e: Interface) => {
      e.srcFileList = JSON.parse(
        JSON.stringify(INIT_INTERFACE_DATA.srcFileList),
      );
      e.dstFileList = JSON.parse(
        JSON.stringify(INIT_INTERFACE_DATA.dstFileList),
      );
      e.srcInboundOutputFileList = JSON.parse(
        JSON.stringify(INIT_INTERFACE_DATA.srcInboundOutputFileList),
      );
      e.dstInboundOutputFileList = JSON.parse(
        JSON.stringify(INIT_INTERFACE_DATA.dstInboundOutputFileList),
      );
      fileLayoutList.forEach((fileLayout: GetFileLayout) => {
        if (fileLayout.dtKindId === e.src.interfaceDefinition?.dataKindId) {
          e.srcFileList!.push({
            label: fileLayout.fileId,
            value: fileLayout.fileId,
          } as Option);
        }
        if (fileLayout.dtKindId === e.dst.interfaceDefinition?.dataKindId) {
          e.dstFileList!.push({
            label: fileLayout.fileId,
            value: fileLayout.fileId,
          } as Option);
        }
        if (
          fileLayout.dtKindId === e.src.interfaceDefinition?.dataKindId &&
          fileLayout.bsFileFlg === InDefCommonFlagType.YES
        ) {
          e.srcInboundOutputFileList!.push({
            label: fileLayout.fileId,
            value: fileLayout.fileId,
          } as Option);
        }
        if (
          fileLayout.dtKindId === e.dst.interfaceDefinition?.dataKindId &&
          fileLayout.bsFileFlg === InDefCommonFlagType.YES
        ) {
          e.dstInboundOutputFileList!.push({
            label: fileLayout.fileId,
            value: fileLayout.fileId,
          } as Option);
        }
      });
    });
  };

  const handleResize = (heightOtherThanSpreadsheet: number) => {
    return () => {
      const pageInnerHeight = window.innerHeight;
      document.documentElement.style.setProperty(
        "--main-spreadsheet-max-height",
        `${pageInnerHeight - heightOtherThanSpreadsheet}px`,
      );
    };
  };
  //JDI-2369 Resize Spreadsheet height depending on page magnification.
  useEffect(() => {
    const pageHeight = window.innerHeight;
    switch (params.mode) {
      case PAGE_MODE.REF_MODE:
        if (!pageState.isHistoryDisplay) {
          const refModeEventHandler = handleResize(400);
          document.documentElement.style.setProperty(
            "--main-spreadsheet-max-height",
            `${pageHeight - 400}px`,
          );
          window.addEventListener("resize", refModeEventHandler);
          return () => {
            window.removeEventListener("resize", refModeEventHandler);
          };
        } else {
          const historyModeIventHandler = handleResize(200);
          document.documentElement.style.setProperty(
            "--main-spreadsheet-max-height",
            `${pageHeight - 200}px`,
          );
          window.addEventListener("resize", historyModeIventHandler);
          return () => {
            window.removeEventListener("resize", historyModeIventHandler);
          };
        }
      case PAGE_MODE.INPUT_MODE:
        const normalModeEventHandler = handleResize(200);
        document.documentElement.style.setProperty(
          "--main-spreadsheet-max-height",
          `${pageHeight - 200}px`,
        );
        window.addEventListener("resize", normalModeEventHandler);
        return () => {
          window.removeEventListener("resize", normalModeEventHandler);
        };
      case PAGE_MODE.STG_DPLYMNT_MODE:
        const stgDeploymentModeEventHandler = handleResize(200);
        document.documentElement.style.setProperty(
          "--main-spreadsheet-max-height",
          `${pageHeight - 200}px`,
        );
        window.addEventListener("resize", stgDeploymentModeEventHandler);
        return () => {
          window.removeEventListener("resize", stgDeploymentModeEventHandler);
        };
      case PAGE_MODE.PRD_DPLYMNT_MODE:
        const prdDeploymentModeEventHandler = handleResize(200);
        document.documentElement.style.setProperty(
          "--main-spreadsheet-max-height",
          `${pageHeight - 200}px`,
        );
        window.addEventListener("resize", prdDeploymentModeEventHandler);
        return () => {
          window.removeEventListener("resize", prdDeploymentModeEventHandler);
        };
      case PAGE_MODE.REQ_APPROVAL_MODE:
        const reqApprovalModeEventHandler = handleResize(250);
        document.documentElement.style.setProperty(
          "--main-spreadsheet-max-height",
          `${pageHeight - 250}px`,
        );
        window.addEventListener("resize", reqApprovalModeEventHandler);
        return () => {
          window.removeEventListener("resize", reqApprovalModeEventHandler);
        };
      case PAGE_MODE.REVIEW_MODE:
        const reviewModeEventHandler = handleResize(280);
        document.documentElement.style.setProperty(
          "--main-spreadsheet-max-height",
          `${pageHeight - 280}px`,
        );
        window.addEventListener("resize", reviewModeEventHandler);
        return () => {
          window.removeEventListener("resize", reviewModeEventHandler);
        };
      case PAGE_MODE.GOD_MODE:
        const godModeEventHandler = handleResize(450);
        document.documentElement.style.setProperty(
          "--main-spreadsheet-max-height",
          `${pageHeight - 450}px`,
        );
        window.addEventListener("resize", godModeEventHandler);
        return () => {
          window.removeEventListener("resize", godModeEventHandler);
        };
    }
  }, [pageState.isHistoryDisplay]);

  /**
   * Get number of items that match the conditions for summary.
   * @param spreadsheetState SpreadsheetState
   * @param targetDIP DIP By Region
   * @param srcDstType srcDstType
   * @param actionType action
   * @returns Number of items that matched the conditions
   */
  const countMatchingElements = (
    spreadsheetState: SpreadsheetState,
    targetDIP: string,
    srcDstType: string,
    actionType: string,
  ): number => {
    if (srcDstType === SrcDstType.Source && actionType === "ALL") {
      return spreadsheetState.ifList.filter(
        (item) =>
          item.src.interfaceDefinition.dipByRegion === targetDIP &&
          item.projectTcktInfo.srcDsgnWFlwStsDsplyName ===
            DSGN_W_FLW_STS_DESIGN_REVIEW,
      ).length;
    } else if (srcDstType === SrcDstType.Source) {
      return spreadsheetState.ifList.filter(
        (item) =>
          item.srcAction === actionType &&
          item.src.interfaceDefinition.dipByRegion === targetDIP,
      ).length;
    } else if (srcDstType === SrcDstType.Destination && actionType === "ALL") {
      return spreadsheetState.ifList.filter(
        (item) =>
          item.dst.interfaceDefinition.dipByRegion === targetDIP &&
          item.projectTcktInfo.dstDsgnWFlwStsDsplyName ===
            DSGN_W_FLW_STS_DESIGN_REVIEW,
      ).length;
    } else {
      return spreadsheetState.ifList.filter(
        (item) =>
          item.dstAction === actionType &&
          item.dst.interfaceDefinition.dipByRegion === targetDIP,
      ).length;
    }
  };

  /**
   * SearchContent
   */
  const onChangeValueHandle = (name: string) => (event: CustomEvent) => {
    const value = event.detail.value;
    setPageState((prevState) => ({
      ...prevState,
      searchForm: {
        ...prevState.searchForm,
        [name]: value,
      },
    }));
  };

  const onClickSearch = () => {
    setPageState((prevState) => ({
      ...prevState,
      alertMessage: {},
    }));
    if (params.type === PAGE_TYPE.ACTIVE_PJ_TYPE) {
      sendGetProjectsRequest({
        pjtStsList: [PJT_STS.OPEN],
        pjtLnchTypeList: [
          PjtLnchType.REGULAR,
          PjtLnchType.GOD,
          PjtLnchType.NONAME,
        ],
        dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM"),
      });
    } else {
      const iFDefinitionsRequest: GetIFDefinitionsRequest = {
        dfnSetVerNum: params.dfnSetVerNum,
        snapshot: {
          ...(!!searchForm.srcDipByRgnOrDip && {
            srcDipByRgnOrDip: searchForm.srcDipByRgnOrDip,
          }),
          ...(!!searchForm.srcIfId && { srcIfId: searchForm.srcIfId }),
          ...(!!searchForm.srcInbdId && { srcInbdId: searchForm.srcInbdId }),
          ...(!!searchForm.srcInbdCpntId && {
            srcInbdCpntId: searchForm.srcInbdCpntId,
          }),
          ...(!!searchForm.dstDipByRgnOrDip && {
            dstDipByRgnOrDip: searchForm.dstDipByRgnOrDip,
          }),
          ...(!!searchForm.dstIfId && { dstIfId: searchForm.dstIfId }),
          ...(!!searchForm.dstOtbdId && { dstOtbdId: searchForm.dstOtbdId }),
          ...(!!searchForm.dstOtbdCpntId && {
            dstOtbdCpntId: searchForm.dstOtbdCpntId,
          }),
          ...(!!searchForm.interfaceNameEnglish && {
            interfaceNameEnglish: searchForm.interfaceNameEnglish,
          }),
          ...(!!searchForm.interfaceNameJapanese && {
            interfaceNameJapanese: searchForm.interfaceNameJapanese,
          }),
          isPrd:
            params.type === ReferenceModeType.ENVIRONMENT_PRD ? true : false,
          andCondDip: true,
          andCondIfId: true,
          andCondInOtbdId: true,
          andCondInOtbdCpntId: true,
        },
      };
      iFDefinitionsRequest.includeFileLayout = determineIncludeFileLayout();
      sendGetIFDefinitionsRequest(iFDefinitionsRequest);
    }

    return (
      <FrVrfAccordion>
        <FrVrfPanel>
          <div style={{ display: "flex" }}>
            <FrVrfDropdownField
              includeDefaultValue={false}
              selectedValue={params.type}
              onValueChanged={onChangeReferenceType}
              items={
                pageState.interfaceListGeneralCodeState.godReferenceModeType
              }
              style={{
                "--vrf-dropdown-field-select-width": "150px",
              }}
            />
            <div style={{ width: "90%", paddingTop: "7px" }}>
              <FrVrfFormPanel
                columns={2}
                style={{
                  "--vrf-form-panel-padding-top": "0px",
                  "--vrf-form-panel-padding-bottom": "5px",
                  "--vrf-single-line-input-field-label-width": "100px",
                  "--vrf-single-line-input-field-input-width": "200px",
                  "--vrf-dropdown-field-label-width": "100px",
                  "--vrf-dropdown-field-select-width": "200px",
                }}
              >
                <FrVrfFormPanel>
                  <div style={{ display: "flex" }}>
                    <FrVrfDropdownField
                      autocomplete={false}
                      labelContent="Src DIP"
                      selectedValue={searchForm.srcDipByRgnOrDip}
                      includeDefaultValue={true}
                      items={interfaceListGeneralCodeState.dipByRgnOrDipList}
                      onValueChanged={onChangeValueHandle("srcDipByRgnOrDip")}
                    />
                    <FrVrfDropdownField
                      autocomplete={false}
                      labelContent="Dst DIP"
                      selectedValue={searchForm.dstDipByRgnOrDip}
                      includeDefaultValue={true}
                      items={interfaceListGeneralCodeState.dipByRgnOrDipList}
                      onValueChanged={onChangeValueHandle("dstDipByRgnOrDip")}
                    />
                  </div>
                  <div style={{ display: "flex" }}>
                    <FrVrfSingleLineInputField
                      labelContent="Src Inbound Component ID"
                      content={searchForm.srcInbdCpntId}
                      onInputValueChanged={onChangeValueHandle("srcInbdCpntId")}
                    />
                    <FrVrfSingleLineInputField
                      labelContent="Dst Outbound Component ID"
                      content={searchForm.dstOtbdCpntId}
                      onInputValueChanged={onChangeValueHandle("dstOtbdCpntId")}
                    />
                  </div>
                  <div style={{ display: "flex" }}>
                    <FrVrfSingleLineInputField
                      labelContent="Interface Name(English)"
                      content={searchForm.interfaceNameEnglish}
                      onInputValueChanged={onChangeValueHandle(
                        "interfaceNameEnglish",
                      )}
                    />
                    <FrVrfSingleLineInputField
                      labelContent="Interface Name(Japanese)"
                      content={searchForm.interfaceNameJapanese}
                      onInputValueChanged={onChangeValueHandle(
                        "interfaceNameJapanese",
                      )}
                    />
                  </div>
                </FrVrfFormPanel>
                {/* JDI-2368 Padding for Add Saerch condition. */}
                <FrVrfFormPanel style={{ paddingBottom: "41px" }}>
                  <div style={{ display: "flex" }}>
                    <FrVrfSingleLineInputField
                      labelContent="Src Interface ID"
                      content={searchForm.srcIfId}
                      onInputValueChanged={onChangeValueHandle("srcIfId")}
                    />
                    <FrVrfSingleLineInputField
                      labelContent="Dst Interface ID"
                      content={searchForm.dstIfId}
                      onInputValueChanged={onChangeValueHandle("dstIfId")}
                    />
                  </div>
                  <div style={{ display: "flex" }}>
                    <FrVrfSingleLineInputField
                      labelContent="Src Inbound ID"
                      content={searchForm.srcInbdId}
                      onInputValueChanged={onChangeValueHandle("srcInbdId")}
                    />
                    <FrVrfSingleLineInputField
                      labelContent="Dst Outbound ID"
                      content={searchForm.dstOtbdId}
                      onInputValueChanged={onChangeValueHandle("dstOtbdId")}
                    />
                  </div>
                </FrVrfFormPanel>
              </FrVrfFormPanel>
            </div>
            <FrVrfButton
              style={{ display: "flex", alignItems: "flex-end" }}
              content="Search"
              theme="primary"
              size="medium"
              onClicked={onClickSearch}
            />
          </div>
        </FrVrfPanel>
      </FrVrfAccordion>
    );
  };

  /**
   * Confirm Dialog
   */
  const CreateDataKindConfirmDialog: React.FC = () => {
    const onClickConfirmOkButton = () => {
      resetUserError();
      const issuedRowIdx =
        pageState.createFileLayoutConfirmDialogState.issuedRowIdx;
      const issuedEventName =
        pageState.createFileLayoutConfirmDialogState.issuedEventName;
      const createFileLayoutRequest =
        pageState.createFileLayoutConfirmDialogState.createFileLayoutRequest;
      if (
        issuedRowIdx === undefined ||
        issuedEventName === undefined ||
        createFileLayoutRequest === undefined
      )
        return;
      sendCreateFileLayoutRequest(createFileLayoutRequest);
      setPageState((prevState) => ({
        ...prevState,
        issuedRowIdx,
        issuedEventName,
        createFileLayoutConfirmDialogState:
          INIT_CREATE_FILE_LAYOUT_CONFIRM_DIALOG_STATE,
      }));
    };
    return (
      <>
        {createModal(
          "",
          <div>
            <div style={{ display: "flex", marginBottom: "10px" }}>
              <FrVrfIcon
                icon="frIcon:question"
                style={{
                  "--vrf-icon-size": "38px",
                  margin: "4px",
                }}
              />
              <FrVrfTextDisplayField
                style={{
                  "--vrf-font-color": VRF_PRIMARY_COLOR,
                  "--vrf-text-display-field-font-size": "25px",
                  "--vrf-text-display-field-font-weight": "bold",
                  margin: "4px",
                }}
                text={"Are you sure you want to continue?"}
              />
            </div>
            {messageForScreen(
              ApplicationMessageScreen.APP_SCN_00179,
              "${FileID}",
              "${DIP Name}",
              "${COMPONENT_ID}",
            )
              .split("\n")
              .map((line, i) => (
                <p key={`confirm-message-${i}`} style={{ margin: 0 }}>
                  {line}
                </p>
              ))}

            <FrVrfFooter>
              <>
                <FrVrfButton
                  content="Cancel"
                  theme="secondary"
                  size="large"
                  onClicked={() => {
                    setPageState((prevState) => ({
                      ...prevState,
                      createFileLayoutConfirmDialogState:
                        INIT_CREATE_FILE_LAYOUT_CONFIRM_DIALOG_STATE,
                    }));
                  }}
                />
                <FrVrfButton
                  content="OK"
                  theme="primary"
                  size="large"
                  onClicked={onClickConfirmOkButton}
                />
              </>
            </FrVrfFooter>
          </div>,
          () => {},
          "medium",
        )}
      </>
    );
  };

  const Summary: React.FC = () => {
    if (spreadsheetState === undefined) return null;
    let srcResult: string = "";
    let dstResult: string = "";
    Array.from(
      new Set(
        spreadsheetState.ifList.flatMap((e) => [
          e.src.interfaceDefinition.dipByRegion,
          e.dst.interfaceDefinition.dipByRegion,
        ]),
      ),
    )
      .sort()
      .forEach((targetDip) => {
        if (targetDip === undefined) return;
        const srcReviewingStatusTotal: number = countMatchingElements(
          spreadsheetState,
          targetDip,
          SrcDstType.Source,
          "ALL",
        );
        const dstReviewingStatusTotal: number = countMatchingElements(
          spreadsheetState,
          targetDip,
          SrcDstType.Destination,
          "ALL",
        );
        if (srcReviewingStatusTotal !== 0) {
          srcResult += `${targetDip}: ${srcReviewingStatusTotal} (${countMatchingElements(
            spreadsheetState,
            targetDip,
            SrcDstType.Source,
            ReviewActionType.APPROVE,
          ).toString()}/${countMatchingElements(
            spreadsheetState,
            targetDip,
            SrcDstType.Source,
            ReviewActionType.REJECT,
          ).toString()}) `;
        }
        if (dstReviewingStatusTotal !== 0) {
          dstResult += `${targetDip}: ${dstReviewingStatusTotal}(${countMatchingElements(
            spreadsheetState,
            targetDip,
            SrcDstType.Destination,
            ReviewActionType.APPROVE,
          )}/${countMatchingElements(
            spreadsheetState,
            targetDip,
            SrcDstType.Destination,
            ReviewActionType.REJECT,
          )}) `;
        }
      });

    return (
      <>
        <FrVrfTextDisplayField
          style={{ "--vrf-text-display-field-font-size": "14px" }}
          text={`Total(Approve/Reject) - Src : [ ${srcResult}]`}
        />
        <FrVrfTextDisplayField
          style={{ "--vrf-text-display-field-font-size": "14px" }}
          text={`Total(Approve/Reject) - Dst : [ ${dstResult}]`}
        />
      </>
    );
  };

  const selectedRowIndex = pageState.spreadsheetSelectedRowIndex;

  const selectedRow =
    selectedRowIndex === undefined
      ? undefined
      : spreadsheetState?.ifList?.[selectedRowIndex];

  const selectedRowErrorMessages = createErrorPanelMessages({
    row: selectedRow,
    frontendValidationMessages:
      selectedRowIndex === undefined
        ? []
        : frontendValidationMessagesByRowIndex[selectedRowIndex],
  });

  const shouldShowSelectedRowErrorPanel = [
    PAGE_MODE.INPUT_MODE,
    PAGE_MODE.REQ_APPROVAL_MODE,
    PAGE_MODE.REVIEW_MODE,
  ].includes(params.mode);

  return (
    <>
      {pageState.createFileLayoutConfirmDialogState.isShow && (
        <CreateDataKindConfirmDialog />
      )}
      {commentDialogState.isShow && <CommentDialogContent />}
      {((pageState.authorized &&
        params.mode === PAGE_MODE.REF_MODE &&
        !pageState.isHistoryDisplay) ||
        (params.mode === PAGE_MODE.GOD_MODE &&
          (params.type === ReferenceModeType.ENVIRONMENT_PRD ||
            params.type === ReferenceModeType.ENVIRONMENT_STG))) && (
        <FrVrfAccordion>
          <FrVrfPanel>
            <div style={{ display: "flex" }}>
              <FrVrfDropdownField
                includeDefaultValue={false}
                selectedValue={params.type}
                onValueChanged={onChangeReferenceType}
                items={
                  params.mode === PAGE_MODE.REF_MODE
                    ? pageState.interfaceListGeneralCodeState.referenceModeType
                    : pageState.interfaceListGeneralCodeState
                        .godReferenceModeType
                }
                style={{
                  "--vrf-dropdown-field-select-width": "150px",
                }}
              />
              <div style={{ width: "90%", paddingTop: "7px" }}>
                <FrVrfFormPanel
                  columns={2}
                  style={{
                    "--vrf-form-panel-padding-top": "0px",
                    "--vrf-form-panel-padding-bottom": "5px",
                    "--vrf-single-line-input-field-label-width": "100px",
                    "--vrf-single-line-input-field-input-width": "200px",
                    "--vrf-dropdown-field-label-width": "100px",
                    "--vrf-dropdown-field-select-width": "200px",
                  }}
                >
                  <FrVrfFormPanel>
                    <div style={{ display: "flex" }}>
                      <FrVrfDropdownField
                        autocomplete={false}
                        labelContent="Src DIP"
                        selectedValue={searchForm.srcDipByRgnOrDip}
                        includeDefaultValue={true}
                        items={interfaceListGeneralCodeState.dipByRgnOrDipList}
                        onValueChanged={onChangeValueHandle("srcDipByRgnOrDip")}
                      />
                      <FrVrfDropdownField
                        autocomplete={false}
                        labelContent="Dst DIP"
                        selectedValue={searchForm.dstDipByRgnOrDip}
                        includeDefaultValue={true}
                        items={interfaceListGeneralCodeState.dipByRgnOrDipList}
                        onValueChanged={onChangeValueHandle("dstDipByRgnOrDip")}
                      />
                    </div>
                    <div style={{ display: "flex" }}>
                      <FrVrfSingleLineInputField
                        labelContent="Src Inbound Component ID"
                        content={searchForm.srcInbdCpntId}
                        onInputValueChanged={onChangeValueHandle(
                          "srcInbdCpntId",
                        )}
                      />
                      <FrVrfSingleLineInputField
                        labelContent="Dst Outbound Component ID"
                        content={searchForm.dstOtbdCpntId}
                        onInputValueChanged={onChangeValueHandle(
                          "dstOtbdCpntId",
                        )}
                      />
                    </div>
                    <div style={{ display: "flex" }}>
                      <FrVrfSingleLineInputField
                        labelContent="Interface Name(English)"
                        content={searchForm.interfaceNameEnglish}
                        onInputValueChanged={onChangeValueHandle(
                          "interfaceNameEnglish",
                        )}
                      />
                      <FrVrfSingleLineInputField
                        labelContent="Interface Name(Japanese)"
                        content={searchForm.interfaceNameJapanese}
                        onInputValueChanged={onChangeValueHandle(
                          "interfaceNameJapanese",
                        )}
                      />
                    </div>
                  </FrVrfFormPanel>
                  {/* JDI-2368 Padding for Add Saerch condition. */}
                  <FrVrfFormPanel style={{ paddingBottom: "41px" }}>
                    <div style={{ display: "flex" }}>
                      <FrVrfSingleLineInputField
                        labelContent="Src Interface ID"
                        content={searchForm.srcIfId}
                        onInputValueChanged={onChangeValueHandle("srcIfId")}
                      />
                      <FrVrfSingleLineInputField
                        labelContent="Dst Interface ID"
                        content={searchForm.dstIfId}
                        onInputValueChanged={onChangeValueHandle("dstIfId")}
                      />
                    </div>
                    <div style={{ display: "flex" }}>
                      <FrVrfSingleLineInputField
                        labelContent="Src Inbound ID"
                        content={searchForm.srcInbdId}
                        onInputValueChanged={onChangeValueHandle("srcInbdId")}
                      />
                      <FrVrfSingleLineInputField
                        labelContent="Dst Outbound ID"
                        content={searchForm.dstOtbdId}
                        onInputValueChanged={onChangeValueHandle("dstOtbdId")}
                      />
                    </div>
                  </FrVrfFormPanel>
                </FrVrfFormPanel>
              </div>
              {pageState.authorized &&
                params.mode === PAGE_MODE.REF_MODE &&
                !pageState.isHistoryDisplay && (
                  <div style={{ display: "flex", flexFlow: "column" }}>
                    <FrVrfButton
                      content="IE Maintenance"
                      theme="caution"
                      size="medium"
                      style={{ marginBottom: "1em" }}
                      onClicked={transitionGodMode}
                      authActId="interface_list_reference.button.god"
                    />
                    <FrVrfButton
                      content="Search"
                      theme="primary"
                      size="medium"
                      onClicked={onClickSearch}
                    />
                  </div>
                )}
              {params.mode === PAGE_MODE.GOD_MODE &&
                (params.type === ReferenceModeType.ENVIRONMENT_PRD ||
                  params.type === ReferenceModeType.ENVIRONMENT_STG) && (
                  <FrVrfButton
                    style={{ display: "flex", alignItems: "flex-end" }}
                    content="Search"
                    theme="primary"
                    size="medium"
                    onClicked={onClickSearch}
                  />
                )}
            </div>
          </FrVrfPanel>
        </FrVrfAccordion>
      )}
      {/* Alert Bar */}
      <>
        {!!alertMessage.successMessage && (
          <FrVrfAlertBar
            style={{ "--vrf-error-color": VRF_SUCCESS_COLOR }}
            messageList={pageState.alertMessage.successMessage}
          />
        )}
        {!!alertMessage.errorMessage && (
          <FrVrfAlertBar messageList={pageState.alertMessage.errorMessage} />
        )}
        {!!alertMessage.warningMessage && (
          <FrVrfAlertBar
            theme="warning"
            messageList={pageState.alertMessage.warningMessage}
          />
        )}
      </>
      <div style={{ marginLeft: "30px" }}>
        {params.mode === PAGE_MODE.REVIEW_MODE && <Summary />}
      </div>
      {shouldShowSelectedRowErrorPanel && (
        <SelectedRowErrorPanel
          selectedRowIndex={pageState.spreadsheetSelectedRowIndex}
          errorMessages={selectedRowErrorMessages}
          srcDip={selectedRow?.src?.interfaceDefinition?.dipByRegion}
          srcInboundId={
            selectedRow?.src?.interfaceDefinition?.inbound?.inboundId
          }
          dstDip={selectedRow?.dst?.interfaceDefinition?.dipByRegion}
          dstOutboundId={
            selectedRow?.dst?.interfaceDefinition?.outbound?.outboundId
          }
        />
      )}
      {
        <div
          style={{
            display: "flex",
            minHeight: "32px",
            marginLeft: "14px",
            marginBottom: isDiffVisible ? "0px" : "5px",
            alignItems:
              params.mode === PAGE_MODE.GOD_MODE &&
              params.type !== PAGE_TYPE.ACTIVE_PJ_TYPE
                ? "flex-end"
                : "normal",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <FrVrfButton
              content="Basic Information"
              size="small"
              theme={presetParentSelectedItems.basic ? "primary" : "secondary"}
              onClicked={onClickPresetButtonHandle("basic")}
              style={{
                paddingLeft: "6px",
                "--vrf-button-small-margin": "1px",
                "--vrf-button-small-min-width": "110px",
              }}
            />
            <FrVrfButton
              content="Source"
              size="small"
              theme={presetParentSelectedItems.src ? "primary" : "secondary"}
              onClicked={onClickPresetButtonHandle("src")}
              style={{
                paddingLeft: "6px",
                "--vrf-button-small-margin": "1px",
                "--vrf-button-small-min-width": "110px",
              }}
            />
            <FrVrfIcon
              onIconClicked={() =>
                setPresetSubCategoriesVisible((prev) => ({
                  ...prev,
                  src: !prev.src,
                }))
              }
              icon={
                presetSubCategoriesVisible.src
                  ? "frIcon:chevron-left"
                  : "frIcon:chevron-right"
              }
              style={{
                "--vrf-icon-size": "18px",
              }}
            />
            <FrVrfCheckboxesField
              options={srcInboundColumnPresets}
              checkList={srcPresetSelectedItems}
              onCheckboxesChanged={onClickPresetCheckboxHandle("src")}
              style={{
                "--vrf-checkboxes-field-label-width": "auto",
                display: presetSubCategoriesVisible.src ? "block" : "none",
              }}
            />
            <FrVrfButton
              content="Cross DIP"
              size="small"
              theme={presetParentSelectedItems.cross ? "primary" : "secondary"}
              onClicked={onClickPresetButtonHandle("cross")}
              style={{
                paddingLeft: "6px",
                "--vrf-button-small-margin": "1px",
                "--vrf-button-small-min-width": "110px",
              }}
            />
            <FrVrfIcon
              onIconClicked={() =>
                setPresetSubCategoriesVisible({
                  ...presetSubCategoriesVisible,
                  cross: !presetSubCategoriesVisible.cross,
                })
              }
              icon={
                presetSubCategoriesVisible.cross
                  ? "frIcon:chevron-left"
                  : "frIcon:chevron-right"
              }
              style={{
                "--vrf-icon-size": "18px",
              }}
            />
            <FrVrfCheckboxesField
              options={crossDomainColumnPresetsToUse}
              checkList={crossPresetSelectedItems}
              onCheckboxesChanged={onClickPresetCheckboxHandle("cross")}
              style={{
                "--vrf-checkboxes-field-label-width": "auto",
                display: presetSubCategoriesVisible.cross ? "block" : "none",
              }}
            />
            <FrVrfButton
              content="Destination"
              size="small"
              theme={presetParentSelectedItems.dst ? "primary" : "secondary"}
              onClicked={onClickPresetButtonHandle("dst")}
              style={{
                paddingLeft: "6px",
                "--vrf-button-small-margin": "1px",
                "--vrf-button-small-min-width": "110px",
              }}
            />
            <FrVrfIcon
              onIconClicked={() =>
                setPresetSubCategoriesVisible({
                  ...presetSubCategoriesVisible,
                  dst: !presetSubCategoriesVisible.dst,
                })
              }
              icon={
                presetSubCategoriesVisible.dst
                  ? "frIcon:chevron-left"
                  : "frIcon:chevron-right"
              }
              style={{
                "--vrf-icon-size": "18px",
              }}
            />
            <FrVrfCheckboxesField
              options={dstOutboundColumnPresets}
              checkList={dstPresetSelectedItems}
              onCheckboxesChanged={onClickPresetCheckboxHandle("dst")}
              style={{
                "--vrf-checkboxes-field-label-width": "auto",
                display: presetSubCategoriesVisible.dst ? "block" : "none",
              }}
            />
          </div>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              verticalAlign: "middle",
              marginRight: "8px",
              marginBottom: "4px",
            }}
          >
            <DiffDropdownField
              visible={isDiffVisible}
              selectedValue={pageState.reviewDiffState.selectedTarget}
              onValueChanged={onChangeReviewDiff}
            />
          </span>
          {params.mode === PAGE_MODE.GOD_MODE &&
            params.type !== PAGE_TYPE.ACTIVE_PJ_TYPE && (
              <FrVrfButtonPanel>
                <FrVrfButton
                  content="Add Row"
                  size="medium"
                  theme="secondary"
                  slot="left"
                  onClicked={clickedAddRow}
                  authActId="interface_list_god.button.add_row"
                />
              </FrVrfButtonPanel>
            )}
        </div>
      }
      <div
        onClickCapture={handleSpreadsheetAreaClickCapture}
        onMouseEnter={handleHoverAreaMouseEnter}
        onMouseLeave={handleHoverAreaMouseLeave}
        style={{
          position: "relative",
          cursor: "default",
          marginLeft: [PAGE_MODE.REF_MODE].includes(params.mode)
            ? "21px"
            : "0px",
        }}
      >
        <FrVrfSpreadsheet
          data={spreadsheetInitialData}
          onInitialized={onInitializedSheet}
          templateUrl={interfaceListTemplateFileUrl}
          onCellBulkEdited={onCellBulkEdited}
          onCellMouseEntered={handleHover}
          onCellEdited={onCellEdited}
          onCellClicked={onCellClicked}
          onCellSelected={onCellSelected}
          minHeight={700}
        />
        <DiffTooltip {...tooltipProps} />
      </div>
      {/* Footer */}
      {pageState.authorized && (
        <FrVrfFooter>
          {params.mode === PAGE_MODE.REF_MODE && pageState.isHistoryDisplay && (
            <>
              <FrVrfButton
                content="Back to Interface List"
                theme="secondary"
                size="large"
                onClicked={() => {
                  setPageState((prevState) => ({
                    ...prevState,
                    isHistoryDisplay: false,
                    ifList: [],
                    alertMessage: {},
                  }));
                  resetUserError();
                  // Set IF list of last search conditions
                  onGetIFDefinitionsResponse();
                }}
                slot="left"
              />
            </>
          )}
          {params.mode === PAGE_MODE.INPUT_MODE && (
            <>
              <FrVrfButton
                content="Back to Project"
                theme="secondary"
                size="large"
                onClicked={clickedBackProject}
                slot="left"
                authActId="interface_list_input.button.back_to_project"
              />
              <FrVrfButton
                content="Create SHP Csv"
                theme="primary"
                size="large"
                onClicked={onClickCreateSHPCsv}
                visible={includeSHP()}
                authActId="interface_list_input.button.create_shp_csv"
              />
              <FrVrfButton
                content="Create Manifest.json"
                theme="primary"
                size="large"
                onClicked={clickedCreateManifestZip}
                authActId="interface_list_input.button.create_manifest_json"
              />
              <FrVrfButton
                content="Reload"
                theme="primary"
                size="large"
                disabled={!unSaved}
                onClicked={clickedReload}
                authActId="interface_list_input.button.input_reload"
              />
              <FrVrfButton
                content="Save"
                theme="primary"
                size="large"
                disabled={!unSaved}
                onClicked={clickedSave}
                authActId="interface_list_input.button.input_save"
              />
              <FrVrfButton
                content="Validate"
                theme="primary"
                size="large"
                onClicked={onClickValidate}
                disabled={unSaved}
                authActId="interface_list_input.button.input_validate"
              />
              <FrVrfButton
                content="Select Review Target"
                theme="secondary"
                size="large"
                disabled={unSaved || !params.pjtId}
                onClicked={transitionHandle(PAGE_MODE.REQ_APPROVAL_MODE)}
                authActId="interface_list_input.button.select_review_target"
              />
              <FrVrfButton
                content="Request STG Deployment"
                theme="secondary"
                size="large"
                disabled={unSaved || !params.pjtId}
                onClicked={transitionHandle(PAGE_MODE.STG_DPLYMNT_MODE)}
                authActId="interface_list_input.button.request_stg_deployment"
              />
              <FrVrfButton
                content="Request PRD Deployment"
                theme="secondary"
                size="large"
                disabled={unSaved || !params.pjtId}
                onClicked={transitionHandle(PAGE_MODE.PRD_DPLYMNT_MODE)}
                authActId="interface_list_input.button.request_prd_deployment"
              />
            </>
          )}
          {params.mode === PAGE_MODE.GOD_MODE && (
            <>
              <FrVrfButton
                content="Cancel"
                theme="secondary"
                size="large"
                onClicked={clickedBackReference}
                slot="left"
                authActId="interface_list_god.button.cancel"
              />
              <FrVrfButton
                content="Create SHP Csv"
                theme="primary"
                size="large"
                onClicked={onClickCreateSHPCsv}
                visible={
                  includeSHP() && params.type === PAGE_TYPE.ACTIVE_PJ_TYPE
                }
                authActId="interface_list_input.button.create_shp_csv"
              />
              <FrVrfButton
                content="Reload"
                theme="primary"
                size="large"
                disabled={!unSaved}
                onClicked={clickedReload}
                authActId="interface_list_god.button.god_reload"
              />
              <FrVrfButton
                content="Save"
                theme="primary"
                size="large"
                disabled={!unSaved}
                onClicked={clickedSave}
                authActId="interface_list_god.button.god_save"
              />
              <FrVrfButton
                content="Validate"
                theme="primary"
                size="large"
                onClicked={onClickValidate}
                disabled={unSaved || !params.pjtId}
                authActId="interface_list_input.button.input_validate"
              />
              <FrVrfButton
                content="Request STG Deployment"
                theme="secondary"
                size="large"
                disabled={unSaved || !params.pjtId}
                onClicked={onClickRequestStgDeployment}
                authActId="interface_list_god.button.request_stg_deployment"
              />
              <FrVrfButton
                content="Request PRD Deployment"
                theme="secondary"
                size="large"
                disabled={unSaved || !params.pjtId}
                onClicked={transitionHandle(PAGE_MODE.PRD_DPLYMNT_MODE)}
                authActId="interface_list_god.button.request_prd_deployment"
              />
            </>
          )}
          {params.mode === PAGE_MODE.REQ_APPROVAL_MODE && (
            <>
              <FrVrfButton
                content="Back"
                theme="secondary"
                size="large"
                onClicked={transitionHandle(PAGE_MODE.INPUT_MODE)}
                slot="left"
                authActId="interface_list_request_approval.button.cancel_request_review"
              />
              <FrVrfButton
                content="Withdraw Review Request"
                theme="primary"
                size="large"
                onClicked={clickedWithdrawReviewRequest}
                authActId="interface_list_request_approval.button.withdraw_review_request"
              />
              <FrVrfButton
                content="Request Review"
                theme="primary"
                size="large"
                onClicked={clickedRequestReview}
                authActId="interface_list_request_approval.button.request_review"
              />
            </>
          )}
          {params.mode === PAGE_MODE.REVIEW_MODE && (
            <>
              <FrVrfButton
                content="Reload"
                theme="secondary"
                size="large"
                disabled={!unSaved}
                onClicked={clickedReload}
                authActId="interface_list_review.button.review_reload"
              />
              <FrVrfButton
                content="Save"
                theme="secondary"
                size="large"
                disabled={!unSaved}
                onClicked={clickedSave}
                authActId="interface_list_review.button.review_save"
              />
              <FrVrfButton
                content="Validate"
                theme="primary"
                size="large"
                onClicked={onClickValidate}
                disabled={unSaved}
                authActId="interface_list_review.button.review_validate"
              />
              <FrVrfButton
                content="Complete Review"
                theme="primary"
                size="large"
                disabled={unSaved}
                onClicked={clickedCompleteReview}
                authActId="interface_list_review.button.complete_review"
              />
              <FrVrfButton
                content="Dismiss Approval"
                theme="primary"
                size="large"
                disabled={unSaved}
                onClicked={clickedDismiss}
                authActId="interface_list_review.button.dismiss_approval"
              />
            </>
          )}
          {params.mode === PAGE_MODE.STG_DPLYMNT_MODE &&
            !pageState.isPendingDisplay && (
              <>
                <FrVrfButton
                  content="Cancel Request STG Deployment"
                  theme="secondary"
                  size="large"
                  slot="left"
                  onClicked={() => navigate(-1)}
                  authActId="interface_list_stg_deployment_req.button.cancel_request_stg_deployment"
                />
                <FrVrfButton
                  content="Re-enter Attributes"
                  theme="primary"
                  size="large"
                  onClicked={clickedReEnterAttribute}
                  authActId="interface_list_stg_deployment_req.button.stg_re_enter_attributes"
                />
                <FrVrfButton
                  content="Confirm Deployment Target and Select Pending"
                  theme="primary"
                  size="large"
                  onClicked={clickedConfirmDeploymentTarget}
                  authActId="interface_list_stg_deployment_req.button.stg_confirm_deployment_target_and_select_pending"
                />
              </>
            )}
          {params.mode === PAGE_MODE.STG_DPLYMNT_MODE &&
            pageState.isPendingDisplay && (
              <>
                <FrVrfButton
                  content="Select Deployment Target"
                  theme="secondary"
                  size="large"
                  slot="left"
                  onClicked={reloadWindow}
                  authActId="interface_list_stg_deployment_req.button.stg_select_deployment_target"
                />
                <FrVrfButton
                  content="Confirm Interrupt Type and Request Deployment"
                  theme="primary"
                  size="large"
                  onClicked={openDeploymentDialog}
                  authActId="interface_list_stg_deployment_req.button.confirm_interrupt_type_and_requet_deployment"
                />
              </>
            )}
          {params.mode === PAGE_MODE.PRD_DPLYMNT_MODE &&
            !pageState.isPendingDisplay && (
              <>
                <FrVrfButton
                  content="Cancel Request PRD Deployment"
                  theme="secondary"
                  size="large"
                  slot="left"
                  onClicked={() => navigate(-1)}
                  authActId="interface_list_prd_deployment_req.button.cancel_request_prd_deployment"
                />
                <FrVrfButton
                  content="Re-enter Attributes"
                  theme="primary"
                  size="large"
                  onClicked={clickedReEnterAttribute}
                  authActId="interface_list_prd_deployment_req.button.prd_re_enter_attributes"
                />
                <FrVrfButton
                  content="Confirm Deployment Target and Select Pending"
                  theme="primary"
                  size="large"
                  onClicked={clickedConfirmDeploymentTarget}
                  authActId="interface_list_prd_deployment_req.button.prd_confirm_deployment_target_and_select_pending"
                />
              </>
            )}
          {params.mode === PAGE_MODE.PRD_DPLYMNT_MODE &&
            pageState.isPendingDisplay && (
              <>
                <FrVrfButton
                  content="Select Deployment Target"
                  theme="secondary"
                  size="large"
                  slot="left"
                  onClicked={reloadWindow}
                  authActId="interface_list_prd_deployment_req.button.prd_select_deployment_target"
                />
                <FrVrfButton
                  content="Request Deployment"
                  theme="primary"
                  size="large"
                  onClicked={openDeploymentDialog}
                  authActId="interface_list_prd_deployment_req.button.request_deployment"
                />
              </>
            )}
        </FrVrfFooter>
      )}
      {deploymentRequestInfomationInputDialogState.isShow && (
        <DeploymentRequestInfomationInputDialogContent />
      )}
    </>
  );
};

export const shouldShowInterruptType = (ifRow: Interface): boolean => {
  if (!!!ifRow.project) {
    return false;
  }

  const srcRequirement = ifRow.src.interfaceDefinition.interfaceRequirementType;
  const dstRequirement = ifRow.dst.interfaceDefinition.interfaceRequirementType;

  if (ifRow.project.ifReqCnclTypeCd === IfReqCnclType.CANCEL) {
    // Canceled IF
    return !(
      (srcRequirement === InterfaceRequirementType.CREATE &&
        dstRequirement === InterfaceRequirementType.CREATE) ||
      (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
        dstRequirement === InterfaceRequirementType.CREATE)
    );
  } else {
    // Normal IF
    return !(
      (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
        dstRequirement === InterfaceRequirementType.DELETE) ||
      (srcRequirement === InterfaceRequirementType.DELETE &&
        dstRequirement === InterfaceRequirementType.DELETE) ||
      (srcRequirement === InterfaceRequirementType.DELETE &&
        dstRequirement === InterfaceRequirementType.NO_CHANGE)
    );
  }
};

export const shouldSetInterruptType = (
  ifRow: Interface,
  srcDstType: SrcDstTypeCd,
  srcOnly: boolean,
): boolean => {
  if (!!!ifRow.project) {
    return false;
  }

  const srcRequirement = ifRow.src.interfaceDefinition.interfaceRequirementType;
  const dstRequirement = ifRow.dst.interfaceDefinition.interfaceRequirementType;

  if (ifRow.project.ifReqCnclTypeCd === IfReqCnclType.CANCEL) {
    // Canceled IF
    if (srcOnly) {
      // Source only deployment
      if (
        ifRow?.src?.interfaceDefinition?.metaOnlyFlag ===
        InDefCommonFlagType.YES
      ) {
        return false;
      }

      return !(
        (srcRequirement === InterfaceRequirementType.DELETE &&
          dstRequirement === InterfaceRequirementType.DELETE) ||
        (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
          dstRequirement === InterfaceRequirementType.DELETE) ||
        (srcRequirement === InterfaceRequirementType.DELETE &&
          dstRequirement === InterfaceRequirementType.NO_CHANGE) ||
        (srcRequirement === InterfaceRequirementType.CREATE &&
          dstRequirement === InterfaceRequirementType.UPDATE) ||
        (srcRequirement === InterfaceRequirementType.CREATE &&
          dstRequirement === InterfaceRequirementType.CREATE) ||
        (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
          dstRequirement === InterfaceRequirementType.UPDATE) ||
        (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
          dstRequirement === InterfaceRequirementType.CREATE) ||
        (srcRequirement === InterfaceRequirementType.CREATE &&
          dstRequirement === InterfaceRequirementType.NO_CHANGE)
      );
    } else {
      // Source/Desitination deployment or destination only deployment
      if (
        srcDstType === SrcDstTypeCd.INTERDOMAIN_SOURCE ||
        srcDstType === SrcDstTypeCd.DIP_INTERNAL_SOURCE
      ) {
        // Src.Outbound interruptType
        if (
          ifRow?.src?.interfaceDefinition?.metaOnlyFlag ===
          InDefCommonFlagType.YES
        ) {
          return false;
        }

        return !(
          (srcRequirement === InterfaceRequirementType.DELETE &&
            dstRequirement === InterfaceRequirementType.DELETE) ||
          (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
            dstRequirement === InterfaceRequirementType.DELETE) ||
          (srcRequirement === InterfaceRequirementType.DELETE &&
            dstRequirement === InterfaceRequirementType.NO_CHANGE) ||
          (srcRequirement === InterfaceRequirementType.CREATE &&
            dstRequirement === InterfaceRequirementType.UPDATE) ||
          (srcRequirement === InterfaceRequirementType.CREATE &&
            dstRequirement === InterfaceRequirementType.CREATE) ||
          (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
            dstRequirement === InterfaceRequirementType.UPDATE) ||
          (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
            dstRequirement === InterfaceRequirementType.CREATE) ||
          (srcRequirement === InterfaceRequirementType.CREATE &&
            dstRequirement === InterfaceRequirementType.NO_CHANGE)
        );
      } else {
        // Dst.Outbound interruptType
        if (
          ifRow?.dst?.interfaceDefinition?.metaOnlyFlag ===
          InDefCommonFlagType.YES
        ) {
          return false;
        }

        return !(
          (srcRequirement === InterfaceRequirementType.CREATE &&
            dstRequirement === InterfaceRequirementType.CREATE) ||
          (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
            dstRequirement === InterfaceRequirementType.CREATE) ||
          (srcRequirement === InterfaceRequirementType.UPDATE &&
            dstRequirement === InterfaceRequirementType.CREATE)
        );
      }
    }
  } else {
    // Normal IF
    if (srcOnly) {
      // Source only deployment
      if (
        ifRow?.src?.interfaceDefinition?.metaOnlyFlag ===
        InDefCommonFlagType.YES
      ) {
        return false;
      }

      return !(
        (srcRequirement === InterfaceRequirementType.DELETE &&
          dstRequirement === InterfaceRequirementType.DELETE) ||
        (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
          dstRequirement === InterfaceRequirementType.DELETE) ||
        (srcRequirement === InterfaceRequirementType.DELETE &&
          dstRequirement === InterfaceRequirementType.NO_CHANGE) ||
        (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
          dstRequirement === InterfaceRequirementType.CREATE) ||
        (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
          dstRequirement === InterfaceRequirementType.UPDATE)
      );
    } else {
      // Source/Desitination deployment or destination only deployment
      if (
        srcDstType === SrcDstTypeCd.INTERDOMAIN_SOURCE ||
        srcDstType === SrcDstTypeCd.DIP_INTERNAL_SOURCE
      ) {
        // Src.Outbound interruptType
        if (
          ifRow?.src?.interfaceDefinition?.metaOnlyFlag ===
          InDefCommonFlagType.YES
        ) {
          return false;
        }

        return !(
          (srcRequirement === InterfaceRequirementType.DELETE &&
            dstRequirement === InterfaceRequirementType.DELETE) ||
          (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
            dstRequirement === InterfaceRequirementType.DELETE) ||
          (srcRequirement === InterfaceRequirementType.DELETE &&
            dstRequirement === InterfaceRequirementType.NO_CHANGE) ||
          (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
            dstRequirement === InterfaceRequirementType.CREATE) ||
          (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
            dstRequirement === InterfaceRequirementType.UPDATE)
        );
      } else {
        // Dst.Outbound interruptType
        if (
          ifRow?.dst?.interfaceDefinition?.metaOnlyFlag ===
          InDefCommonFlagType.YES
        ) {
          return false;
        }

        return !(
          (srcRequirement === InterfaceRequirementType.DELETE &&
            dstRequirement === InterfaceRequirementType.DELETE) ||
          (srcRequirement === InterfaceRequirementType.NO_CHANGE &&
            dstRequirement === InterfaceRequirementType.DELETE) ||
          (srcRequirement === InterfaceRequirementType.DELETE &&
            dstRequirement === InterfaceRequirementType.NO_CHANGE)
        );
      }
    }
  }
};
